import moment from "moment";
import { Fragment, useEffect, useMemo, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  approversCardDocumentListName,
  approversDependenciesListName,
  approversListName,
  emailsSender,
  equipmentsListName,
  historyByDocumentListName,
  historyChangeFieldsDocumentListName,
  MDWorkstationListName,
  MT5WhyCommentsFiles,
  MTIncCommentsFiles,
  myDocumentsListName,
  myWorksDocumentsListName,
  paramsListName,
  ReplacedListName,
  siteUrl,
  s3cloudUrl,
  versionsByDocumentListName,
  equipmentsByDocumentListName,
} from "src/api/config";
import { DownloadIcon } from "src/components/ui-icons/upload";
import { DocumentIcon } from "@heroicons/react/24/outline";
import { emailQueueListName } from "src/api/config/email.config";
import {
  myTask5WayCommentsFilesListName,
  myTasks5WayCommentsListName,
} from "src/api/config/myTasks5Way.config";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { myTasksAuditFilesListName } from "src/api/config/myTasksAudit.config";
import {
  notificationIdsListName,
  notificationsCardListName,
} from "src/api/config/notifications.config";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import Comments from "src/modules/comments";
import {
  updateItem
} from "src/modules/spItems/actions";
import {
  addItemRequest,
  deleteItemRequest,
  getItemsRequest,
  updateItemRequest,
} from "src/modules/spItems/api";
import {
  selectItem,
  selectItems
} from "src/modules/spItems/selectors";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import AddActionInComponent from "src/pages/DashboardPage/mytasks/addAction/inComponent";
import SDCA from "src/pages/DashboardPage/throughcomponents/card5Way/components/sdca";
import Tree from "src/pages/DashboardPage/throughcomponents/card5Way/components/tree";
import { emailAPI } from "src/utils/api.utils";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { TooltipItem } from "src/utils/Tooltip";
import { twMerge } from "tailwind-merge";
import { fieldType } from "../types/form";
import Button from "./Button";
import Loading from "./Loading";
import { ArrowDown } from "./ui-icons/card";
import { Medal } from "./ui-icons/myTasks/medal";
import Autocomplete from "./ui/form/autocomplete";
import Checkbox from "./ui/form/checkbox";
import { dataFormForSharepoint, getObjectDiff } from "./ui/form/constants";
import DateField from "./ui/form/date";
import DateRangeField from "./ui/form/dateRange";
import Editors from "./ui/form/editors";
import Input from "./ui/form/input";
import PeoplePicker from "./ui/form/peoplePicker";
import Radio from "./ui/form/radio";
import Repeater from "./ui/form/repeater";
import Select from "./ui/form/select";
import Text from "./ui/form/text";
import TextArea from "./ui/form/textArea";
import UploadFiles from "./ui/form/uploadFiles";
import UploadFilesMobile from "./ui/form/uploadFiles/uploadFiles.mobile";
import InfoIconSdca from "src/pages/DashboardPage/throughcomponents/card5Way/components/infoIconSdca";
import CheckboxSearch from "./ui/form/checkbox_search/checkbox_search";
import NumberInput from "./ui/form/number";
import TimeField from "./ui/form/time";
import {
  myTaskIncCommentsFilesListName,
  myTaskIncCommentsListName,
} from "src/api/config/myTasksInc.config";
import TimeRange from "./ui/form/timeRange";
import NumberRange from "./ui/form/numberRange";
import Grade from "./ui/form/grade";
import {
  actionsStatus,
  docApprovers,
  docStatuses,
  FiveWhyType,
  incStatus,
  notificationStatuses,
} from "src/api/config/systemSwitch";
import { getWorkDocumentsInfo } from "src/modules/acadia/documents/actions";
import _ from "lodash";
import { addUsers } from "src/modules/users/actions";
const { sendEmail } = emailAPI();

//! Очистка маркдауна для раздела 5с аудиты
const stripMarkdown = (text: any): string =>
  String(text || "")
    .replace(/^#{1,6}\s*/gm, "")
    .replace(/(\*\*|__)(.*?)\1/g, "$2")
    .replace(/(\*|_)(.*?)\1/g, "$2")
    .replace(/`{1,3}([^`]*)`{1,3}/g, "$1")
    .replace(/~~(.*?)~~/g, "$1")
    .replace(/\[([^\]]*)\]\([^)]*\)/g, "$1")
    .replace(/^\s*[-*+]\s+/gm, "")
    .trim();

type Props = {
  fieldsForm: fieldType[]; // Набор полей для рендера в форме
  setFormData: (obj: any) => void; // Для возврата результата в род. компонент
  openCancelAddCard?: boolean; // Флаг - открывает окошко закрывающие форму, можно использовать для разных модалок
  setOpenCancelAddCard?: (b: boolean) => void; // Меняет флаг см. выше
  textButtonSubmit?: string; // Текст на кнопке отправки формы
  type: string; // Тип модуля/компонента для которого нужна форма
  setDependenceFields?: (obj: any) => void; // Изменение взаимосвязанных полей (Мои документы)
  setDependenceFields5Way?: (obj: any) => void; // Изменение взаимосвязанных полей 5 Почему (Мои задачи)
  code?: string; // Код документа (Мои документы)
  defaultValues?: any; // Значение формы по умолчанию
  setIdRemoveElem?: any; // Для запоминания удалённого элемента|файла
  setApproversCardDocumentData?: any; // Для вызова модалки с отправкой документа (Мои документы)
  versionView?: any; // Версия документа (Мои документы)
  setBackStep?: (b: boolean) => void; // изменить флаг см. ниже
  backStep?: boolean; // Флаг- Вернуться на шаг назад  (Мои документы - Создание)
  setHideCloseIcon?: (b: boolean) => void; // Заблокировать возможность закрыть окно с формой, после изменения
  showEditApprovers?: any; // Для вызова модалки с изменением согласующих (Мои документы)
  setShowEditApprovers?: any; // Флаг - см. выше
  sendApproveBlock?: any; // Флаг - см. ниже
  setSendApproveBlock?: any; // Вызов модалки, которая блокирует создания новых версий (Мои документы)
  setIsSelectResponsible?: any; // Проверка изменения ответственного в добавлении действия (Мои задачи)
  setIsSelectMitings?: any; // Проверка изменения совещания в добавлении действия (Мои задачи)
  copyAction?: any; //Флаг - см. ниже
  setCopyAction?: any; // Вызов модалки, которая отвечает за копирование действия (Мои задачи)
  setRemoveDocument?: any; //Вызов модалки, котораяотвечает за удаление дока
  removeDocument?: any; //Флаг - см. выше
  listUploadFiles?: any; //Папка куда загружать различные файлы
  openRemoveFileCommentModal?: any; //Флаг - см. ниже
  setOpenRemoveFileCommentModal?: any; // Функция, которая вызывает модалку для удаления файла у комментария (Мои задачи - Карточка действия)
  setObservedType?: any; //Функция отслеживающая тип сотрудника в поведенческом аудите Мои задачи
  auditID?: number; //ID поведенческого аудита - Мои Задачи
  incidentID?: number; //ID инциндента - Мои Задачи
  ID5WayAdd?: number; //ID 5 почему - Мои Задачи
  customTypes?: any; // Кастомные типы для репитора действий в Моих задачах
  kpi?: any; // Значение KPI передаётся в зависимости от выбранного триггера в 5почему (Мои задачи)
  setDetailProblem?: any; // Изменение описание детальной проблемы в 5почему
  card5WayTree?: any; //Объект дерева 5Почему для режима редактирования (Мои задачи)
  setCard5WayTree?: any; //Функция для изменения дерева почему на лету
  openTree?: boolean; //Флаг для отслеживание открытия модалки с деревом 5Почему
  setOpenTree?: any; // Функция для флага
  zIndex?: any; //Число для корректного открытия модалок внутри формы, в частности модалки с деревом 5Почему
  removeEditorHandle?: any; //Функция для перехода в режим просмотра для карточки 5Почему (Мои задачи)
  type5way?: string; //Тип 5Почему или Отчет об отклонении (Мои задачи)
  meetingAction?: any; //Совещание для открытой карточки действия
  setCurrentTypeInc?: any; //Текущий тип несоответствия/инцидента (Мои задачи)
  setCurrentFormData?: any; // Отслеживание данных формы в процессе взаимодействия с полями
  incLoading?: any; //Ререндер формы действий после обновления данных в форме инцидентов
  setInvCompletedModal?: any; //Откроет модалку по завершению расследования, для инцидентов
  incCard?: any; //Карточка инцидента/несоответствия
  linkCardWithAction?: any;
  cardWithActionType?: any;
  inconsistencesText?: any;
  section5S?: any; //5S Аудит: шаг (раздел вопроса)
  questionTitle5S?: any; //5S Аудит: вопрос/требование
  files5S?: any; //5S Аудит: вложения несоответствия
  setCurrentUserRole?: any; //Изменение текущей роли пользователя для документа
  currentUserRole?: any; // Текущая роль пользователя для документа
  documentCardID?: any; // ID карточки документа
  setUpdateCardData?: any // Обновление всей информации о данных карточки, при условии выбора новых согласующих - МД
  updateCardData?: any //Новые данные карточки - МД
  setCard?: any //Изменение информации о текущей карточке докумета - МД
  card?: any //Карточка документа - МД
  setImagesDoc?: any //Изменение массива с изображениямии документа
  setCheckLoadUsers?: any // ререндер дефолтных значений карточки документа - флаг по пользователеям - МД
  actionsEml?: any //Действия привязанные к карточке инцидента - МЗ
  isMobileActionCard?: boolean; // Вертикальные full-width кнопки в мобильной карточке действия
  isMobile5WayCard?: boolean; // Мобильный режим карточки 5Почему
  isMobileDocumentCard?: boolean; // Мобильный режим карточки документа
  isMobilePovAuditCard?: boolean; // Мобильный режим карточки Поведенческий аудит
  isMobileIncCard?: boolean; // Мобильный режим карточки Инциденты
  isMobileModeAddInComponent?: boolean; // Переключает в мобильный режим карточки действия
  show5wayFieldsFromTabs?: boolean;
  extraButtonText?: string; // Текст оценки 5Почему
  extraButtonAction?: () => void; // Оценка 5Почему
  removeObjData?: any //Объект с удаленными элементами
  setEditCardFiveWhy?: any //Флаг когда редактируют форму 5П и ОоО
  setInArchiveCardTrigger?: any //Метка для перемещения триггера в архив
  activeTrigger?: any //Находится ли выбранная карточка триггера в архиве или нет
  trigger?: any // Триггер, который редактируется на странице триггеров в МЗ (настройки)
  setProblemInTree?: any // Изменение описания проблемы из дерева 5П в МЗ
  problemInTree?: any // Описание проблемы из дерева в карточке 5П в МЗ
  setProblevRepeatCounShow?: any //Показывать или нет поле с количеством повторений в 5П МЗ
};

function Form(props: Props) {
  const {
    fieldsForm,
    setFormData,
    openCancelAddCard,
    setOpenCancelAddCard,
    textButtonSubmit,
    type,
    setDependenceFields,
    code,
    defaultValues,
    setIdRemoveElem,
    setApproversCardDocumentData,
    versionView,
    backStep,
    setBackStep,
    setHideCloseIcon,
    setShowEditApprovers,
    setImagesDoc,
    sendApproveBlock,
    setSendApproveBlock,
    setIsSelectMitings,
    setIsSelectResponsible,
    copyAction,
    setCopyAction,
    removeDocument,
    setRemoveDocument,
    listUploadFiles,
    setOpenRemoveFileCommentModal,
    openRemoveFileCommentModal,
    setObservedType,
    auditID,
    incidentID,
    setDependenceFields5Way,
    kpi,
    ID5WayAdd,
    setDetailProblem,
    card5WayTree,
    openTree,
    setOpenTree,
    zIndex,
    setCard5WayTree,
    removeEditorHandle,
    type5way,
    meetingAction,
    setCurrentTypeInc,
    setCurrentFormData,
    incLoading,
    setInvCompletedModal,
    incCard,
    linkCardWithAction,
    cardWithActionType,
    inconsistencesText,
    section5S,
    questionTitle5S,
    files5S,
    setCurrentUserRole,
    currentUserRole,
    documentCardID,
    setUpdateCardData,
    updateCardData,
    setCard,
    card,
    setCheckLoadUsers,
    actionsEml,
    isMobileActionCard = false,
    isMobile5WayCard = false,
    isMobileDocumentCard = false,
    isMobilePovAuditCard = false,
    isMobileIncCard = false,
    extraButtonText,
    extraButtonAction,
    isMobileModeAddInComponent = false,
    removeObjData,
    setEditCardFiveWhy,
    setInArchiveCardTrigger,
    activeTrigger,
    trigger,
    setProblemInTree,
    problemInTree,
    setProblevRepeatCounShow,
  } = props;

  const dispatch = useAppDispatch();
  const currentUser: any = useAppSelector(selectCurrentUser);
  const users: any = useAppSelector(selectUsers);
  const [customLoading, setCustomLoading] = useState(false);
  const [textButtonCancel, setTextButtonCancel] = useState("Назад");
  const [editDataForm, setEditDataForm] = useState(false);
  const [resetDefaultValue, setResetDefaultValue] = useState<any>(0);
  const params: any = useAppSelector((state) => selectItems(state, paramsListName));
  const [disabledDoubleSend, setDisabledDoubleSend] = useState(false);
  const [query, setQuery] = useSearchParams();

  /*МЗ - Карточка действий - START */
  const actionCard: any = useAppSelector((state) => selectItem(state, myTaskActionsListName));
  /*МЗ - Карточка действий - END */

  /*Информация для согласования карточки документа МД - START */
  const [approversByDocument, setApproversByDocument] = useState<any>([]);
  const [approversDependencies, setApproversDependencies] = useState<any>([]);
  const [approversList, setApproversList] = useState<any>([]);
  const [changesButtonsFlag, setChangesButtonsFlag] = useState(false);
  const [approveButtonsFlag, setApproveButtonsFlag] = useState(false);
  const [revisionButtonsFlag, setRevisionButtonsFlag] = useState(false);
  const [queueCurrentCardApproversGroup, setQueueCurrentCardApproversGroup] =
    useState<any>(null);
  const [nextApproversGroup, setNextApproversGroup] = useState<any>(null);
  const [reRenderCard, setReRenderCard] = useState(false);
  /*Информация для согласования карточки документа МД - END */

  /* Версии карточки документа - МД - START */
  const [versionsDocument, setVersionsDocument] = useState<any>([]);
  const [createVersion, setCreateVersions] = useState(true);
  const [activeVersion, setActivVersion] = useState(0);
  /* Версии карточки документа - МД - END */

  /*Уведомления карточки документа - МД - START */
  const [notifications, setNotifications] = useState<any>([]);
  const [emails, setEmails] = useState<any>([]);
  /*Уведомления карточки документа - МД - END */

  /* История карточки документа - МД - START */
  const [historyCard, setHistoryCard] = useState<any>([]);
  /* История карточки документа - МД - END */

  const navigate = useNavigate();
  const [closedDateInc, setClosedDateInc] = useState(new Date());
  const [updateRepeaterField, setUpdateRepeaterField] = useState(false);

  const openCardWithAction = () =>
  isMobileActionCard && linkCardWithAction.startsWith("/")
    ? navigate(linkCardWithAction)
    : window.open(linkCardWithAction, "_blank");

  // флаг, что текущий юзер отдал голос в множественном согласовании
  const [multipleApproveCurrent, setMultipleApproveCurrent] = useState<boolean>(false);
  useEffect(() => {
    if (currentUser && currentUser.email && card && approversByDocument && approversByDocument.length > 0) {
      const queueItem = approversByDocument.find((item: any) => item.Queue === true);
      if (queueItem && queueItem.MultiApproved) {
        const hasMatchingEmail = queueItem.MultiApproved.some((approver: any) =>
          approver.get_email() === currentUser.email.toLowerCase()
        );
        if (hasMatchingEmail) {
          setMultipleApproveCurrent(true);
        }
      }
    }
  }, [approversByDocument, card, currentUser]);

  const {
    control,
    handleSubmit,
    register,
    reset,
    setValue,
    getValues,
    watch,
    unregister,
    formState: { errors, dirtyFields },
  } = useForm<any>({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues]),
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const onSubmit = (data: any, e: any) => {
    if (type === "action_card" || type === "add_comment") {
      if (data.ID) {
        const changesFieldValue = getObjectDiff(data, defaultValues);
        if (
          changesFieldValue.CommentFiles &&
          changesFieldValue.CommentFiles.new &&
          changesFieldValue.CommentFiles.new.length > 0
        ) {
          changesFieldValue.CommentFiles.new =
            changesFieldValue.CommentFiles.new.filter(
              (file: any) => file.id || file.ID,
            );
        }
        localStorage.setItem(
          `${type}_data_form`,
          JSON.stringify(changesFieldValue),
        );
      }
    }
    if ((type === "add_my_tasks_inc" || type === "inc_card_my_tasks") && e.nativeEvent.submitter.dataset.addinc === "true") {
      localStorage.setItem("OpenAdd5WayCardForm", "true");
    }
    if (!disabledDoubleSend) {
      setFormData(data);
      setDisabledDoubleSend(true);
    }
    if (type === "approvers_edit") {
      setShowEditApprovers && setShowEditApprovers(false);
      if (updateCardData) {
        updateCardData["new_approvers"] = data;
        setApproversCardDocumentData(updateCardData);
      }
    }
    if (type === "card") {
      let approve = e.nativeEvent.submitter.dataset.approve === "true"; //Согласовать
      let reject = e.nativeEvent.submitter.dataset.reject === "true"; // Отменить
      let modification =
        e.nativeEvent.submitter.dataset.modification === "true"; // На доработку
      let agreement = e.nativeEvent.submitter.dataset.agreement === "true"; // Отправить на согласование
      let revision = e.nativeEvent.submitter.dataset.revision === "true"; // На пересмотр
      let draft = e.nativeEvent.submitter.dataset.draft === "true"; // Черновик
      let archive = e.nativeEvent.submitter.dataset.archive === "true"; // Архив
      localStorage.setItem("agreementDoc", JSON.stringify(agreement));
      localStorage.setItem("draftDoc", JSON.stringify(draft));
      localStorage.setItem("archiveDoc", JSON.stringify(archive));
      const changesFieldValue = getObjectDiff(data, defaultValues);
      const updateData: any = dataFormForSharepoint(changesFieldValue);
      if (!draft) {
        updateData["ID"] = card.ID;
      }
      const approversCardDocumentData: any = {};
      approversCardDocumentData["setLoading"] = () => setCustomLoading(!customLoading);
      approversCardDocumentData["reRender"] = () => setReRenderCard(!reRenderCard);
      approversCardDocumentData["card"] = { ...card };
      approversCardDocumentData["approversList"] = [...approversList];
      approversCardDocumentData["approversDependencies"] = [...approversDependencies];
      approversCardDocumentData["approversByDocument"] = [...approversByDocument];
      approversCardDocumentData["notificationData"] = [];
      approversCardDocumentData['changesFieldValue'] = changesFieldValue;
      const currentHistoryCardUpdate = queueCurrentCardApproversGroup && historyCard.find(
        (item: any) =>
          item.ApprovalGroup &&
          item.ApprovalGroup.get_lookupId() === queueCurrentCardApproversGroup.group &&
          item.Statuses.some(
            (status: any) => status.get_lookupId() === docStatuses.waitApproval,
          ),
      ); //Ожидает согласования
      //Получаем из истории всех кто сейчас ожидает согласования
      const historyCardWaiting = historyCard.filter((item: any) =>
        item.Statuses.some(
          (status: any) => status.get_lookupId() === docStatuses.waitApproval,
        ),
      );
      //Фильтруем все уведомления, которые нужно удалить
      approversCardDocumentData["notificationsRemove"] = [];
      approversCardDocumentData["notificationsRemove"] = notifications
        .filter(
          (item: any) =>
            item.NotificationType.get_lookupId() === notificationStatuses.approval ||
            item.NotificationType.get_lookupId() === notificationStatuses.cancel ||
            item.NotificationType.get_lookupId() === notificationStatuses.revision,
        )
        .map((item: any) => {
          return { ID: item.ID };
        });
      approversCardDocumentData["emailsRemove"] = [];
      approversCardDocumentData["emailsRemove"] = emails.map((item: any) => {
        return { ID: item.ID };
      });
      if (archive) {
        approversCardDocumentData["type"] = "archive";
        updateData["PublicationDate"] = moment(new Date()).add(7, "d").toDate();
        updateData["Status"] = docStatuses.approval; // На согласовании
        updateData["AuthorEmail"] = currentUser.email.toLowerCase();
        approversCardDocumentData["updateCard"] = updateData;
        setUpdateCardData && setUpdateCardData(approversCardDocumentData);
      }
      if (draft) {
        approversCardDocumentData["type"] = "draft";
        approversCardDocumentData["removeItemsApproversCardDocument"] =
          approversByDocument.length > 0 &&
          approversByDocument.map((item: { ID: number }) => {
            return { ID: item.ID };
          });
        approversCardDocumentData["historyFieldsCardAdd"] = {
          Title: `History fields card # ${card.ID}`,
          DocumentID: card.ID,
          Approvers: [currentUser.email],
          Comment: "",
          JSONChangesFields: JSON.stringify(changesFieldValue),
          Statuses: [docStatuses.edited, docStatuses.sendApproval], // Изменен, Отправлен на согласование
        };
        const sendData: any = {
          Code: card.Code,
          Collection: card.Collection.get_lookupId(),
          Department: card.Department.get_lookupId(),
          Sector: card.Sector.get_lookupId(),
          Process: card.Process.get_lookupId(),
          DocType: card.DocType.get_lookupId(),
          ResponsibleForRevision: card.ResponsibleForRevisionEmail,
          ResponsibleForRevisionEmail: card.ResponsibleForRevisionEmail,
          PublicationDate: moment(new Date())
            .add(
              Number(
                params
                  .find((param: any) => param.Key === "documentsApproveDays")
                ["Value"].trim(),
              ),
              "days",
            )
            .toDate(),
          Critical: card.Critical,
          File: defaultValues["File"],
          Path: card.Path,
          Title: card.Title,
          DateForRevision: card.DateForRevision,
          Status: docStatuses.approval, // Список Statuses - На согласовании
          MainDocument: card.ID,
          Index: card.Index,
          AuthorEmail: currentUser.email.toLowerCase(),
          Ver: Number(card.Ver) + 1,
          WorkPlaces: Array.isArray(card.WorkPlaces) && card.WorkPlaces.length > 0 && card.WorkPlaces.map((item: any) => {
            return item.get_lookupId()
          }) || []
        };
        const draftData = { ...sendData, ...updateData };
        approversCardDocumentData['draftData'] = draftData;
        setUpdateCardData && setUpdateCardData(approversCardDocumentData);
      }

      if (approve) {
        console.log("approversCardDocumentData: ", approversCardDocumentData);
        let allApproved: boolean = false;
        let multiApprove: boolean = false;
        let currentQueueGroup: any = null;

        if (approversCardDocumentData.approversByDocument && approversCardDocumentData.approversByDocument.length > 0) {
          currentQueueGroup = approversCardDocumentData.approversByDocument.find((item: any) => item.Queue === true);
          if (currentQueueGroup && currentQueueGroup.MultiApprove) {
            multiApprove = true;
          }
        }

        if (multiApprove) {
          // Множественное согласование документа
          console.log(" --- Множественное согласование документа, currentQueueGroup: ", currentQueueGroup);

          if (!currentQueueGroup) {
            console.error("Не найдена активная группа согласования");
            return;
          }

          // Получаем текущий список согласовавших
          let currentMultiApproved: string[] = [];
          if (currentQueueGroup.MultiApproved && currentQueueGroup.MultiApproved.length > 0) {
            currentQueueGroup.MultiApproved.forEach((maItem: any) => {
              if (maItem && maItem.get_email()) {
                currentMultiApproved = [
                  ...currentMultiApproved,
                  maItem.get_email(),
                ];
              }
            })
          }

          // Добавляем текущего пользователя, если его еще нет
          if (!currentMultiApproved.includes(currentUser.email.toLowerCase())) {
            currentMultiApproved = [...currentMultiApproved, currentUser.email.toLowerCase()];
          }
          console.log(" --- cuurent multi approved: ", currentMultiApproved);
          // Получаем всех согласующих из текущей группы
          const currentGroupApprovers = queueCurrentCardApproversGroup.approvers.map(
            (a: any) => a.get_email().toLowerCase()
          );

          // Проверяем, все ли согласовали
          const allApprovedInGroup = currentGroupApprovers.length > 0 &&
            currentGroupApprovers.length === currentMultiApproved.length &&
            currentGroupApprovers.every((email: string) => currentMultiApproved.includes(email));

          if (allApprovedInGroup) {
            // Все согласовали - переходим к следующей группе или завершаем
            console.log(" --- Все согласовали, переходим к следующей группе или завершаем ");

            // Устанавливаем тип approve (как в single approve)
            approversCardDocumentData["type"] = "approve";

            // Отмечаем текущую группу как согласованную (preventGroup)
            approversCardDocumentData["preventGroup"] = {
              Approved: currentUser.email,
              Queue: false,
              VersionDocument: (versionView && true) || false,
              ID: currentQueueGroup.ID,
              Statuses: [docStatuses.agreed],
              MultiApproved: [...currentMultiApproved]
            };

            if (nextApproversGroup) {
              // Есть следующая группа - активируем её (как в single approve)
              console.log(" --- Активируем следующую группу ");

              approversCardDocumentData["nextGroup"] = {
                ID: nextApproversGroup.updateID,
                Queue: true,
                VersionDocument: (versionView && true) || false,
              };

              // Добавляем запись в историю
              if (currentHistoryCardUpdate && Object.keys(currentHistoryCardUpdate).length > 0) {
                approversCardDocumentData["historyCardUpdate"] = {
                  Approved: currentUser.email.toLowerCase(),
                  ID: currentHistoryCardUpdate.ID,
                  Statuses: [docStatuses.agreed],
                  VersionDocument: (versionView && true) || false,
                  Title: queueCurrentCardApproversGroup.dateReplaced || `History card # ${card.ID}`,
                  ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
                  Created: new Date(),
                  //MultiApproved: [...currentMultiApproved]
                };
              }

              // Обновляем историю полей
              approversCardDocumentData["historyFieldsCardAdd"] = {
                Title: queueCurrentCardApproversGroup.dateReplaced || `History fields card # ${card.ID}`,
                DocumentID: card.ID,
                Statuses: [docStatuses.agreed],
                JSONChangesFields: JSON.stringify(changesFieldValue),
                Approvers: (queueCurrentCardApproversGroup.approvers && queueCurrentCardApproversGroup.approvers.length > 0 &&
                  queueCurrentCardApproversGroup.approvers.map((user: any) => user.get_email())) || [],
                VersionDocument: (versionView && true) || false,
                ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
              };

              // Отправляем уведомления следующей группе
              if (nextApproversGroup.approvers.length > 0) {
                nextApproversGroup.approvers.forEach((approver: any) => {
                  if (approver.get_email()) {
                    approversCardDocumentData["notificationData"] = [
                      ...approversCardDocumentData["notificationData"],
                      {
                        Title: (versionView && `Согласовать версию # ${card.MainDocument.get_lookupId()}`) ||
                          `Согласовать # ${card.ID}`,
                        ReviewDate: moment(new Date())
                          .add(
                            Number(
                              params
                                .find((param: any) => param.Key === "documentsApproveDays")
                              ["Value"].trim(),
                            ),
                            "days",
                          )
                          .toDate(),
                        AuthorComment: "",
                        DocumentCode: `${card.Code}.${card.Index}`,
                        Document: (versionView && card.MainDocument.get_lookupId()) || card.ID,
                        NotificationType: notificationStatuses.approval,
                        Employee: approver.get_email().toLowerCase(),
                        EmployeeEmail: approver.get_email().toLowerCase(),
                        VersionDocument: versionView,
                        AuthorEmail: currentUser.email.toLowerCase(),
                        Completed: new Date(),
                      },
                    ];
                  }
                });
              }

              // Обновляем PublicationDate (как в single approve)
              updateData["PublicationDate"] = moment(new Date())
                .add(
                  Number(
                    params
                      .find((param: any) => param.Key === "documentsApproveDays")
                    ["Value"].trim(),
                  ),
                  "days",
                )
                .toDate();
              approversCardDocumentData["updateCard"] = updateData;

            } else {
              // Нет следующей группы - документ полностью согласован (как в single approve)
              console.log(" --- Документ полностью согласован, публикуем ");

              // Уведомление автору
              if (card.AuthorEmail) {
                approversCardDocumentData["notificationData"] = [
                  {
                    Title: (versionView && `Согласована версия # ${card.ID}`) ||
                      `Согласован документ # ${card.ID}`,
                    ReviewDate: moment(new Date())
                      .add(
                        Number(
                          params
                            .find((param: any) => param.Key === "documentsApproveDays")
                          ["Value"].trim(),
                        ),
                        "days",
                      )
                      .toDate(),
                    AuthorComment: "",
                    DocumentCode: `${card.Code}.${card.Index}`,
                    Document: (versionView && card.MainDocument.get_lookupId()) || card.ID,
                    NotificationType: notificationStatuses.approved,
                    Employee: card.AuthorEmail.toLowerCase(),
                    EmployeeEmail: card.AuthorEmail.toLowerCase(),
                    VersionDocument: versionView,
                    AuthorEmail: currentUser.email.toLowerCase(),
                    Completed: new Date(),
                  },
                ];

                if (emailsSender) {
                  approversCardDocumentData["emailBody"] = {
                    Body: `Здравствуйте ${users[card.AuthorEmail.toLowerCase()] &&
                      users[card.AuthorEmail.toLowerCase()]["displayName"]
                      },<br/><br/>Уведомляем Вас, что следующий документ был согласован и опубликован:<br/><br/>${`<a href="${siteUrl}/dashboard/1?documentCard=${(versionView && card.MainDocument.get_lookupId()) || card.ID}">${card.Title}</a>`}`,
                    DateToBeSentAt: moment().subtract(12, "hours").toDate(),
                    Title: "Мои Документы | Документ согласован",
                    Subject: "Мои Документы | Документ согласован",
                    Recepients: card.AuthorEmail.toLowerCase(),
                    CheckDoc: String(card.ID),
                  };
                }
              }

              // Обновляем историю полей для финального согласования
              approversCardDocumentData["historyFieldsCardAdd"] = {
                Title: queueCurrentCardApproversGroup.dateReplaced ||
                  `History fields card # ${card.ID}`,
                DocumentID: card.ID,
                JSONChangesFields: JSON.stringify(changesFieldValue),
                Statuses: [docStatuses.approved, docStatuses.public],
                Approvers: (queueCurrentCardApproversGroup.approvers &&
                  queueCurrentCardApproversGroup.approvers.length > 0 &&
                  queueCurrentCardApproversGroup.approvers.map(
                    (user: any) => user.get_email(),
                  )) || [],
                VersionDocument: (versionView && true) || false,
                ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
              };

              // Обновляем статус документа
              updateData["Status"] = docStatuses.public;
              updateData["PublicationDate"] = new Date();
              approversCardDocumentData["updateCard"] = updateData;

              // Удаляем все карточки согласования
              approversCardDocumentData["removeItemsApproversCardDocument"] =
                (approversByDocument.length > 0 &&
                  approversByDocument.map((item: { ID: number }) => {
                    return { ID: item.ID };
                  })) || [];

              // Обновляем историю
              if (currentHistoryCardUpdate && Object.keys(currentHistoryCardUpdate).length > 0) {
                approversCardDocumentData["historyCardUpdate"] = {
                  Title: queueCurrentCardApproversGroup.dateReplaced ||
                    `History card # ${defaultValues.ID}`,
                  Approved: currentUser.email.toLowerCase(),
                  ID: currentHistoryCardUpdate.ID,
                  VersionDocument: (versionView && true) || false,
                  Statuses: [docStatuses.approved, docStatuses.public],
                  Approvers: (queueCurrentCardApproversGroup.approvers &&
                    queueCurrentCardApproversGroup.approvers.length > 0 &&
                    queueCurrentCardApproversGroup.approvers.map(
                      (user: any) => user.get_email(),
                    )) || [],
                  ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
                  Created: new Date(),
                  //MultiApproved: [...currentMultiApproved]
                };
              }

              // Обрабатываем рабочие места
              let workPlacesIds: any = [];
              if (approversCardDocumentData["updateCard"]["WorkPlaces"] &&
                Array.isArray(approversCardDocumentData["updateCard"]["WorkPlaces"]) &&
                approversCardDocumentData["updateCard"]["WorkPlaces"].length > 0) {
                workPlacesIds = [...approversCardDocumentData["updateCard"]["WorkPlaces"]];
              }
              approversCardDocumentData['workPlacesIds'] = [...workPlacesIds];
            }

            // Отправляем данные (один раз)
            setApproversCardDocumentData(approversCardDocumentData);

          } else {
            // Не все согласовали - просто обновляем список MultiApproved
            console.log(" --- Не все согласовали, обновляем список MultiApproved ");

            approversCardDocumentData["type"] = "updateMultiApproved";

            // Обновляем только поле MultiApproved в текущей группе
            approversCardDocumentData["updateCurrentGroupMultiApproved"] = {
              ID: currentQueueGroup.ID,
              MultiApproved: [...currentMultiApproved]
            };

            setApproversCardDocumentData(approversCardDocumentData);
          }

        } else {
          // single approve document (БЕЗ ИЗМЕНЕНИЙ)
          approversCardDocumentData["type"] = "approve";
          approversCardDocumentData["preventGroup"] = {
            Approved: currentUser.email,
            Queue: false,
            VersionDocument: (versionView && true) || false,
            ID: queueCurrentCardApproversGroup.updateID,
            Statuses: [docStatuses.agreed],
          };

          if (nextApproversGroup) {
            approversCardDocumentData["nextGroup"] = {
              ID: nextApproversGroup.updateID,
              Queue: true,
              VersionDocument: (versionView && true) || false,
            };

            if (nextApproversGroup.approvers.length > 0) {
              nextApproversGroup.approvers.forEach((approver: any) => {
                if (approver.get_email()) {
                  approversCardDocumentData["notificationData"] = [
                    ...approversCardDocumentData["notificationData"],
                    {
                      Title: (versionView && `Согласовать версию # ${card.MainDocument.get_lookupId()}`) ||
                        `Согласовать # ${card.ID}`,
                      ReviewDate: moment(new Date())
                        .add(
                          Number(
                            params
                              .find((param: any) => param.Key === "documentsApproveDays")
                            ["Value"].trim(),
                          ),
                          "days",
                        )
                        .toDate(),
                      AuthorComment: "",
                      DocumentCode: `${card.Code}.${card.Index}`,
                      Document: (versionView && card.MainDocument.get_lookupId()) || card.ID,
                      NotificationType: notificationStatuses.approval,
                      Employee: approver.get_email().toLowerCase(),
                      EmployeeEmail: approver.get_email().toLowerCase(),
                      VersionDocument: versionView,
                      AuthorEmail: currentUser.email.toLowerCase(),
                      Completed: new Date(),
                    },
                  ];
                }
              });

              if (emailsSender) {
                const minutes = Number(
                  params
                    .find((param: any) => param.Key === "documentApprove")
                  ["Value"].trim(),
                );
                const dateSendEmailsArr = [
                  moment(new Date()).clone().subtract(12, "hours").toDate(),
                  moment(new Date()).clone().add(minutes, "m").toDate(),
                ];
                approversCardDocumentData["emailsBody"] = [];
                dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                  nextApproversGroup.approvers.forEach((approver: any) => {
                    approversCardDocumentData["emailsBody"] = [
                      ...approversCardDocumentData["emailsBody"],
                      {
                        Body: `Здравствуйте ${users[approver.get_email().toLowerCase()] &&
                          users[approver.get_email().toLowerCase()]["displayName"]
                          },<br/><br/>Прочитайте следующий документ и подтвердите факт его согласования:<br/><br/>${`<a href="${siteUrl}/dashboard/1?documentCard=${(versionView && card.MainDocument.get_lookupId()) || card.ID
                          }${(versionView && `&version=${versionView}`) || ""}">${card.Title
                          }</a>`}<br/><br/>Срок согласования: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                          }>${moment(card.PublicationDate).format(
                            "DD.MM.YYYY",
                          )}</span>`,
                        DateToBeSentAt: date,
                        Title: "Мои Документы | Согласование документа",
                        Subject: "Мои Документы | Согласование документа",
                        Recepients: approver.get_email().toLowerCase(),
                        CheckDoc: (versionView && String(card.MainDocument.get_lookupId())) ||
                          String(card.ID),
                        RepeatAt: (idxDate === 1 && minutes) || 0,
                      },
                    ];
                  });
                });
              }
            }

            if (currentHistoryCardUpdate && Object.keys(currentHistoryCardUpdate).length > 0) {
              approversCardDocumentData["historyCardUpdate"] = {
                Approved: currentUser.email.toLowerCase(),
                ID: currentHistoryCardUpdate.ID,
                Statuses: [docStatuses.agreed],
                VersionDocument: (versionView && true) || false,
                Title: queueCurrentCardApproversGroup.dateReplaced ||
                  `History card # ${card.ID}`,
                ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
                Created: new Date()
              };
            }

            approversCardDocumentData["historyFieldsCardAdd"] = {
              Title: queueCurrentCardApproversGroup.dateReplaced ||
                `History card # ${card.ID}`,
              DocumentID: card.ID,
              Statuses: [docStatuses.agreed],
              JSONChangesFields: JSON.stringify(changesFieldValue),
              Approvers: (queueCurrentCardApproversGroup.approvers &&
                queueCurrentCardApproversGroup.approvers.length > 0 &&
                queueCurrentCardApproversGroup.approvers.map(
                  (user: any) => user.get_email(),
                )) || [],
              VersionDocument: (versionView && true) || false,
              ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
            };

            updateData["PublicationDate"] = moment(new Date())
              .add(
                Number(
                  params
                    .find((param: any) => param.Key === "documentsApproveDays")
                  ["Value"].trim(),
                ),
                "days",
              )
              .toDate();
            approversCardDocumentData["updateCard"] = updateData;

          } else {
            if (card.AuthorEmail) {
              approversCardDocumentData["notificationData"] = [
                {
                  Title: (versionView && `Согласована версия # ${card.ID}`) ||
                    `Согласован документ # ${card.ID}`,
                  ReviewDate: moment(new Date())
                    .add(
                      Number(
                        params
                          .find((param: any) => param.Key === "documentsApproveDays")
                        ["Value"].trim(),
                      ),
                      "days",
                    )
                    .toDate(),
                  AuthorComment: "",
                  DocumentCode: `${card.Code}.${card.Index}`,
                  Document: (versionView && card.MainDocument.get_lookupId()) || card.ID,
                  NotificationType: notificationStatuses.approved,
                  Employee: card.AuthorEmail.toLowerCase(),
                  EmployeeEmail: card.AuthorEmail.toLowerCase(),
                  VersionDocument: versionView,
                  AuthorEmail: currentUser.email.toLowerCase(),
                  Completed: new Date(),
                },
              ];

              if (emailsSender) {
                approversCardDocumentData["emailBody"] = {
                  Body: `Здравствуйте ${users[card.AuthorEmail.toLowerCase()] &&
                    users[card.AuthorEmail.toLowerCase()]["displayName"]
                    },<br/><br/>Уведомляем Вас, что следующий документ был согласован и опубликован:<br/><br/>${`<a href="${siteUrl}/dashboard/1?documentCard=${(versionView && card.MainDocument.get_lookupId()) || card.ID}">${card.Title}</a>`}`,
                  DateToBeSentAt: moment().subtract(12, "hours").toDate(),
                  Title: "Мои Документы | Документ согласован",
                  Subject: "Мои Документы | Документ согласован",
                  Recepients: card.AuthorEmail.toLowerCase(),
                  CheckDoc: String(card.ID),
                };
              }
            }

            approversCardDocumentData["historyFieldsCardAdd"] = {
              Title: queueCurrentCardApproversGroup.dateReplaced ||
                `History card # ${card.ID}`,
              DocumentID: card.ID,
              JSONChangesFields: JSON.stringify(changesFieldValue),
              Statuses: [docStatuses.approved, docStatuses.public],
              Approvers: (queueCurrentCardApproversGroup.approvers &&
                queueCurrentCardApproversGroup.approvers.length > 0 &&
                queueCurrentCardApproversGroup.approvers.map(
                  (user: any) => user.get_email(),
                )) || [],
              VersionDocument: (versionView && true) || false,
              ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
            };

            updateData["Status"] = docStatuses.public;
            updateData["PublicationDate"] = new Date();
            approversCardDocumentData["updateCard"] = updateData;

            approversCardDocumentData["removeItemsApproversCardDocument"] =
              (approversByDocument.length > 0 &&
                approversByDocument.map((item: { ID: number }) => {
                  return { ID: item.ID };
                })) || [];

            if (currentHistoryCardUpdate && Object.keys(currentHistoryCardUpdate).length > 0) {
              approversCardDocumentData["historyCardUpdate"] = {
                Title: queueCurrentCardApproversGroup.dateReplaced ||
                  `History card # ${defaultValues.ID}`,
                Approved: currentUser.email.toLowerCase(),
                ID: currentHistoryCardUpdate.ID,
                VersionDocument: (versionView && true) || false,
                Statuses: [docStatuses.approved, docStatuses.public],
                Approvers: (queueCurrentCardApproversGroup.approvers &&
                  queueCurrentCardApproversGroup.approvers.length > 0 &&
                  queueCurrentCardApproversGroup.approvers.map(
                    (user: any) => user.get_email(),
                  )) || [],
                ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
                Created: new Date()
              };
            }

            let workPlacesIds: any = [];
            if (approversCardDocumentData["updateCard"]["WorkPlaces"] &&
              Array.isArray(approversCardDocumentData["updateCard"]["WorkPlaces"]) &&
              approversCardDocumentData["updateCard"]["WorkPlaces"].length > 0) {
              workPlacesIds = [...approversCardDocumentData["updateCard"]["WorkPlaces"]];
            }
            approversCardDocumentData['workPlacesIds'] = [...workPlacesIds];
          }

          setApproversCardDocumentData(approversCardDocumentData);
        }
      }

      if (reject) {
        approversCardDocumentData["type"] = "reject";
        approversCardDocumentData["notificationData"] = [
          {
            Title: `Отклонено # ${card.ID}`,
            ReviewDate: moment(new Date())
              .add(
                Number(
                  params
                    .find(
                      (param: any) => param.Key === "documentsApproveDays",
                    )
                  ["Value"].trim(),
                ),
                "days",
              )
              .toDate(),
            AuthorComment: "",
            DocumentCode: `${card.Code}.${card.Index}`,
            Document: documentCardID,
            NotificationType: notificationStatuses.cancel, // Отклонено
            Employee: card.AuthorEmail.toLowerCase(),
            EmployeeEmail: card.AuthorEmail.toLowerCase(),
            VersionDocument: versionView,
            AuthorEmail: currentUser.email.toLowerCase(),
            Completed: new Date(),
          },
        ];
        approversCardDocumentData["preventGroup"] = {
          Denied: currentUser.email,
          Queue: false,
          ID: queueCurrentCardApproversGroup.updateID,
          Statuses: [docStatuses.cancel], // Отклонен
        };
        approversCardDocumentData["historyCardRemove"] =
          (historyCardWaiting.length > 0 &&
            historyCardWaiting.map((item: { ID: number }) => {
              return { ID: item.ID };
            })) ||
          [];
        if (
          currentHistoryCardUpdate &&
          Object.keys(currentHistoryCardUpdate).length > 0
        ) {
          approversCardDocumentData["historyCardAdd"] = {
            Title:
              queueCurrentCardApproversGroup.dateReplaced ||
              `History card # ${card.ID}`,
            JSONChangesFields: JSON.stringify(changesFieldValue),
            DocumentID: card.ID,
            Denied: currentUser.email.toLowerCase(),
            ApprovalGroup: queueCurrentCardApproversGroup.group,
            Approvers:
              (queueCurrentCardApproversGroup.approvers &&
                queueCurrentCardApproversGroup.approvers.length > 0 &&
                queueCurrentCardApproversGroup.approvers.map((user: any) => user.get_email())) ||
              [],
            Statuses: [docStatuses.cancel], // Отклонен
            ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
            VersionDocument: (versionView && true) || false,
          };
        }
        approversCardDocumentData["historyFieldsCardAdd"] = {
          Title:
            queueCurrentCardApproversGroup.dateReplaced ||
            `History card # ${card.ID}`,
          DocumentID: card.ID,
          Approvers:
            (queueCurrentCardApproversGroup.approvers &&
              queueCurrentCardApproversGroup.approvers.length > 0 &&
              queueCurrentCardApproversGroup.approvers.map((user: any) => user.get_email())) ||
            [],
          JSONChangesFields: JSON.stringify(changesFieldValue),
          Statuses: [docStatuses.cancel], // Отклонен
          VersionDocument: (versionView && true) || false,
          ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
        };
        updateData["PublicationDate"] = moment(new Date()).add(7, "d").toDate();
        updateData["Status"] = docStatuses.cancel;
        approversCardDocumentData["updateCard"] = updateData;
      }
      if (modification) {
        approversCardDocumentData["type"] = "modification";
        if (card.AuthorEmail) {
          approversCardDocumentData["notificationData"] = [
            {
              Title: `На доработку # ${defaultValues.ID}`,
              ReviewDate: moment(new Date())
                .add(
                  Number(
                    params
                      .find(
                        (param: any) => param.Key === "documentsApproveDays",
                      )
                    ["Value"].trim(),
                  ),
                  "days",
                )
                .toDate(),
              AuthorComment: "",
              DocumentCode:
                (updateData.Code &&
                  updateData.Index &&
                  `${updateData.Code}.${updateData.Index}`) ||
                `${defaultValues.Code}.${defaultValues.Index}`,
              Document:
                (versionView && defaultValues.MainDocument.ID) ||
                defaultValues.ID,
              NotificationType: notificationStatuses.revision, // На доработку
              Employee: card.AuthorEmail.toLowerCase(),
              EmployeeEmail: card.AuthorEmail.toLowerCase(),
              VersionDocument: versionView,
              AuthorEmail: currentUser.email.toLowerCase(),
              Completed: new Date(),
            },
          ];
        }
        approversCardDocumentData["preventGroup"] = {
          Denied: currentUser.email,
          Queue: false,
          ID: queueCurrentCardApproversGroup.updateID,
          Statuses: [docStatuses.revision], // На доработку
          VersionDocument: (versionView && true) || false,
        };
        approversCardDocumentData["historyCardRemove"] =
          (historyCardWaiting.length > 0 &&
            historyCardWaiting.map((item: { ID: number }) => {
              return { ID: item.ID };
            })) ||
          [];
        if (
          currentHistoryCardUpdate &&
          Object.keys(currentHistoryCardUpdate).length > 0
        ) {
          approversCardDocumentData["historyCardAdd"] = {
            Title:
              queueCurrentCardApproversGroup.dateReplaced ||
              `History card # ${card.ID}`,
            DocumentID: card.ID,
            Denied: currentUser.email.toLowerCase(),
            ApprovalGroup: queueCurrentCardApproversGroup.group,
            Approvers:
              (queueCurrentCardApproversGroup.approvers &&
                queueCurrentCardApproversGroup.approvers.length > 0 &&
                queueCurrentCardApproversGroup.approvers.map(
                  (user: any) => user.Email,
                )) ||
              [],
            JSONChangesFields: JSON.stringify(changesFieldValue),
            Statuses: [docStatuses.edited, docStatuses.sendRevision], // Изменен, Отправлен на доработку
            VersionDocument: (versionView && true) || false,
            ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
          };
        }
        approversCardDocumentData["historyFieldsCardAdd"] = {
          Title:
            queueCurrentCardApproversGroup.dateReplaced ||
            `History card # ${card.ID}`,
          DocumentID: card.ID,
          JSONChangesFields: JSON.stringify(changesFieldValue),
          Approvers:
            (queueCurrentCardApproversGroup.approvers &&
              queueCurrentCardApproversGroup.approvers.length > 0 &&
              queueCurrentCardApproversGroup.approvers.map(
                (user: any) => user.Email,
              )) ||
            [],
          Statuses: [docStatuses.edited, docStatuses.sendRevision], // Изменен, Отправлен на доработку
          VersionDocument: (versionView && true) || false,
          ChangeRights: queueCurrentCardApproversGroup.whoReplaced,
        };
        updateData["PublicationDate"] = moment(new Date()).add(7, "d").toDate();
        updateData["Status"] = docStatuses.revision;
        approversCardDocumentData["updateCard"] = updateData;
      }
      if (agreement) {
        approversCardDocumentData["type"] = "agreement";
        approversCardDocumentData["historyCardRemove"] =
          (historyCardWaiting.length > 0 &&
            historyCardWaiting.map((item: { ID: number }) => {
              return { ID: item.ID };
            })) ||
          [];
        approversCardDocumentData["historyCardAdd"] = [
          {
            Title: `History card # ${card.ID}`,
            ApprovalGroup: docApprovers.Creater, //Создатель
            DocumentID: card.ID,
            order: 0,
            Statuses: [docStatuses.edited, docStatuses.sendApproval], //Изменен, Отправлен на согласование
            Approvers: [currentUser.email.toLowerCase()],
            JSONChangesFields: JSON.stringify(changesFieldValue),
            VersionDocument: (versionView && true) || false,
          },
        ];
        approversCardDocumentData["historyFieldsCardAdd"] = {
          Title: `History fields card # ${card.ID}`,
          DocumentID: card.ID,
          Statuses: [docStatuses.edited, docStatuses.sendApproval], //Изменен, Отправлен на согласование
          JSONChangesFields: JSON.stringify(changesFieldValue),
          VersionDocument: (versionView && true) || false,
        };

        updateData["PublicationDate"] = moment(new Date()).add(7, "d").toDate();
        updateData["Status"] = docStatuses.approval; // На согласовании
        approversCardDocumentData["updateCard"] = updateData;
        setUpdateCardData && setUpdateCardData(approversCardDocumentData);
      }
      if (revision) {
        console.log(" --- revision: ", revision);
        console.log(" --- documentCardID: ", documentCardID);

        setCustomLoading(true);

        getItemsRequest({ listName: notificationsCardListName, filters: { Document: documentCardID, VersionDocument: versionView || null } }).then((results) => {
          const notifications = [...results.items];
          if (card.Status.get_lookupId() === docStatuses.review) {
            updateData["Status"] = docStatuses.public;
            approversCardDocumentData["removeItemsApproversCardDocument"] =
              approversByDocument.length > 0 &&
              approversByDocument.map((item: { ID: number }) => {
                return { ID: item.ID };
              });
          }
          let emailsArrExistsNotifications = notifications.length > 0 &&
            notifications.filter((item: any) => item.NotificationType.get_lookupId() === notificationStatuses.familiarization && item.Read && !item.VersionDocument).map((item: any) => item.EmployeeEmail.toLowerCase()) || [];
          approversCardDocumentData["removeAuditNotifications"] =
            notifications.length > 0 &&
            notifications.filter((item: any) => item.NotificationType.get_lookupId() === notificationStatuses.familiarization && !item.Read && item.Title.indexOf('Отклонено') === -1).map((item: any) => {
              return { ID: item.ID }
            });
          approversCardDocumentData["historyFieldsCardAdd"] = {
            Title: `History fields card # ${card.ID}`,
            DocumentID: card.ID,
            Statuses: [docStatuses.edited], //Изменен
            JSONChangesFields: JSON.stringify(changesFieldValue),
            VersionDocument: (versionView && true) || false,
          };
          let requests: any = [];
          approversCardDocumentData["updateCard"] = updateData;
          if (approversCardDocumentData["removeItemsApproversCardDocument"] && approversCardDocumentData["removeItemsApproversCardDocument"].length > 0) {
            requests = [...requests, deleteItemRequest({ listName: approversCardDocumentListName, ID: 0, Ids: approversCardDocumentData["removeItemsApproversCardDocument"] })];
          }
          if (approversCardDocumentData["emailsRemove"].length > 0) {
            requests = [...requests, deleteItemRequest({ listName: emailQueueListName, ID: 0, Ids: approversCardDocumentData["emailsRemove"] })];
          }

          requests = [...requests, addItemRequest({ listName: historyChangeFieldsDocumentListName, body: approversCardDocumentData["historyFieldsCardAdd"] })];
          let workPlacesIds: any = [];
          // if (defaultValues.WorkPlaces && Array.isArray(defaultValues.WorkPlaces) && defaultValues.WorkPlaces.length > 0) {
          //   workPlacesIds = [...defaultValues.WorkPlaces.map((place: any) => place.id)];
          // }
          if (approversCardDocumentData["updateCard"]["WorkPlaces"] && Array.isArray(approversCardDocumentData["updateCard"]["WorkPlaces"]) && approversCardDocumentData["updateCard"]["WorkPlaces"].length > 0) {
            workPlacesIds = [...approversCardDocumentData["updateCard"]["WorkPlaces"]];
          }
          if (approversCardDocumentData["updateCard"] && approversCardDocumentData["updateCard"]["EquipmentsListNew"] && approversCardDocumentData["updateCard"]["EquipmentsListNew"].length > 0) {
            const equpmentsupdates = { ...approversCardDocumentData["updateCard"] };
            console.log('approversCardDocumentData["updateCard"]: ', equpmentsupdates);
            let sendDataEquipments: any = [];
            for (
              let i = 0;
              i < approversCardDocumentData["updateCard"]["EquipmentsListNew"].length;
              i++
            ) {
              sendDataEquipments = [
                ...sendDataEquipments,
                {
                  Title: `Document card #${approversCardDocumentData["updateCard"]["ID"]}`,
                  Line:
                    approversCardDocumentData["updateCard"]["EquipmentsListNew"][i]["Line"] &&
                    approversCardDocumentData["updateCard"]["EquipmentsListNew"][i]["Line"]["id"],
                  Equipment:
                    approversCardDocumentData["updateCard"]["EquipmentsListNew"][i]["SAP"] &&
                    approversCardDocumentData["updateCard"]["EquipmentsListNew"][i]["SAP"]["ID"],
                  Document: approversCardDocumentData["updateCard"]["ID"],
                  VersionDocument: (versionView && true) || false,
                },
              ];
            }
            if (sendDataEquipments.length > 0) {
              requests = [...requests, addItemRequest({ listName: equipmentsByDocumentListName, body: sendDataEquipments[0], bodyArr: sendDataEquipments })];
            }
            if (
              approversCardDocumentData["updateCard"]["EquipmentsListOld"] &&
              approversCardDocumentData["updateCard"]["EquipmentsListOld"].length > 0
            ) {
              let removeIds: any = [];
              for (
                let i = 0;
                i < approversCardDocumentData["updateCard"]["EquipmentsListOld"].length;
                i++
              ) {
                removeIds = [
                  ...removeIds,
                  {
                    ID: approversCardDocumentData["updateCard"]["EquipmentsListOld"][i]["ID"],
                  },
                ];
              }
              if (removeIds.length > 0) {
                requests = [...requests, deleteItemRequest({ listName: equipmentsByDocumentListName, ID: 0, Ids: removeIds })];
              }
            }
            delete approversCardDocumentData["updateCard"]["EquipmentsListNew"];
            delete approversCardDocumentData["updateCard"]["EquipmentsListOld"];
          }
          requests = [...requests, updateItemRequest({ listName: (versionView && versionsByDocumentListName) || myDocumentsListName, body: approversCardDocumentData["updateCard"] })];
          if (workPlacesIds.length > 0 && (card.Status.get_lookupId() === docStatuses.review || card.Status.get_lookupId() === docStatuses.public)) {
            if (approversCardDocumentData["removeAuditNotifications"].length > 0) {
              requests = [...requests, deleteItemRequest({ listName: notificationsCardListName, ID: 0, Ids: approversCardDocumentData["removeAuditNotifications"] })];
            }
            getItemsRequest({ listName: MDWorkstationListName, filters: { ID: workPlacesIds } }).then((results) => {
              addItemRequest({
                listName: notificationIdsListName,
                body: { Title: "Ознакомление" },
                updateReducer: false,
              }).then((notificationID) => {
                const workPlaces = [...results.items];
                let usersData: any = [];
                workPlaces.forEach(place => {
                  if (place.User && Array.isArray(place.User) && place.User.length > 0) {
                    place.User.forEach((user: any) => {
                      let displayName = user.get_metadata &&
                        (user.get_metadata().DisplayName || (user.get_metadata()["UserProfileProperties"].length > 0 &&
                          ((user.get_metadata()["UserProfileProperties"].find(
                            (item: any) => item.Key === "PreferredNameRus"
                          ) &&
                            user.get_metadata()["UserProfileProperties"].find(
                              (item: any) => item.Key === "PreferredNameRus"
                            )?.["Value"]) ||
                            (user.get_metadata()["UserProfileProperties"].find(
                              (item: any) => item.Key === "PreferredName"
                            ) &&
                              user.get_metadata()["UserProfileProperties"].find(
                                (item: any) => item.Key === "PreferredName"
                              )?.["Value"]))));
                      if (displayName.split(" ").length === 3) {
                        displayName = `${displayName.split(" ")[0]} ${displayName.split(" ")[1]
                          }`;
                      }
                      usersData = [...usersData, {
                        email: user.get_email().toLowerCase(),
                        name: displayName,
                        personalNumber: user.get_metadata && (user.get_metadata().EmployeeNumber || (user.get_metadata()["UserProfileProperties"].length > 0 &&
                          (user.get_metadata()["UserProfileProperties"].find(
                            (item: any) => item.Key === "abiPersonnelNumber"
                          )?.["Value"] ||
                            user.get_metadata()["UserProfileProperties"].find(
                              (item: any) => item.Key === "UserName"
                            )?.["Value"])))
                      }]
                    });
                  }
                });
                let dataNotificationsArr: any = [];
                _.uniqWith(usersData, _.isEqual).map(user => {
                  const days = Number(
                    params
                      .find((param: any) => param.Key === "auditDateDefault")
                    ["Value"].trim(),
                  );
                  if (emailsArrExistsNotifications.filter(email => email === user.email).length === 0) {
                    dataNotificationsArr = [...dataNotificationsArr, {
                      Title: "Уведомление " + notificationID,
                      NotificationID: notificationID,
                      Employee: user.email.toLowerCase(),
                      EmployeeEmail: user.email.toLowerCase(),
                      Document: card.ID,
                      DocumentCode: `${card.Code}.${card.Index}`,
                      ReviewDate: moment().add(days, 'days').toDate(),
                      AuthorComment: "",
                      NotificationType: notificationStatuses.familiarization,
                      AuthorEmail: "supply.portal@abinbevefes.com",
                    }];
                  }
                });
                requests = [...requests, addItemRequest({ listName: notificationsCardListName, body: dataNotificationsArr[0], bodyArr: dataNotificationsArr })];
                Promise.all(requests).then(() => {
                  requests = [];
                  getItemsRequest({ listName: notificationsCardListName, filters: { Document: card.ID, NotificationType: notificationStatuses.familiarization, Read: false } }).then((results) => {
                    const notifications = [...results.items];
                    let dataEmailNotificationArr: any = [];
                    _.uniqWith(usersData, _.isEqual).map(user => {
                      const minutes = Number(
                        params
                          .find((param: any) => param.Key === "audit")
                        ["Value"].trim(),
                      );
                      const days = Number(
                        params
                          .find((param: any) => param.Key === "auditDateDefault")
                        ["Value"].trim(),
                      );
                      const dateSendEmailsArr = [
                        moment(new Date()).clone().subtract(12, "hours").toDate(),
                        moment(new Date()).clone().add(minutes, "m").toDate(),
                      ];
                      if (emailsArrExistsNotifications.filter(email => email === user.email).length === 0) {
                        dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
                          dataEmailNotificationArr = [
                            ...dataEmailNotificationArr,
                            sendEmail({
                              Body: `Здравствуйте ${user['name']} (${user['personalNumber']}),<br/><br/>Прочитайте следующий (-е) документ (-ы) и подтвердите факт ознакомления с документом (-ами):<br/><br/>${`<a href="${siteUrl}/dashboard/1/notification?notificationCard=${notifications.filter(item => item.EmployeeEmail.toLowerCase() === user.email.toLowerCase()).map(item => item.ID)[0]}">${card.Title
                                }</a>`}<br/><br/>Срок ознакомления: <span${(idxDate === 1 && ` style="color:red;"`) || ""
                                }>${moment().add(Number(days), 'd').format(
                                  "DD.MM.YYYY",
                                )}</span>`,
                              DateToBeSentAt: date,
                              Title: "Мои документы | Ознакомление с документами",
                              Subject: "Мои документы | Ознакомление с документами",
                              Recepients: user.email.toLowerCase(),
                              CheckDoc: String(card.ID),
                              NotificationID: notifications.filter(item => item.EmployeeEmail.toLowerCase() === user.email.toLowerCase()).map(item => item.ID)[0],
                              RepeatAt: (idxDate === 1 && minutes) || 0,
                            })
                          ];
                        });
                      }
                    });
                    requests = [...requests, ...dataEmailNotificationArr];
                    Promise.all(requests).then(values => {
                      setReRenderCard(!reRenderCard);
                    });
                  });
                });
              });
            });
          } else {
            Promise.all(requests).then(values => {
              setReRenderCard(!reRenderCard);
            });
          }
        });
      }
      if (!revision && !draft && !agreement && !archive) {
        setApproversCardDocumentData(approversCardDocumentData);
      }
    }
    setEditDataForm(false);
  };
  //Получаем все данные по карточке докумена, текущей роли пользователя, а также текущей группе согласующих и следующей
  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();

    const loadCardData = async () => {
      if (type !== "card" || !currentUser.id) return;

      const targetId = versionView || documentCardID;
      if (!targetId) {
        console.log("Не удается загрузить документ: ", { versionView, documentCardID });
        return;
      }

      try {
        setCustomLoading(true);

        // 1. Загружаем карточку
        const cardResult = await getItemsRequest({
          listName: versionView ? versionsByDocumentListName : myDocumentsListName,
          filters: { ID: versionView || documentCardID }
        });

        if (!isMounted) return;

        const card = cardResult.items[0] || null;
        //console.log('card_in_form: ', card);

        if (!card) {
          alert("Карточка документа не найдена или удалена");
          query.delete("documentCard");
          query.delete("version");
          setQuery(query);
          return;
        }

        // 2. Параллельно загружаем независимые данные
        const [approversResult, replacedResult, dependenciesResult, approversListResult, versionsResult, notificationsResult, emailsResult, historyResult] = await Promise.all([
          getItemsRequest({ listName: approversCardDocumentListName, filters: { Document: card.ID, VersionDocument: !!versionView } }),
          getItemsRequest({ listName: ReplacedListName, filters: { WhoReplaced: currentUser.id } }),
          getItemsRequest({ listName: approversDependenciesListName, filters: { DocType: card.DocType.get_lookupId(), Collection: card.Collection.get_lookupId() } }),
          getItemsRequest({ listName: approversListName }),
          getItemsRequest({ listName: versionsByDocumentListName, filters: { MainDocument: documentCardID }, sortOrder: { name: 'ID', desc: true } }),
          getItemsRequest({ listName: notificationsCardListName, filters: { Document: documentCardID, VersionDocument: versionView || null } }),
          getItemsRequest({ listName: emailQueueListName, filters: { CheckDoc: String(documentCardID) } }),
          getItemsRequest({ listName: historyByDocumentListName, filters: { DocumentID: versionView || documentCardID, VersionDocument: !!versionView } })
        ]);

        if (!isMounted) return;

        // 3. Подготовка данных (без мутаций)
        const approversByDocument = approversResult.items;
        const replacedItems = replacedResult.items;
        const approversDependencies = dependenciesResult.items;

        // 4. Вычисляем роль пользователя (одним объектом!)
        const userRoleUpdates: Record<string, boolean> = {
          author: card.AuthorEmail === currentUser.email,
          admin: currentUser.isAdmin || false,
          replaced: false,
          approver: false
        };

        // Логика замены
        const whomReplaced = replacedItems[0]?.WhomReplaced?.get_email?.().toLowerCase() || null;
        const currentApproversGroup = approversByDocument.find((item: any) => item.Group && item.Queue) || null;
        const currentCardStatusId = Number(card?.Status?.get_lookupId?.());

        if (whomReplaced && currentApproversGroup?.Approvers?.some((a: any) =>
          a.get_email?.().toLowerCase() === whomReplaced)) {
          userRoleUpdates.replaced = true;
        }

        // Логика аппрувера
        const queueCurrentCardApproversGroup = currentApproversGroup ? {
          queue: currentApproversGroup.Queue,
          group: currentApproversGroup.Group.get_lookupId(),
          approvers: currentApproversGroup.Approvers,
          updateID: currentApproversGroup.ID,
          whoReplaced: userRoleUpdates.replaced && currentUser.email,
          whomReplaced: userRoleUpdates.replaced && whomReplaced,
          dateReplaced: userRoleUpdates.replaced
            ? `Передача полномочий заместителю в период с ${moment(replacedItems[0]?.StartReplace).format("DD.MM.YYYY")} по ${moment(replacedItems[0]?.EndReplace).format("DD.MM.YYYY")}`
            : undefined
        } : null;

        // Проверка прав на аппрув
        const hasApproveRights = queueCurrentCardApproversGroup?.approvers?.some((a: any) =>
          a.get_email?.().toLowerCase() === currentUser.email.toLowerCase()
        ) || (queueCurrentCardApproversGroup?.whoReplaced && queueCurrentCardApproversGroup?.whomReplaced);

        if (hasApproveRights) {
          userRoleUpdates.approver = true;
        }

        // 5. Вычисляем следующую группу (если нужно)
        let nextApproversGroupData = null;
        if (currentApproversGroup) {
          const queueCurrent = approversDependencies.find((item: any) =>
            item.Group?.get_lookupId?.() === currentApproversGroup.Group.get_lookupId()
          )?.Order0;

          if (queueCurrent && queueCurrent < approversDependencies.length) {
            const tempNextGroup = approversDependencies.find((item: any) => item.Order0 === queueCurrent + 1);
            const next = approversByDocument.find((item: any) =>
              tempNextGroup?.Group && item.Group?.get_lookupId?.() === tempNextGroup.Group.get_lookupId()
            );
            if (next) {
              nextApproversGroupData = {
                queue: false,
                group: next.Group.get_lookupId(),
                approvers: next.Approvers,
                updateID: next.ID,
              };
            }
          }
        }

        // 6. Обрабатываем email для удаления
        const emailsRemove = currentCardStatusId === docStatuses.public
          ? emailsResult.items
            .filter((email: any) => email.Title?.indexOf("Согласование ") !== -1)
            .map((email: any) => ({ ID: email.ID }))
          : [];

        // 7. Собираем уникальные email для добавления пользователей
        const allItems = [card, ...approversByDocument, ...historyResult.items];
        const usersEmail = _.uniq(
          allItems.flatMap((item: any) =>
            Object.values(item).flatMap((field: any) => {
              if (!field) return [];
              if (Array.isArray(field)) {
                return field.filter((f: any) => f?.get_email?.()).map((f: any) => f.get_email().toLowerCase());
              }
              if (field.get_email?.()) {
                return [field.get_email().toLowerCase()];
              }
              return [];
            })
          )
        );

        const newUsers = usersEmail.filter((email: string) => !users[email]);

        // 8. ОДНИМ вызовом обновляем ВСЕ состояния (батчинг!)
        if (isMounted) {

          console.log(" --- card: ", card);
          console.log(" --- approversByDocument: ", approversByDocument);
          console.log(" --- queueCurrentCardApproversGroup: ", queueCurrentCardApproversGroup);
          console.log(" --- approversListResult: ", approversListResult);
          console.log(" --- approversDependencies: ", approversDependencies);

          setCard(card);
          setCheckLoadUsers(false);
          setApproversByDocument(approversByDocument);
          setApproversDependencies(approversDependencies);
          setApproversList(approversListResult.items);
          setVersionsDocument(versionsResult.items);
          setNotifications(notificationsResult.items);
          setEmails(emailsResult.items);
          setHistoryCard(historyResult.items);
          setQueueCurrentCardApproversGroup(queueCurrentCardApproversGroup);
          setNextApproversGroup(nextApproversGroupData);
          setApproveButtonsFlag(userRoleUpdates.admin || hasApproveRights);
          setCurrentUserRole((prev: any) => ({ ...prev, ...userRoleUpdates }));

          // Dispatch actions
          dispatch(getWorkDocumentsInfo({ listName: myWorksDocumentsListName }));
          if (newUsers.length > 0) {
            dispatch(addUsers(newUsers));
          }

          // Удаляем старые email если нужно
          if (emailsRemove.length > 0) {
            await deleteItemRequest({ listName: emailQueueListName, ID: 0, Ids: emailsRemove });
          }
        }
      } catch (error) {
        const err = error as any;
        if (isMounted && err?.name !== "AbortError") {
          console.error("Ошибка загрузки данных:", err);
          // Можно добавить toast-уведомление для пользователя
        }
      } finally {
        if (isMounted) {
          setResetDefaultValue(Math.random());
          reset(defaultValues);
          setCustomLoading(false);
          setDisabledDoubleSend(false);
        }
      }
    };

    loadCardData();

    // Cleanup функция
    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, [type, currentUser?.id, reRenderCard]); // ✅ Правильные зависимости

  //Запрет на создание новых версий, если есть версия на согласовании или смотрим версию - START
  useEffect(() => {
    if (
      type === "card" &&
      (versionView ||
        versionsDocument.find(
          (version: any) => version.Status.get_lookupId() === docStatuses.approval,
        ) ||
        versionsDocument.find(
          (version: any) => version.Status.get_lookupId() === docStatuses.revision,
        ) ||
        versionsDocument.find(
          (version: any) => version.Status.get_lookupId() === docStatuses.cancel,
        ))
    ) {
      setCreateVersions(false);
    }
    if (type === "card") {
      const tempVersions = versionsDocument.filter((version: any) => version.Status.get_lookupId() === docStatuses.approval || version.Status.get_lookupId() === docStatuses.revision || version.Status.get_lookupId() === docStatuses.cancel)
      setActivVersion(tempVersions.length > 0 && tempVersions[0]['ID'] || 0);
    }
  }, [type, versionsDocument]);
  //Запрет на создание новых версий, если есть версия на согласовании - END

  /* Защита от дурачков, чтобы нельзя было закрыть модалку с измененными полями - START */
  useEffect(() => {
    if (type === "card") {
      if (
        editDataForm &&
        card &&
        (card.Status.get_lookupId() === docStatuses.public ||
          card.Status.get_lookupId() === docStatuses.review)
      ) {
        if (
          !dirtyFields["DateForRevision"] &&
          !dirtyFields["ResponsibleForRevision"] &&
          !dirtyFields["Critical"] &&
          !dirtyFields["WorkPlaces"]
        ) {
          setValue("DateForRevision", null);
        }
        setHideCloseIcon && setHideCloseIcon(true);
      } else {
        setHideCloseIcon && setHideCloseIcon(false);
      }
    }
  }, [type, editDataForm, card]);
  /* Защита от дурачков, чтобы нельзя было закрыть модалку с измененными полями - END */

  /* Определяем  флаги для отображения кнопок формы и проверка пересмотра - START */
  useEffect(() => {
    if (
      type === "card" &&
      card &&
      Object.keys(currentUserRole).length > 0
    ) {
      if (
        (dirtyFields["File"] ||
          dirtyFields["Title"] ||
          dirtyFields["DocType"] ||
          dirtyFields["Collection"] ||
          dirtyFields["Department"] ||
          dirtyFields["Process"] ||
          dirtyFields["Sector"]) && !dirtyFields[equipmentsListName]
      ) {
        setChangesButtonsFlag(true);
        setApproveButtonsFlag(false);
        setRevisionButtonsFlag(false);
        setTextButtonCancel("Отменить изменения");
        setEditDataForm(true);
      } else if (
        card.Status.get_lookupId() === docStatuses.approval &&
        (currentUserRole.approver || currentUserRole.admin)
      ) {
        //На согласовании
        setApproveButtonsFlag(true);
        setChangesButtonsFlag(false);
        setRevisionButtonsFlag(false);
        setTextButtonCancel("Назад");
        setEditDataForm(false);
      }

      if (
        (card.Status.get_lookupId() === docStatuses.revision ||
          card.Status.get_lookupId() === docStatuses.cancel) &&
        (currentUserRole.author || currentUserRole.admin || card.ResponsibleForRevisionEmail === currentUser.email)
      ) {
        //На доработке или отменена
        setApproveButtonsFlag(false);
        setChangesButtonsFlag(true);
        setRevisionButtonsFlag(false);
        setTextButtonCancel("Назад");
        setEditDataForm(false);
      }
      if (card.Status.get_lookupId() === docStatuses.review) {
        //На пересмотре
        setApproveButtonsFlag(false);
        setChangesButtonsFlag(false);
        setRevisionButtonsFlag(true);
        setTextButtonCancel("Назад");
        setEditDataForm(false);
      }
      if (
        card.Status.get_lookupId() === docStatuses.public ||
        card.Status.get_lookupId() === docStatuses.archive
      ) {
        // Опубликован или в архиве
        setApproveButtonsFlag(false);
        setChangesButtonsFlag(false);
        setRevisionButtonsFlag(false);
        setTextButtonCancel("Назад");
        setEditDataForm(false);
      }
    }
  }, [type, card, currentUserRole, resetDefaultValue]);
  /* Определяем  флаги для отображения кнопок формы и проверка пересмотра - END */

  /* Отслеживаем статус карточки - На пересмотр - START */
  useEffect(() => {
    if (type === "card" && card) {
      if (
        card.Status.get_lookupId() === docStatuses.public && !versionView
      ) {
        const tempDateForRevision = moment(card.DateForRevision).clone();
        if (moment().unix() > tempDateForRevision.subtract(30, "days").unix()) {
          setCustomLoading(true);
          let requests: any = [
            updateItemRequest({
              listName: myDocumentsListName, body: {
                ID: Number(versionView) || card.ID,
                Status: docStatuses.review,
              }
            }),
            addItemRequest({
              listName: approversCardDocumentListName, body: {
                Title: `Approver card # ${card.ID}`,
                Approvers: [card.ResponsibleForRevisionEmail],
                Group: docApprovers.Creater,
                Statuses: [docStatuses.review],
                Document: card.ID,
              }
            }),
            addItemRequest({
              listName: historyChangeFieldsDocumentListName, body: {
                Title: `History fields card # ${card.ID}`,
                DocumentID: card.ID,
                Statuses: [docStatuses.review], //На пересмотр,
              }
            })
          ];
          if (emailsSender) {
            let emailsHanleArr: any = [];
            const minutes = Number(
              params
                .find((param: any) => param.Key === "documentRevision")
              ["Value"].trim(),
            );
            const dateSendEmailsArr = [
              moment(new Date()).clone().subtract(12, "hours").toDate(),
              moment(new Date()).clone().add(minutes, "m").toDate(),
            ];
            dateSendEmailsArr.forEach((date: Date, idxDate: number) => {
              const emailBody = {
                Body: `Здравствуйте ${(users[card.ResponsibleForRevisionEmail.toLowerCase()] && users[card.ResponsibleForRevisionEmail.toLowerCase()]["displayName"]) ||
                  card.ResponsibleForRevision.get_lookupValue() || ""},<br/><br/>Уведомляем Вас о необходимости пересмотреть документ, так как Вы являетесь ответственным за его пересмотр:<br/><br/><a href="${siteUrl}/dashboard/1?documentCard=${card.ID
                  }">${card.Title
                  }</a><br/><br/>Срок пересмотра: ${moment(card.DateForRevision).format(
                    "DD.MM.YYYY",
                  )}`,
                DateToBeSentAt: date,
                Title: "Мои Документы | Необходимо пересмотреть документ",
                Subject: "Мои Документы | Необходимо пересмотреть документ",
                Recepients: card.ResponsibleForRevisionEmail.toLowerCase(),
                CheckDoc: String(card.ID),
                RepeatAt: (idxDate === 1 && minutes) || 0,
              };
              emailsHanleArr = [...emailsHanleArr, sendEmail(emailBody)];
            });
            requests = [...requests, ...emailsHanleArr];
          }
          Promise.all(requests).then(() => {
            setReRenderCard(!reRenderCard);
          });
        }
      }
    }
  }, [type, card]);
  /* Отслеживаем статус карточки - На пересмотр - END */

  /* Отслеживаем изменения полей форм, которые запускают согласование заного - START*/
  useEffect(() => {
    if (
      type === "card" &&
      (dirtyFields["File"] ||
        dirtyFields["Title"] ||
        dirtyFields["DocType"] ||
        dirtyFields["Collection"] ||
        dirtyFields["Department"] ||
        dirtyFields["Process"] ||
        dirtyFields["Sector"]) && !dirtyFields[equipmentsListName]
    ) {
      setChangesButtonsFlag(true);
      setApproveButtonsFlag(false);
      setRevisionButtonsFlag(false);
      setTextButtonCancel("Отменить изменения");
      setEditDataForm(true);
    }
  }, [
    type,
    watch("File"),
    watch("Title"),
    watch("DocType"),
    watch("Collection"),
    watch("Department"),
    watch("Process"),
    watch("Sector"),
  ]);
  /* Отслеживаем изменения полей форм, которые запускают согласование заного - END*/

  /* Отслеживаем изменения полей форм, которые не запускают согласование заного - START */
  useEffect(() => {
    if (
      card && type === "card" &&
      (dirtyFields["DateForRevision"] ||
        dirtyFields["ResponsibleForRevision"] ||
        dirtyFields["Critical"] ||
        dirtyFields["WorkPlaces"] ||
        dirtyFields[equipmentsListName])
    ) {
      console.log('watch(equipmentsListName)_1: ', watch(equipmentsListName));
      console.log('defaultValues_1: ', defaultValues);
      console.log('dirtyFields_1: ', dirtyFields);
      if (!changesButtonsFlag) {
        setRevisionButtonsFlag(true);
        setApproveButtonsFlag(false);
        setTextButtonCancel("Отменить изменения");
        setEditDataForm(true);
      }
      if (watch("DateForRevision") && !watch("DateForRevision")["startDate"]) {
        setValue("DateForRevision", null);
      }
    }
  }, [
    type,
    watch("DateForRevision"),
    watch("ResponsibleForRevision"),
    watch("Critical"),
    watch("WorkPlaces"),
    watch(equipmentsListName)
  ]);
  /* Отслеживаем изменения полей форм, которые не запускают согласование заного - END*/

  useEffect(() => {
    console.log("currentUserRole: ", currentUserRole);
    console.log("nextApproversGroup: ", nextApproversGroup);
    console.log(
      "queueCurrentCardApproversGroup: ",
      queueCurrentCardApproversGroup,
    );
  }, [currentUserRole, nextApproversGroup, queueCurrentCardApproversGroup]);

  /* Возврат значения формы по дефолту - START */
  useEffect(() => {
    if (defaultValues && Object.keys(defaultValues).length > 0) {
      reset(defaultValues);
    }
  }, [defaultValues, resetDefaultValue]);
  /* Возврат значения формы по дефолту - END */

  /* Отслеживаем поля и добавляем/меняем зависимости у формы - START */
  useEffect(() => {
    if (type === "add_card" || type === "card") {
      setDependenceFields &&
        setDependenceFields({
          Collection: watch("Collection"),
          Department: watch("Department"),
          Process: watch("Process"),
          Sector: watch("Sector"),
          Type: watch("DocType"),
        });
      setValue(
        "Path",
        `${(watch("Collection") && watch("Collection")["name"]) || "__"}/${(watch("Department") && watch("Department")["name"]) || "__"
        }/${(watch("Sector") && watch("Sector")["name"]) || "__"}/${(watch("Process") && watch("Process")["name"]) || "__"
        }/${(watch("DocType") && watch("DocType")["name"]) || "__"}`,
      );
    }
  }, [
    type,
    watch("Collection"),
    watch("Department"),
    watch("Process"),
    watch("Sector"),
    watch("DocType"),
  ]);

  useEffect(() => {
    if ((type === "card" || type === "add_card") && dirtyFields["Collection"]) {
      setValue(equipmentsListName, []);
      setValue("Department", null);
      setValue("Sector", null);
      setValue("Process", null);
      setValue("WorkPlaces", []);
    }
  }, [type, watch("Collection")]);

  useEffect(() => {
    if ((type === "card" || type === "add_card") && dirtyFields["Department"]) {
      setValue("Sector", null);
      setValue("Process", null);
      setValue("WorkPlaces", []);
    }
  }, [type, watch("Department")]);

  useEffect(() => {
    if ((type === "card" || type === "add_card") && dirtyFields["Sector"]) {
      setValue("Process", null);
    }
  }, [type, watch("Sector")]);

  useEffect(() => {
    if (type === "card" || type === "add_card") {
      setValue("Code", `${code}`);
    }
  }, [type, code, defaultValues, resetDefaultValue]);
  /* Отслеживаем поля и добавляем/меняем зависимости у формы - END */

  /* Сборос формы на значения по умолчанию - START */
  const resetDefaultValuesHandle = (idCard: number) => {
    if (type === "card") {
      setChangesButtonsFlag(false);
      setRevisionButtonsFlag(false);
    }
    if (type === "add_comment") {
      if (
        dirtyFields.CommentFiles ||
        (watch("CommentFiles") && watch("CommentFiles").length > 0)
      ) {
        let tempUpdateFilesArr: any = [];
        watch("CommentFiles").forEach((file: any) => {
          if (file.ForHistory) {
            tempUpdateFilesArr = [
              ...tempUpdateFilesArr,
              {
                ID: file.ID,
                ForHistory: false,
              },
            ];
          }
        });
        if (tempUpdateFilesArr.length > 0 && listUploadFiles) {
          dispatch(
            updateItem({
              listName: listUploadFiles,
              bodyArr: tempUpdateFilesArr,
              body: tempUpdateFilesArr[0],
            }),
          );
        }
      }
    }
    if (type === "audit_card_my_tasks") {
      if (dirtyFields.AuditFiles) {
        let tempUpdateFilesArr: any = [];
        defaultValues.AuditFiles.length > 0 &&
          defaultValues.AuditFiles.forEach((file: any) => {
            tempUpdateFilesArr = [
              ...tempUpdateFilesArr,
              {
                ID: file.ID,
                ForHistory: false,
              },
            ];
          });
        if (tempUpdateFilesArr.length > 0) {
          dispatch(
            updateItem({
              listName: myTasksAuditFilesListName,
              bodyArr: tempUpdateFilesArr,
              body: tempUpdateFilesArr[0],
            }),
          );
        }
      }
      setObservedType(defaultValues.ObservedType.name);
      setCurrentFormData({ ...defaultValues });
    }
    if (type === "inc_card_my_tasks") {
      setUpdateRepeaterField(false);
      setCurrentFormData({ ...defaultValues });
    }
    setResetDefaultValue(Math.random());
    reset(defaultValues);
    setEditDataForm(false);
  };
  /* Сборос формы на значения по умолчанию - END */

  /* Отслеживаем изменение ответственного и собраний (Мои задачи - Действия) - START */
  useEffect(() => {
    if (
      type === "add_action_in_component" ||
      type === "action_card" ||
      type === "action_card_copy" ||
      type === "add_action_in_modal"
    ) {
      if (dirtyFields["Responsible"] && !dirtyFields["Meeting"]) {
        if (watch("Responsible") && watch("Responsible").length > 0) {
          setIsSelectResponsible(watch("Responsible")[0]);
        } else {
          setIsSelectResponsible(false);
        }
        if (!watch("Meeting")) {
          setIsSelectMitings(false);
          setValue("Meeting", null);
        }
      }

      if (dirtyFields["Responsible"] && dirtyFields["Meeting"]) {
        if (watch("Responsible") && watch("Responsible").length > 0) {
          setIsSelectResponsible(watch("Responsible")[0]);
        } else {
          setIsSelectResponsible(false);
        }
        setIsSelectMitings(watch("Meeting"));
      }

      if (dirtyFields["Meeting"] && !dirtyFields["Responsible"]) {
        setIsSelectResponsible(false);
        setIsSelectMitings(watch("Meeting"));
        setValue("Responsible", null);
      }

      if (!dirtyFields["Meeting"] && !dirtyFields["Responsible"]) {
        if (watch("Responsible") && watch("Responsible").length > 0) {
          setIsSelectResponsible(watch("Responsible")[0]);
        } else {
          setIsSelectResponsible(false);
        }
        if (watch("Meeting")) {
          setIsSelectMitings(watch("Meeting"));
        } else {
          setIsSelectMitings(false);
        }
      }
    }
  }, [type, watch("Responsible"), watch("Meeting")]);

  useEffect(() => {
    if (type === "action_card" && dirtyFields["Meeting"]) {
      fieldsForm
        .filter(
          (field: any) => !field.hide && field.key.indexOf("_custom_") !== -1,
        )
        .forEach((field) => {
          setValue(field.key, null);
        });
    }
  }, [type, watch("Meeting")]);
  /* Отслеживаем изменение ответственного и собраний (Мои задачи- Действия) - END */

  /* Отслеживаем изменение полей в карточке Действия (Мои задачи) - START */
  useEffect(() => {
    if (
      type === "action_card" &&
      fieldsForm
        .filter((field: any) => !field.hide)
        .some((field: any) => dirtyFields[field.key])
    ) {
      setEditDataForm(true);
    }
    if (watch("DateForDone") && !watch("DateForDone")["startDate"]) {
      setValue("DateForDone", null);
    }
  }, [
    ...fieldsForm
      .filter((field: any) => !field.hide)
      .map((field: any) => watch(field.key)),
    type,
    updateRepeaterField,
  ]);
  /* Отслеживаем изменение полей в карточке Действия (Мои задачи) - END */

  /* Отслеживаем изменение полей в форме комментария в карточке действия (Мои задачи) - START */
  useEffect(() => {
    if (
      type === "add_comment" &&
      (dirtyFields["TextComment"] || dirtyFields["CommentFiles"])
    ) {
      setEditDataForm(true);
    }
  }, [type, watch("TextComment"), watch("CommentFiles")]);
  /* Отслеживаем изменение полей в форме комментария в карточке действия (Мои задачи) - START */

  /* Отслеживаем изменение полей в форме несоответствия/инцидента (Мои задачи) - START */
  useEffect(() => {
    if (
      type === "add_my_tasks_inc" ||
      type === "inc_card_my_tasks" ||
      type === "filter_my_tasks_inc" ||
      type === "add_my_tasks_inc_security" ||
      type === "inc_security_card_my_tasks" ||
      type === "filter_report_my_tasks_inc" ||
      type === "add_my_tasks_audit" ||
      type === "audit_card_my_tasks" ||
      type === "audit_filters_my_tasks"
    ) {
      setDependenceFields &&
        setDependenceFields({
          Location: watch("Location"),
          Department: watch("Department"),
          Region: watch("Region"),
        });
    }
  }, [type, watch("Location"), watch("Department"), watch("Region")]);

  useEffect(() => {
    if (
      (type === "add_my_tasks_inc" ||
        type === "inc_card_my_tasks" ||
        type === "add_my_tasks_inc_security" ||
        type === "inc_security_card_my_tasks" ||
        type === "filter_report_my_tasks_inc" ||
        type === "add_my_tasks_audit" ||
        type === "audit_card_my_tasks" ||
        type === "audit_filters_my_tasks") &&
      dirtyFields["Location"]
    ) {
      setValue("Department", null);
      setValue("Region", null);
    }
  }, [type, watch("Location")]);

  useEffect(() => {
    if (
      (type === "add_my_tasks_inc" ||
        type === "inc_card_my_tasks" ||
        type === "add_my_tasks_inc_security" ||
        type === "inc_security_card_my_tasks" ||
        type === "filter_report_my_tasks_inc" ||
        type === "add_my_tasks_audit" ||
        type === "audit_card_my_tasks" ||
        type === "audit_filters_my_tasks") &&
      dirtyFields["Department"]
    ) {
      setValue("Region", null);
    }
  }, [type, watch("Department")]);

  useEffect(() => {
    if (
      type === "add_my_tasks_inc" ||
      type === "inc_card_my_tasks" ||
      type === "filter_my_tasks_inc" ||
      type === "filter_report_my_tasks_inc"
    ) {
      if (watch("TypeIncident")) {
        if (type === "filter_my_tasks_inc") {
          if (dirtyFields["TypeIncident"]) {
            setCurrentTypeInc(`${watch("TypeIncident")}_${Math.random()}`);
          }
        } else {
          setCurrentTypeInc(watch("TypeIncident"));
        }
      }
    }
  }, [type, watch("TypeIncident")]);

  useEffect(() => {
    if (
      (type === "add_my_tasks_inc" || type === "inc_card_my_tasks") &&
      watch("DateIncidents") &&
      watch("DateIncidents").startDate
    ) {
      let tempCloseDate =
        (typeof watch("DateIncidents").startDate === "string" &&
          new Date(watch("DateIncidents").startDate)) ||
        watch("DateIncidents").startDate;
      if (watch("IncidentOption") === "Инцидент") {
        if (watch("TypeIncident") === "Безопасность") {
          //1
          const days = Number(
            params
              .find((param: any) => param.Key === "IncSafeDate")
            ["Value"].trim(),
          );
          setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
        }
        if (watch("TypeIncident") === "Экология") {
          //2
          const days = Number(
            params
              .find((param: any) => param.Key === "IncEnvDate")
            ["Value"].trim(),
          );
          setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
        }
        if (watch("TypeIncident") === "Качество") {
          //3
          if (watch("QAIncidentType") === "Инцидент по качеству") {
            const days = Number(
              params
                .find((param: any) => param.Key === "IncQualityDate")
              ["Value"].trim(),
            );
            setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
          }
          if (watch("QAIncidentType") === "Инцидент в процессе") {
            const days = Number(
              params
                .find((param: any) => param.Key === "IncProcessDate")
              ["Value"].trim(),
            );
            setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
          }
        }
        if (watch("TypeIncident") === "Техобслуживание") {
          //4
          const days = Number(
            params
              .find((param: any) => param.Key === "IncMDate")
            ["Value"].trim(),
          );
          setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
        }
      }
      if (watch("IncidentOption") === "Несоответствие") {
        if (watch("TypeIncident") === "Безопасность") {
          //1
          const days = Number(
            params
              .find((param: any) => param.Key === "NSafeDate")
            ["Value"].trim(),
          );
          setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
        }
        if (watch("TypeIncident") === "Экология") {
          //2
          const days = Number(
            params
              .find((param: any) => param.Key === "NEnvDate")
            ["Value"].trim(),
          );
          setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
        }
        if (watch("TypeIncident") === "Качество") {
          //3
          const days = Number(
            params
              .find((param: any) => param.Key === "NQualityDate")
            ["Value"].trim(),
          );
          setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
        }
        if (watch("TypeIncident") === "Техобслуживание") {
          //4
          const days = Number(
            params.find((param: any) => param.Key === "NMDate")["Value"].trim(),
          );
          setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
        }
      }
    }
  }, [
    type,
    watch("TypeIncident"),
    watch("IncidentOption"),
    watch("QAIncidentType"),
    watch("DateIncidents"),
  ]);

  useEffect(() => {
    if (
      (type === "add_my_tasks_inc_security" ||
        type === "inc_security_card_my_tasks") &&
      watch("DateIncidents") &&
      watch("DateIncidents").startDate
    ) {
      let tempCloseDate =
        (typeof watch("DateIncidents").startDate === "string" &&
          new Date(watch("DateIncidents").startDate)) ||
        watch("DateIncidents").startDate;
      const days = Number(
        params
          .find((param: any) => param.Key === "IncSecurityDate")
        ["Value"].trim(),
      );
      setClosedDateInc(moment(tempCloseDate).add(days, "days").toDate());
    }
  }, [type, watch("DateIncidents")]);

  useEffect(() => {
    if (
      (type === "add_my_tasks_inc_security" ||
        (type === "inc_security_card_my_tasks" &&
          dirtyFields["SecurityTypeIncident"])) &&
      watch("SecurityTypeIncident")
    ) {
      setValue("SecuritySubtypeIncident", null);
    }
  }, [type, watch("SecurityTypeIncident")]);

  useEffect(() => {
    if (
      type === "add_my_tasks_inc_security" ||
      type === "inc_security_card_my_tasks"
    ) {
      let riskSecurity = 0;
      if (
        watch("SecurityStateInvolved") &&
        watch("SecurityStateInvolved") === "Да"
      )
        riskSecurity += 1 * 5;
      if (
        watch("SecurityMediaInvolved") &&
        watch("SecurityMediaInvolved") === "Да"
      )
        riskSecurity += 1 * 15;
      if (
        watch("SecurityStateInvolved") &&
        watch("SecurityStateInvolved") === "Нет"
      )
        riskSecurity += 0;
      if (
        watch("SecurityMediaInvolved") &&
        watch("SecurityMediaInvolved") === "Нет"
      )
        riskSecurity += 0;
      if (
        watch("SecurityHumanRisks") &&
        watch("SecurityHumanRisks")["name"] === "Нет"
      ) {
        riskSecurity += 0;
      } else if (
        watch("SecurityHumanRisks") &&
        (watch("SecurityHumanRisks")["name"] === "Лёгкая травма" ||
          watch("SecurityHumanRisks")["name"] === "Другое")
      ) {
        riskSecurity += 0.5 * 40;
      } else if (watch("SecurityHumanRisks")) {
        riskSecurity += 1 * 40;
      }
      if (
        watch("SecurityDamageCount") &&
        Number(watch("SecurityDamageCount")) <= 500000
      ) {
        riskSecurity += 0;
      } else if (
        watch("SecurityDamageCount") &&
        Number(watch("SecurityDamageCount")) > 500000 &&
        Number(watch("SecurityDamageCount")) <= 10000000
      ) {
        riskSecurity += 0.5 * 40;
      } else if (watch("SecurityDamageCount")) {
        riskSecurity += 1 * 40;
      }
      setValue("SecurityRisk", riskSecurity);
    }
  }, [
    type,
    watch("SecurityStateInvolved"),
    watch("SecurityMediaInvolved"),
    watch("SecurityHumanRisks"),
    watch("SecurityDamageCount"),
  ]);

  useEffect(() => {
    let currentData: any = {};
    if (
      type === "add_my_tasks_inc" ||
      type === "add_my_tasks_inc_security" ||
      type === "filter_my_tasks_inc" ||
      type === "filter_report_my_tasks_inc" ||
      ((type === "inc_card_my_tasks" ||
        type === "inc_security_card_my_tasks") &&
        (fieldsForm
          .filter((field: any) => !field.hide)
          .some((field: any) => dirtyFields[field.key]) ||
          updateRepeaterField))
    ) {
      fieldsForm
        .filter((field: any) => !field.hide)
        .map((field: any) => {
          currentData[field.key] = getValues()[field.key];
          register(field.key, { required: field.require });
        });

      const currentValues = getValues(); // все текущие поля, зарегистрированные ранее
      const currentNames = Object.keys(currentValues);
      const validNames = fieldsForm.filter((f) => !f.hide).map((f) => f.key);
      // Убираем все старые, которых больше нет
      currentNames.forEach((name) => {
        if (!validNames.includes(name)) {
          unregister(name);
        }
      });
    }
    if (type === "add_my_tasks_inc" || type === "add_my_tasks_inc_security") {
      setCurrentFormData({ ...currentData });
    }
    if (
      type === "filter_my_tasks_inc" ||
      type === "filter_report_my_tasks_inc"
    ) {
      setFormData({ ...currentData });
    }
    if (
      (type === "inc_card_my_tasks" || type === "inc_security_card_my_tasks") &&
      (fieldsForm
        .filter((field: any) => !field.hide)
        .some((field: any) => dirtyFields[field.key]) ||
        updateRepeaterField)
    ) {
      setEditDataForm(true);
      setCurrentFormData({ ...currentData });
    }
  }, [
    ...fieldsForm
      .filter((field: any) => !field.hide)
      .map((field: any) => watch(field.key)),
    type,
    updateRepeaterField,
  ]);
  /* Отслеживаем изменение полей в форме несоответствия/инцидента (Мои задачи) - END */

  /* Отслеживаем изменение полей в форме аудита (Мои задачи) - START */
  useEffect(() => {
    if (
      (type === "add_my_tasks_audit" || type === "audit_card_my_tasks") &&
      dirtyFields["ObservedType"]
    ) {
      setObservedType(watch("ObservedType").name);
      if (watch("ObservedType").name === "Внутренний") {
        unregister("ObservedString");
        register("ObservedUser", { required: true });
        setValue("ObservedUser", null);
      }
      if (watch("ObservedType").name === "Внешний") {
        unregister("ObservedUser");
        register("ObservedString", { required: true });
        setValue("ObservedString", null);
      }
    }
  }, [type, watch("ObservedType")]);

  useEffect(() => {
    let currentData: any = {};
    if (type === "add_my_tasks_audit" || type === "audit_card_my_tasks") {
      fieldsForm
        .filter((field: any) => !field.hide)
        .map((field: any) => {
          currentData[field.key] = getValues()[field.key];
          register(field.key, { required: field.require });
        });

      const currentValues = getValues(); // все текущие поля, зарегистрированные ранее
      const currentNames = Object.keys(currentValues);
      const validNames = fieldsForm.filter((f) => !f.hide).map((f) => f.key);
      // Убираем все старые, которых больше нет
      currentNames.forEach((name) => {
        if (!validNames.includes(name)) {
          unregister(name);
        }
      });
      if ((type === "audit_card_my_tasks" && (Object.keys(defaultValues).some((key: string) => dirtyFields[key]) ||
        dirtyFields["AuditFiles"]))) {
        setEditDataForm(true);
      }
      setCurrentFormData && setCurrentFormData({ ...currentData });
    }
  }, [
    ...fieldsForm
      .filter((field: any) => !field.hide)
      .map((field: any) => watch(field.key)),
    type,
  ]);
  /* Отслеживаем изменение полей в пов. аудите (Мои задачи) - END */

  /* Отслеживаем изменение фильтров - START */
  useEffect(() => {
    if (
      type === "list5way_filters_my_tasks" ||
      type === "audit_filters_my_tasks" ||
      type === "report_documents_filters"
    ) {
      let currentData: any = {};
      fieldsForm
        .filter((field: any) => !field.hide)
        .map((field: any) => {
          if (getValues()[field.key]) {
            currentData[field.key] = getValues()[field.key];
          }
        });
      setFormData({ ...currentData });
    }
  }, [
    ...fieldsForm
      .filter((field: any) => !field.hide)
      .map((field: any) => watch(field.key)),
    type,
  ]);

  useEffect(() => {
    if (type === "list5way_filters_my_tasks") {
      setDependenceFields &&
        setDependenceFields({
          Location: watch("Location"),
          Department: watch("Department"),
          Region: watch("Region"),
          Trigger: watch("Trigger"),
          KPI: watch("KPI"),
        });
    }
  }, [
    type,
    watch("Location"),
    watch("Department"),
    watch("Region"),
    watch("Trigger"),
    watch("KPI"),
  ]);
  /* Отслеживаем изменение фильтров - END */

  useEffect(() => {
    if (type === "report_documents_filters") {
      setDependenceFields &&
        setDependenceFields({
          Collection: watch("Collection"),
          Department: watch("Department"),
          Sector: watch("Sector"),
          Process: watch("Process"),
        });
    }
  }, [
    type,
    watch("Collection"),
    watch("Department"),
    watch("Sector"),
    watch("Process"),
  ]);
  /* Отслеживаем изменение фильтров в Отчете по документам - END */

  /* Отслеживаем изменение полей в 5Почему и Отчете об отклонениях (Мои задачи) - START */
  useEffect(() => {
    if (type === "add_my_tasks_5way" || type === "5way_card_my_tasks" || type === 'add_my_tasks_trigger' || type === 'card_my_tasks_trigger') {
      setDependenceFields &&
        setDependenceFields({
          Location: watch("Location"),
          Department: watch("Department"),
          Region: watch("Region"),
          Trigger: watch("Trigger"),
        });
    }
  }, [
    type,
    watch("Location"),
    watch("Department"),
    watch("Region"),
    watch("Trigger"),
  ]);

  useEffect(() => {
    if (
      (type === "add_my_tasks_5way" || type === "5way_card_my_tasks" || type === 'add_my_tasks_trigger' || type === 'card_my_tasks_trigger') &&
      dirtyFields["Location"]
    ) {
      setValue("Department", null);
      setValue("Region", null);
      if (type === 'add_my_tasks_trigger' || type === 'card_my_tasks_trigger') {
        setValue("Trigger", "");
      } else {
        setValue("Trigger", null);
      }
    }
  }, [type, watch("Location")]);

  useEffect(() => {
    if (
      (type === "add_my_tasks_5way" || type === "5way_card_my_tasks" || type === 'add_my_tasks_trigger' || type === 'card_my_tasks_trigger') &&
      dirtyFields["Department"]
    ) {
      setValue("Region", null);
      if (type === 'add_my_tasks_trigger' || type === 'card_my_tasks_trigger') {
        setValue("Trigger", "");
      } else {
        setValue("Trigger", null);
      }
    }
  }, [type, watch("Department")]);

  useEffect(() => {
    if (
      (type === "add_my_tasks_5way" || type === "5way_card_my_tasks" || type === 'add_my_tasks_trigger' || type === 'card_my_tasks_trigger') &&
      dirtyFields["Region"]
    ) {
      if (type === 'add_my_tasks_trigger' || type === 'card_my_tasks_trigger') {
        setValue("Trigger", "");
      } else {
        setValue("Trigger", null);
      }
    }
  }, [type, watch("Region")]);

  useEffect(() => {
    if (type === "add_my_tasks_5way" || type === "5way_card_my_tasks") {
      setDependenceFields5Way &&
        setDependenceFields5Way({
          Trigger: watch("Trigger"),
        });
    }
  }, [type, watch("Trigger")]);

  useEffect(() => {
    if (type === "add_my_tasks_5way" || type === "5way_card_my_tasks") {
      setValue("KPI", kpi);
    }
  }, [type, kpi]);

  useEffect(() => {
    if (type === "5way_card_my_tasks" && dirtyFields["Details"]) {
      setDetailProblem(watch("Details"));
    }
  }, [type, watch("Details")]);

  useEffect(() => {
    if (type === "5way_card_my_tasks") {
      if (editDataForm) {
        setEditCardFiveWhy(true);
      } else {
        setEditCardFiveWhy(false);
      }
    }
  }, [type, editDataForm])

  useEffect(() => {
    if (
      (type === "5way_card_my_tasks" || type === "add_my_tasks_5way" || type === 'card_my_tasks_trigger') &&
      Object.keys(defaultValues).some((key: string) => dirtyFields[key])
    ) {
      setEditDataForm(true);
    }
  }, [
    type,
    watch("Date5Way"),
    watch("Location"),
    watch("Department"),
    watch("Region"),
    watch("Trigger"),
    watch("KPI"),
    watch("Kpi"),
    watch("Editors"),
    watch("Description"),
    watch("Details"),
    watch("Actions"),
    watch("ProblemRepeat"),
    watch("Plan"),
    watch("ProblemsCount")
  ]);

  useEffect(() => {
    if ((type === "5way_card_my_tasks" || type === "add_my_tasks_5way")) {
      if (watch("ProblemRepeat") && watch("ProblemRepeat")['id'] === 1) {
        setProblevRepeatCounShow(true);
      } else {
        setProblevRepeatCounShow(false);
        setValue('ProblemsCount', 1);
      }
    }
  }, [
    type,
    watch("ProblemRepeat")
  ]);
  /* Отслеживаем изменение полей в 5Почему и Отчете об отклонениях (Мои задачи) - END */


  const UploadFilesComponent =
    isMobile5WayCard || isMobileDocumentCard || isMobilePovAuditCard || isMobileIncCard ? UploadFilesMobile : UploadFiles;
  const canRender5WayLinkedBlocks = Number(ID5WayAdd) > 0;
  const card5WayTreeSafe = Array.isArray(card5WayTree) ? card5WayTree : [];

  useEffect(() => {
    //console.log("fieldsForm: ", fieldsForm);
  }, [fieldsForm]);

  const handleDocumentClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isMobileDocumentCard) {
      e.preventDefault();
      window.location.href = `/dashboard/1?documentCardMobile=${card.ID}&version=${activeVersion}`;
    }
  };


  return (
    <>
      {(customLoading && (
        <FlexCol className="items-center justify-center w-full">
          <span className="block mb-5 text-base text-darkblue">
            Идет обработка данных.
            <br />
            Пожалуйста подождите...
          </span>
          <Loading />
        </FlexCol>
      )) || (
          <>
            {type === "5way_card_my_tasks" && (
              <FlexRow className="justify-between w-full gap-5 mb-5">
                {/* {!editDataForm && (
                  <Button
                    classBg="btn-white"
                    shadow={true}
                    text="Выйти из режима редактирования"
                    customFunction={removeEditorHandle}
                    paramsCustomFunction={Number(ID5WayAdd)}
                  />
                )} */}
                <FlexRow className={`gap-5 justify-between ${editDataForm ? "w-full" : ""}`}>
                  {editDataForm && (
                    <>
                      <Button
                        classBg="btn-white"
                        shadow={true}
                        text="Отменить изменения"
                        customFunction={resetDefaultValuesHandle}
                        paramsCustomFunction={Number(ID5WayAdd)}
                      />
                      <FlexRow className="gap-5">
                        {/* {extraButtonText && extraButtonAction &&
                          <Button
                            classBg="btn-white"
                            shadow={true}
                            text={extraButtonText}
                            customFunction={extraButtonAction}
                          />
                        } */}
                        {(Object.keys(errors).length > 0 && (
                          <TooltipItem
                            position="left"
                            tooltipsText={
                              "Пожалуйста, заполните все обязательные поля"
                            }
                          >
                            <Button
                              classBg="btn-dark"
                              text="Сохранить"
                              disabled={true}
                            />
                          </TooltipItem>
                        )) || (
                            <Button
                              classBg="btn-dark"
                              text="Сохранить"
                              submit={true}
                              form={type}
                            />
                          )}
                      </FlexRow>
                    </>
                  )}
                  {/* {extraButtonText && extraButtonAction && !editDataForm &&
                    <Button
                      classBg="btn-white"
                      shadow={true}
                      text={extraButtonText}
                      customFunction={extraButtonAction}
                    />
                  } */}
                </FlexRow>
              </FlexRow>
            )}
            {type === "card" && card && activeVersion && !versionView &&
              <div className="flex flex-col tablet:flex-row items-center tablet:items-start justify-center w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5 mb-5">
                У данного документа создана&nbsp;<a className="text-[#012169] underline font-semibold" href={`${siteUrl}/dashboard/1?${isMobileDocumentCard ? 'documentCardMobile' : 'documentCard'}=${card.ID}&version=${activeVersion}`} {...(!isMobileDocumentCard && { target: '_blank' })} onClick={handleDocumentClick}>новая версия</a>
              </div> || <></>
            }
            <form
              id={type}
              className={twMerge(
                "flex flex-row flex-wrap justify-between w-full custom-form",
                type === "action_card" &&
                  isMobileActionCard &&
                  "pb-[calc(env(safe-area-inset-bottom)+120px)]"
              )}
              onSubmit={handleSubmit(onSubmit)}
            >
              {fieldsForm.map((fieldItem) => (
                <Fragment key={fieldItem.key}>
                  {fieldItem.type === "file" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <UploadFilesComponent
                          setImagesDoc={setImagesDoc}
                          openRemoveFileCommentModal={openRemoveFileCommentModal}
                          setOpenRemoveFileCommentModal={
                            setOpenRemoveFileCommentModal
                          }
                          listUploadFiles={listUploadFiles}
                          setIdRemoveElem={setIdRemoveElem}
                          type={type}
                          errors={errors}
                          value={field.value}
                          dataField={fieldItem}
                          documentCode={
                            type === "card" && card && `${card.Code}.${card.Index}`
                          }
                          documentID={
                            type === "card" && card &&
                            ((versionView && card.MainDocument.get_lookupId()) || card.ID)
                          }
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "checkbox" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <Checkbox
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value || []}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "editors" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <Editors
                          zIndex={zIndex}
                          type={type}
                          defaultValues={defaultValues.Editors}
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                          isMobile={isMobile5WayCard}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "radio" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <Radio
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "input" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <Input
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "grade" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <Grade
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "time" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <TimeField
                          type={type}
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "timeRange" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <TimeRange
                          type={type}
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "numberRange" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <NumberRange
                          type={type}
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "number" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <NumberInput
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "textArea" && !fieldItem.hide && (
                    <>
                      <Controller
                        name={fieldItem.key}
                        control={control}
                        rules={{
                          required: fieldItem.require,
                          maxLength:
                            ((type === "add_my_tasks_5way" ||
                              type === "5way_card_my_tasks") &&
                              fieldItem.key === "Description" &&
                              254) ||
                            5000,
                          validate: (v) =>
                            v && /^#[\p{L}\p{N}_]+$/u.test(v.trim())
                              ? ((type === 'add_action_in_modal' ||
                                type === 'add_action_in_component' ||
                                type === 'action_card') &&
                                'Поле не может состоять только из хештега (пробелы игнорируются)')
                              : true,
                        }}
                        render={({ field }) => (
                          <TextArea
                            maxLength={
                              ((type === "add_my_tasks_5way" ||
                                type === "5way_card_my_tasks") &&
                                fieldItem.key === "Description" &&
                                254) ||
                              5000
                            }
                            errors={errors}
                            dataField={fieldItem}
                            value={field.value}
                            onChange={(value: any) => field.onChange(value)}
                          />
                        )}
                      />
                      {type === "action_card" &&
                        fieldItem.key === "Description" &&
                        cardWithActionType === "actionCard5S" && (
                          <div className="grid grid-cols-2 gap-5 mb-5">
                            <div className="w-full">
                              <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                                <span>Шаг</span>
                              </label>
                              <div className="relative mt-2">
                                <div className="block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 outline-none shadow-custom cursor-not-allowed text-[#6B7280] bg-[#E5E7EB]">
                                  {section5S || "—"}
                                </div>
                              </div>
                            </div>
                            <div className="w-full">
                              <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                                <span>Вопрос/Требование</span>
                              </label>
                              <div className="relative mt-2">
                                <TooltipItem
                                  tooltipsText={stripMarkdown(questionTitle5S)}
                                  position="top"
                                  cursor={false}
                                  disable={!questionTitle5S}
                                  wrapperClassName="block w-full"
                                  textClassName="block whitespace-pre-wrap w-[30vw]"
                                >
                                  <div className="block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5 outline-none shadow-custom cursor-not-allowed text-[#6B7280] bg-[#E5E7EB] truncate">
                                    {stripMarkdown(questionTitle5S) || "—"}
                                  </div>
                                </TooltipItem>
                              </div>
                            </div>
                          </div>
                        )}
                      {type === "action_card" &&
                        fieldItem.key === "Description" &&
                        inconsistencesText && (
                          <div className={`w-full mb-5`}>
                            <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                              <span>Несоответствие</span>
                            </label>
                            <div className="relative mt-2">
                              <div
                                className={`block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5  outline-none shadow-custom  cursor-not-allowed text-[#6B7280] bg-[#E5E7EB]`}
                                dangerouslySetInnerHTML={{
                                  __html: inconsistencesText,
                                }}
                              />
                            </div>
                          </div>
                        )}
                      {type === "action_card" &&
                        fieldItem.key === "Description" &&
                        cardWithActionType === "actionCard5S" &&
                        Array.isArray(files5S) &&
                        files5S.length > 0 && (
                          <div className="w-full mb-5">
                            <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                              <span>Вложения</span>
                            </label>
                            <div className="mt-2 flex flex-col gap-2">
                              {files5S.map((f: any, i: number) => {
                                const file = f?.File;
                                const name = file?.name || f?.Title || "Файл";
                                const sizeLabel = file?.size
                                  ? file.size >= 1024
                                    ? `${(file.size / 1024).toFixed(1)}MB`
                                    : `${Math.round(file.size)}KB`
                                  : "";
                                const rawUrl = file?.url || "";
                                return (
                                  <div
                                    key={f?.id ?? i}
                                    className="flex items-center justify-between rounded-md border border-[#DFE4EA] py-2.5 px-4 bg-[#E5E7EB]"
                                  >
                                    <span className="flex items-center gap-2 min-w-0 text-sm text-[#1C252E]">
                                      <DocumentIcon className="w-5 h-5 flex-shrink-0 text-[#637381]" />
                                      <span className="truncate">
                                        {name}
                                        {sizeLabel && ` (${sizeLabel})`}
                                      </span>
                                    </span>
                                    {rawUrl && (
                                      <button
                                        type="button"
                                        onClick={() => {
                                          const fileUrl = rawUrl.includes(s3cloudUrl)
                                            ? `${siteUrl}/${new URL(rawUrl).pathname.slice(1)}`
                                            : `${siteUrl}${rawUrl}`;
                                          const link = document.createElement("a");
                                          link.href = fileUrl;
                                          link.download = name || "downloaded-file";
                                          link.style.display = "none";
                                          document.body.appendChild(link);
                                          link.click();
                                          document.body.removeChild(link);
                                        }}
                                        className="ml-3 flex-shrink-0 text-[#637381] hover:text-darkblue [&>svg]:w-5 [&>svg]:h-5"
                                      >
                                        <DownloadIcon />
                                      </button>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                    </>
                  )}
                  {fieldItem.type === "select" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <Select
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                          type={type}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "autocomplete" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <Autocomplete
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "checkbox_search" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <CheckboxSearch
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "peoplePicker" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <PeoplePicker
                          type={type}
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "date" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <DateField
                          type={type}
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          setValue={setValue}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "dateRange" && !fieldItem.hide && (
                    <Controller
                      name={fieldItem.key}
                      control={control}
                      rules={{ required: fieldItem.require }}
                      render={({ field }) => (
                        <DateRangeField
                          type={type}
                          errors={errors}
                          dataField={fieldItem}
                          value={field.value}
                          onChange={(value: any) => field.onChange(value)}
                        />
                      )}
                    />
                  )}
                  {fieldItem.type === "repeater" && !fieldItem.hide && (
                    <Repeater
                      setIdRemoveElem={setIdRemoveElem}
                      type={type}
                      questionsInc={incCard && incCard.Questions}
                      watch={watch}
                      errors={errors}
                      dataField={fieldItem}
                      control={control}
                      useWatch={useWatch}
                      updateRepeaterField={updateRepeaterField}
                      setUpdateRepeaterField={setUpdateRepeaterField}
                      isMobileDocumentCard={isMobileDocumentCard}
                    />
                  )}
                  {fieldItem.type === "text" && !fieldItem.hide && (
                    <Text dataField={fieldItem} />
                  )}
                </Fragment>
              ))}
              {(type === "add_card" || type === "approvers_list") && (
                <div className="flex justify-between w-full">
                  {type === "add_card" && (
                    <Button
                      open={openCancelAddCard}
                      setOpen={setOpenCancelAddCard}
                      classBg="btn-white"
                      shadow={true}
                      text="Отмена"
                    />
                  )}
                  {type === "approvers_list" && (
                    <Button
                      open={backStep}
                      setOpen={setBackStep}
                      classBg="btn-white"
                      shadow={true}
                      text="Назад"
                    />
                  )}
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      position="left"
                      tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                    >
                      <Button
                        classBg="btn-dark"
                        text={textButtonSubmit || "Продолжить"}
                        disabled={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button
                        classBg="btn-dark"
                        text={textButtonSubmit || "Продолжить"}
                        submit={true}
                      />
                    )}
                </div>
              )}
              {type === "report_my_tasks_inc_send_emails" && (
                <div className="flex justify-between w-full">
                  <Button
                    open={openCancelAddCard}
                    setOpen={setOpenCancelAddCard}
                    classBg="btn-white"
                    shadow={true}
                    text="Отмена"
                  />
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      position="left"
                      tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                    >
                      <Button
                        classBg="btn-dark"
                        text="Скачать отчет"
                        disabled={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button
                        classBg="btn-dark"
                        text="Скачать отчет"
                        submit={true}
                      />
                    )}
                </div>
              )}
              {type === "card" && changesButtonsFlag && (
                <>
                  <div className="flex justify-between w-full">
                    {card && (card.Status.get_lookupId() === docStatuses.revision ||
                      card.Status.get_lookupId() === docStatuses.cancel) && (
                        <>
                          {(editDataForm && (
                            <Button
                              classBg="btn-white"
                              shadow={true}
                              text={textButtonCancel}
                              customFunction={resetDefaultValuesHandle}
                              paramsCustomFunction={defaultValues.ID}
                            />
                          )) || (
                              <Button
                                open={openCancelAddCard}
                                setOpen={setOpenCancelAddCard}
                                classBg="btn-white"
                                shadow={true}
                                text={textButtonCancel}
                              />
                            )}
                          <div className="flex items-center gap-2">
                            {(card && (currentUser.isAdmin ||
                              currentUser.email === card.AuthorEmail.toLowerCase() || currentUser.email === card.ResponsibleForRevisionEmail.toLowerCase())) && (
                                <Button
                                  open={removeDocument}
                                  setOpen={setRemoveDocument}
                                  classBg="btn-white"
                                  shadow={true}
                                  icon={true}
                                  typeIcon="remove"
                                  text="Удалить эту версию"
                                />
                              )}
                            {(Object.keys(errors).length > 0 && (
                              <>
                                {(currentUser.isAdmin ||
                                  currentUser.email === card.AuthorEmail.toLowerCase()) &&
                                  <TooltipItem
                                    position="left"
                                    tooltipsText={
                                      "Пожалуйста, заполните все обязательные поля"
                                    }
                                  >
                                    <Button
                                      classBg="btn-dark"
                                      text="Отправить на согласование"
                                      disabled={true}
                                    />
                                  </TooltipItem>
                                }
                              </>
                            )) || ((currentUser.isAdmin ||
                              currentUser.email === card.AuthorEmail.toLowerCase()) &&
                              <Button
                                classBg="btn-dark"
                                text="Отправить на согласование"
                                submit={true}
                                dataAttribute="agreement"
                              />
                              )}
                          </div>
                        </>
                      )}
                    {card && card.Status.get_lookupId() === docStatuses.archive && (
                      <>
                        <>
                          {editDataForm && (
                            <>
                              <Button
                                classBg="btn-white"
                                shadow={true}
                                text={textButtonCancel}
                                customFunction={resetDefaultValuesHandle}
                                paramsCustomFunction={defaultValues.ID}
                              />
                              {(createVersion && (
                                <>
                                  {(Object.keys(errors).length > 0 && (
                                    <TooltipItem
                                      position="left"
                                      tooltipsText={
                                        "Пожалуйста, заполните все обязательные поля"
                                      }
                                    >
                                      <Button
                                        classBg="btn-dark"
                                        text="Разархивировать и отправить на согласование"
                                        disabled={true}
                                      />
                                    </TooltipItem>
                                  )) || (
                                      <Button
                                        classBg="btn-dark"
                                        text="Разархивировать и отправить на согласование"
                                        submit={true}
                                        dataAttribute="archive"
                                      />
                                    )}
                                </>
                              )) || (
                                  <Button
                                    classBg="btn-dark"
                                    text="Разархивировать и отправить на согласование"
                                    submit={false}
                                    open={sendApproveBlock}
                                    setOpen={setSendApproveBlock}
                                  />
                                )}
                            </>
                          )}
                        </>
                      </>
                    )}
                    {card && (card.Status.get_lookupId() === docStatuses.public ||
                      card.Status.get_lookupId() === docStatuses.review) && (
                        <>
                          <>
                            {editDataForm && (
                              <>
                                <Button
                                  classBg="btn-white"
                                  shadow={true}
                                  text={textButtonCancel}
                                  customFunction={resetDefaultValuesHandle}
                                  paramsCustomFunction={defaultValues.ID}
                                />
                                {(createVersion && (
                                  <>
                                    {(Object.keys(errors).length > 0 && (
                                      <TooltipItem
                                        position="left"
                                        tooltipsText={
                                          "Пожалуйста, заполните все обязательные поля"
                                        }
                                      >
                                        <Button
                                          classBg="btn-dark"
                                          text="Отправить на согласование"
                                          disabled={true}
                                        />
                                      </TooltipItem>
                                    )) || (
                                        <Button
                                          classBg="btn-dark"
                                          text="Отправить на согласование"
                                          submit={true}
                                          dataAttribute="draft"
                                        />
                                      )}
                                  </>
                                )) || (
                                    <Button
                                      classBg="btn-dark"
                                      text="Отправить на согласование"
                                      submit={false}
                                      open={sendApproveBlock}
                                      setOpen={setSendApproveBlock}
                                    />
                                  )}
                              </>
                            )}
                          </>
                        </>
                      )}
                    {card && card.Status.get_lookupId() === docStatuses.approval && (
                      <>
                        {((currentUserRole.admin ||
                          currentUserRole.approver) && (
                            <>
                              {(editDataForm && (
                                <Button
                                  classBg="btn-white"
                                  shadow={true}
                                  text={textButtonCancel}
                                  customFunction={resetDefaultValuesHandle}
                                  paramsCustomFunction={defaultValues.ID}
                                />
                              )) || (
                                  <Button
                                    open={openCancelAddCard}
                                    setOpen={setOpenCancelAddCard}
                                    classBg="btn-white"
                                    shadow={true}
                                    text={textButtonCancel}
                                  />
                                )}
                              {(Object.keys(errors).length > 0 && (
                                <TooltipItem
                                  position="left"
                                  tooltipsText={
                                    "Пожалуйста, заполните все обязательные поля"
                                  }
                                >
                                  <Button
                                    classBg="btn-dark"
                                    text="Отправить на доработку"
                                    disabled={true}
                                    icon={true}
                                    typeIcon="revision"
                                  />
                                </TooltipItem>
                              )) || (
                                  <Button
                                    classBg="btn-dark"
                                    text="Отправить на доработку"
                                    submit={true}
                                    icon={true}
                                    typeIcon="revision"
                                    dataAttribute="modification"
                                  />
                                )}
                            </>
                          )) ||
                          (!currentUserRole.admin &&
                            !currentUserRole.approver &&
                            currentUserRole.author &&
                            editDataForm && (
                              <>
                                {(editDataForm && (
                                  <Button
                                    classBg="btn-white"
                                    shadow={true}
                                    text={textButtonCancel}
                                    customFunction={resetDefaultValuesHandle}
                                    paramsCustomFunction={defaultValues.ID}
                                  />
                                )) || (
                                    <Button
                                      open={openCancelAddCard}
                                      setOpen={setOpenCancelAddCard}
                                      classBg="btn-white"
                                      shadow={true}
                                      text={textButtonCancel}
                                    />
                                  )}
                                {(Object.keys(errors).length > 0 && (
                                  <TooltipItem
                                    position="left"
                                    tooltipsText={
                                      "Пожалуйста, заполните все обязательные поля"
                                    }
                                  >
                                    <Button
                                      classBg="btn-dark"
                                      text="Отправить на согласование"
                                      disabled={true}
                                    />
                                  </TooltipItem>
                                )) || (
                                    <Button
                                      classBg="btn-dark"
                                      text="Отправить на согласование"
                                      submit={true}
                                      dataAttribute="agreement"
                                    />
                                  )}
                              </>
                            ))}
                      </>
                    )}
                  </div>
                </>
              )}
              {type === "card" && revisionButtonsFlag && (
                <>
                  <div className="flex justify-between w-full">
                    {editDataForm && (
                      <>
                        <Button
                          classBg="btn-white"
                          shadow={true}
                          text={textButtonCancel}
                          customFunction={resetDefaultValuesHandle}
                          paramsCustomFunction={defaultValues.ID}
                        />
                        {(Object.keys(errors).length > 0 && (
                          <TooltipItem
                            position="left"
                            tooltipsText={
                              "Пожалуйста, заполните все обязательные поля"
                            }
                          >
                            <Button
                              classBg="btn-dark"
                              text="Сохранить изменения"
                              disabled={true}
                              dataAttribute="revision"
                            />
                          </TooltipItem>
                        )) || (
                            <Button
                              classBg="btn-dark"
                              text="Сохранить изменения"
                              submit={true}
                              dataAttribute="revision"
                            />
                          )}
                      </>
                    )}
                  </div>
                </>
              )}
              {type === "card" && approveButtonsFlag && !multipleApproveCurrent && !isMobileDocumentCard && (
                <>
                  <div className="flex justify-end w-full">
                    {(Object.keys(errors).length > 0 && (
                      <TooltipItem
                        position="left"
                        tooltipsText={
                          "Пожалуйста, заполните все обязательные поля"
                        }
                      >
                        <Button
                          classBg="btn-red mr-2.5"
                          text="Отклонить"
                          disabled={true}
                          icon={true}
                          typeIcon="cancel"
                        />
                      </TooltipItem>
                    )) || (
                        <Button
                          classBg="btn-red mr-2.5"
                          shadow={true}
                          text="Отклонить"
                          icon={true}
                          submit={true}
                          typeIcon="cancel"
                          dataAttribute="reject"
                        />
                      )}
                    {(Object.keys(errors).length > 0 && (
                      <TooltipItem
                        position="left"
                        tooltipsText={
                          "Пожалуйста, заполните все обязательные поля"
                        }
                      >
                        <Button
                          classBg="btn-dark"
                          text="Согласовать"
                          disabled={true}
                          icon={true}
                          typeIcon="approve"
                        />
                      </TooltipItem>
                    )) || (
                        <Button
                          classBg="btn-dark"
                          text="Согласовать"
                          submit={true}
                          icon={true}
                          typeIcon="approve"
                          dataAttribute="approve"
                        />
                      )}
                  </div>
                </>
              )}
              {multipleApproveCurrent && (
                <div className="flex flex-col items-center justify-center w-full gap-5">
                  Вы уже согласовали этот документ
                </div>
              )}
              {type === "copies" && (
                <div className="flex flex-col items-center justify-center w-full gap-5">
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      wrapperClassName="w-full"
                      position="top"
                      tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                    >
                      <Button
                        classBg="btn-white w-full justify-center"
                        text="Сохранить выданную копию"
                        disabled={true}
                        shadow={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button
                        classBg="btn-white w-full justify-center"
                        text="Сохранить выданную копию"
                        submit={true}
                        shadow={true}
                      />
                    )}
                  <Button
                    open={openCancelAddCard}
                    setOpen={setOpenCancelAddCard}
                    classBg="btn-white w-full justify-center"
                    text="Отмена"
                    shadow={true}
                  />
                </div>
              )}
              {type === "approvers_replaced" && (
                <div className="flex justify-between w-full gap-5">
                  <Button
                    open={openCancelAddCard}
                    setOpen={setOpenCancelAddCard}
                    classBg="btn-white"
                    text="Отмена"
                    shadow={true}
                  />
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      position="top"
                      tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                    >
                      <Button
                        classBg="btn-dark"
                        text="Подтвердить"
                        disabled={true}
                        shadow={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button classBg="btn-dark" text="Подтвердить" submit={true} />
                    )}
                </div>
              )}
              {type === "add_my_tasks_trigger" && (
                <div className="flex justify-between w-full gap-5">
                  <Button
                    open={openCancelAddCard}
                    setOpen={setOpenCancelAddCard}
                    classBg="btn-white"
                    text="Отмена"
                    shadow={true}
                  />
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      position="left"
                      tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                    >
                      <Button
                        classBg="btn-dark"
                        text="Создать"
                        disabled={true}
                        shadow={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button classBg="btn-dark" text="Создать" submit={true} />
                    )}
                </div>
              )}
              {type === "card_my_tasks_trigger" && (
                <div className="flex justify-between w-full gap-5">
                  {editDataForm &&
                    <>
                      <Button
                        classBg="btn-white"
                        shadow={true}
                        text="Отменить изменения"
                        customFunction={resetDefaultValuesHandle}
                        paramsCustomFunction={defaultValues.ID}
                      />
                      {(Object.keys(errors).length > 0 && (
                        <TooltipItem
                          position="top"
                          tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                        >
                          <Button
                            classBg="btn-dark"
                            text={
                              (Object.keys(defaultValues).length > 0 &&
                                "Сохранить изменения") ||
                              "Сохранить"
                            }
                            disabled={true}
                          />
                        </TooltipItem>
                      )) || (
                          <Button
                            classBg="btn-dark"
                            text={
                              (Object.keys(defaultValues).length > 0 &&
                                "Сохранить изменения") ||
                              "Сохранить"
                            }
                            submit={true}
                          />
                        )}
                    </> ||
                    <>
                      <Button
                        open={openCancelAddCard}
                        setOpen={setOpenCancelAddCard}
                        classBg="btn-white"
                        text="Отмена"
                        shadow={true}
                      />
                      {((currentUser.isLocationEditorMyTasks &&
                        currentUser.isLocationEditorMyTasks.length > 0 &&
                        currentUser.isLocationEditorMyTasks.find(
                          (locationID: any) => trigger.Location && locationID === trigger.Location.get_lookupId()
                        )) ||
                        (currentUser.isLocationAdminMyTasks &&
                          currentUser.isLocationAdminMyTasks.length > 0 &&
                          currentUser.isLocationAdminMyTasks.find(
                            (locationID: any) => trigger.Location && locationID === trigger.Location.get_lookupId()
                          ))) &&
                        <Button
                          classBg="btn-white"
                          text={activeTrigger && "Разархивировать" || "Переместить в архив"}
                          shadow={true}
                          customFunction={() => {
                            setInArchiveCardTrigger(true);
                          }}
                        />
                      }
                    </>
                  }
                </div>
              )}
              {type === "lists" && (
                <div className="flex flex-col items-center justify-center w-full">
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      wrapperClassName="w-full"
                      position="top"
                      tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                    >
                      <Button
                        classBg="btn-white w-full mb-5 justify-center"
                        text="Сохранить"
                        disabled={true}
                        shadow={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button
                        classBg="btn-white w-full mb-5 justify-center"
                        text="Сохранить"
                        submit={true}
                        shadow={true}
                      />
                    )}
                  <Button
                    open={openCancelAddCard}
                    setOpen={setOpenCancelAddCard}
                    classBg="btn-white w-full justify-center mb-5"
                    text="Отмена"
                    shadow={true}
                  />
                </div>
              )}
              {(type === "approvers_edit" ||
                type === "add_action_in_modal") && (
                  <div className="flex flex-row justify-between w-full gap-5">
                    <Button
                      open={openCancelAddCard}
                      setOpen={setOpenCancelAddCard}
                      classBg={twMerge(
                        "btn-white"
                      )}
                      shadow={true}
                      text={"Отмена"}
                    />
                    {(Object.keys(errors).length > 0 && (
                      <TooltipItem
                        wrapperClassName={twMerge(
                          (type !== "add_action_in_modal" && "w-full") || "",
                        )}
                        position={type !== "add_action_in_modal" ? "top" : "left"}
                        tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                      >
                        <Button
                          classBg={twMerge(
                            "btn-dark"
                          )}
                          text={textButtonSubmit || "Продолжить"}
                          disabled={true}
                        />
                      </TooltipItem>
                    )) || (
                        <Button
                          classBg={twMerge(
                            "btn-dark"
                          )}
                          text={textButtonSubmit || "Продолжить"}
                          submit={true}
                        />
                      )}
                  </div>
                )}
              {type === "action_card" && (
                <>
                  {(editDataForm && (
                    <div className={twMerge(
                    "flex justify-between w-full gap-5",
                    isMobileActionCard &&
                      "flex-col gap-2 sticky bottom-0 z-20 bg-white pt-3 pb-[calc(env(safe-area-inset-bottom)+12px)]"
                  )}>
                      <Button
                        classBg={twMerge("btn-white", isMobileActionCard && "w-full justify-center")}
                        shadow={true}
                        text="Отменить изменения"
                        customFunction={resetDefaultValuesHandle}
                        paramsCustomFunction={actionCard.ID}
                      />
                      <div className={twMerge(
                      "flex flex-col tablet:flex-row justify-between w-full gap-5",
                      isMobileActionCard &&
                        "flex-col gap-2 sticky bottom-0 z-20 bg-white pt-3 pb-[calc(env(safe-area-inset-bottom)+12px)]"
                    )}>
                        {cardWithActionType && linkCardWithAction && (
                          <Button
                            classBg="btn-white"
                            shadow={true}
                            icon={true}
                            customFunction={openCardWithAction}
                            typeIcon={
                              (cardWithActionType === "FiveWhy" && "question") ||
                              (cardWithActionType === "deviationCard" &&
                                "settings") ||
                              (cardWithActionType === "auditCard" && "audit") ||
                              (cardWithActionType === "incidentCard" &&
                                "incident") ||
                              (cardWithActionType === "securityCard" &&
                                "security") ||
                              ""
                            }
                            text={
                              (cardWithActionType === "FiveWhy" &&
                                "Перейти к 5Почему") ||
                              (cardWithActionType === "deviationCard" &&
                                "Перейти к Отчету об отклонении") ||
                              (cardWithActionType === "auditCard" &&
                                "Перейти к Поведенческому аудиту") ||
                              (cardWithActionType === "incidentCard" &&
                                "Перейти к Несоответствию") ||
                              (cardWithActionType === "securityCard" &&
                                "Перейти к  Security Инциденту") ||
                              (cardWithActionType === "notificationCard" &&
                                "Перейти к OWD") ||
                              (cardWithActionType === "actionCardVPO" &&
                                "Перейти к требованию VPO") ||
                              (cardWithActionType === "prescriptionCard" &&
                                "Перейти к Предписанию") ||
                              (cardWithActionType === "licenseCard" &&
                                "Перейти к Лицензии") ||
                              (cardWithActionType === "actionCardGOP" &&
                                "Перейти к требованию GOP") ||
                              (cardWithActionType === "taskCard" &&
                                "Перейти к Чек-листу") ||
                              (cardWithActionType === "actionCard5S" &&
                                "Перейти к аудиту 5S") ||
                              ""
                            }
                          />
                        )}
                        <Button
                          classBg={twMerge("btn-white", isMobileActionCard && "w-full justify-center")}
                          shadow={true}
                          icon={true}
                          typeIcon="copy"
                          text="Скопировать действие"
                          disabled={true}
                        />
                        {(Object.keys(errors).length > 0 && (
                          <TooltipItem
                            position="left"
                            tooltipsText={
                              "Пожалуйста, заполните все обязательные поля"
                            }
                          >
                            <Button
                              classBg={twMerge("btn-dark", isMobileActionCard && "w-full justify-center")}
                              text="Сохранить изменения"
                              disabled={true}
                            />
                          </TooltipItem>
                        )) || (
                            <Button
                              classBg="btn-dark"
                              text="Сохранить изменения"
                              submit={true}
                            />
                          )}
                      </div>
                    </div>
                  )) ||
                    (actionCard &&
                      Object.keys(actionCard).length > 0 &&
                      (actionCard.Status.ID === actionsStatus.closed ||
                        actionCard.Status.ID === actionsStatus.cancel) && (
                        <div className={twMerge(
                          "flex justify-between w-full gap-5",
                          isMobileActionCard &&
                            "flex-col gap-2 sticky bottom-0 z-20 bg-white pt-3 pb-[calc(env(safe-area-inset-bottom)+12px)]"
                        )}>
                          {meetingAction && meetingAction.Statuses === "active" && (
                            <div className={twMerge("flex gap-5", isMobileActionCard && "flex-col gap-2 w-full")}>
                              {cardWithActionType && linkCardWithAction && (
                                <Button
                                  classBg="btn-white"
                                  shadow={true}
                                  icon={true}
                                  customFunction={openCardWithAction}
                                  typeIcon={
                                    (cardWithActionType === "FiveWhy" &&
                                      "question") ||
                                    (cardWithActionType === "deviationCard" &&
                                      "settings") ||
                                    (cardWithActionType === "auditCard" &&
                                      "audit") ||
                                    (cardWithActionType === "incidentCard" &&
                                      "incident") ||
                                    (cardWithActionType === "securityCard" &&
                                      "security") ||
                                    ""
                                  }
                                  text={
                                    (cardWithActionType === "FiveWhy" &&
                                      "Перейти к 5Почему") ||
                                    (cardWithActionType === "deviationCard" &&
                                      "Перейти к Отчету об отклонении") ||
                                    (cardWithActionType === "auditCard" &&
                                      "Перейти к Поведенческому аудиту") ||
                                    (cardWithActionType === "incidentCard" &&
                                      "Перейти к Несоответствию") ||
                                    (cardWithActionType === "securityCard" &&
                                      "Перейти к  Security Инциденту") ||
                                    (cardWithActionType === "notificationCard" &&
                                      "Перейти к OWD") ||
                                    (cardWithActionType === "actionCardVPO" &&
                                      "Перейти к требованию VPO") ||
                                    (cardWithActionType === "prescriptionCard" &&
                                      "Перейти к Предписанию") ||
                                    (cardWithActionType === "licenseCard" &&
                                      "Перейти к Лицензии") ||
                                    (cardWithActionType === "actionCardGOP" &&
                                      "Перейти к требованию GOP") ||
                                    (cardWithActionType === "taskCard" &&
                                      "Перейти к Чек-листу") ||
                                    ""
                                  }
                                />
                              )}
                              <Button
                                open={openCancelAddCard}
                                setOpen={setOpenCancelAddCard}
                                classBg={twMerge("btn-white", isMobileActionCard && "w-full justify-center")}
                                icon={true}
                                typeIcon="return"
                                shadow={true}
                                text="Вернуть в работу"
                              />
                            </div>
                          )}
                          <Button
                            open={copyAction}
                            setOpen={setCopyAction}
                            classBg={twMerge("btn-white", isMobileActionCard && "w-full justify-center")}
                            shadow={true}
                            icon={true}
                            typeIcon="copy"
                            text="Скопировать действие"
                          />
                        </div>
                      )) || (
                      <div className={twMerge(
                        "flex justify-between w-full gap-5",
                        isMobileActionCard && "flex-col gap-2 sticky bottom-0 z-20 bg-white pt-3 pb-[calc(env(safe-area-inset-bottom)+12px)]"
                      )}>
                        {cardWithActionType && linkCardWithAction && (
                          <Button
                            classBg={twMerge("btn-white", isMobileActionCard && "w-full justify-center")}
                            shadow={true}
                            icon={true}
                            customFunction={openCardWithAction}
                            typeIcon={
                              (cardWithActionType === "FiveWhy" && "question") ||
                              (cardWithActionType === "deviationCard" &&
                                "settings") ||
                              (cardWithActionType === "auditCard" && "audit") ||
                              (cardWithActionType === "incidentCard" &&
                                "incident") ||
                              (cardWithActionType === "securityCard" &&
                                "security") ||
                              ""
                            }
                            text={
                              (cardWithActionType === "FiveWhy" &&
                                "Перейти к 5Почему") ||
                              (cardWithActionType === "deviationCard" &&
                                "Перейти к Отчету об отклонении") ||
                              (cardWithActionType === "auditCard" &&
                                "Перейти к Поведенческому аудиту") ||
                              (cardWithActionType === "incidentCard" &&
                                "Перейти к Несоответствию") ||
                              (cardWithActionType === "securityCard" &&
                                "Перейти к  Security Инциденту") ||
                              (cardWithActionType === "notificationCard" &&
                                "Перейти к OWD") ||
                              (cardWithActionType === "actionCardVPO" &&
                                "Перейти к требованию VPO") ||
                              (cardWithActionType === "prescriptionCard" &&
                                "Перейти к Предписанию") ||
                              (cardWithActionType === "licenseCard" &&
                                "Перейти к Лицензии") ||
                              (cardWithActionType === "actionCardGOP" &&
                                "Перейти к требованию GOP") ||
                              (cardWithActionType === "taskCard" &&
                                "Перейти к Чек-листу") ||
                              (cardWithActionType === "actionCard5S" &&
                                "Перейти к аудиту 5S") ||
                              ""
                            }
                          />
                        )}
                        <Button
                          open={copyAction}
                          setOpen={setCopyAction}
                          classBg={twMerge("btn-white", isMobileActionCard && "w-full justify-center")}
                          shadow={true}
                          icon={true}
                          typeIcon="copy"
                          text="Скопировать действие"
                        />
                      </div>
                    )}
                </>
              )}
              {type === "action_card_copy" && (
                <div className="flex justify-between w-full gap-5">
                  <Button
                    classBg="btn-white"
                    shadow={true}
                    text="Отмена"
                    customFunction={setCopyAction}
                    paramsCustomFunction={!copyAction}
                  />
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      position="left"
                      tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                    >
                      <Button
                        classBg="btn-dark"
                        text="Скопировать"
                        disabled={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button classBg="btn-dark" text="Скопировать" submit={true} />
                    )}
                </div>
              )}
              {type === "add_comment" && (
                <div
                  className={twMerge(
                    "flex items-center justify-between w-full",
                    isMobileIncCard && "flex-col gap-2 items-stretch"
                  )}
                >
                  {(editDataForm && (
                    <Button
                      classBg={twMerge("btn-white", isMobileIncCard && "w-full justify-center")}
                      shadow={true}
                      text="Отменить изменения"
                      customFunction={resetDefaultValuesHandle}
                      paramsCustomFunction={defaultValues.ID}
                    />
                  )) || (
                      <Button
                        open={openCancelAddCard}
                        setOpen={setOpenCancelAddCard}
                        classBg={twMerge("btn-white", isMobileIncCard && "w-full justify-center")}
                        text="Отмена"
                        shadow={true}
                      />
                    )}
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      position="top"
                      tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                    >
                      <Button
                        classBg={twMerge("btn-dark", isMobileIncCard && "w-full justify-center")}
                        text={
                          (Object.keys(defaultValues).length > 0 &&
                            "Сохранить изменения") ||
                          "Сохранить"
                        }
                        disabled={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button
                        classBg={twMerge("btn-dark", isMobileIncCard && "w-full justify-center")}
                        text={
                          (Object.keys(defaultValues).length > 0 &&
                            "Сохранить изменения") ||
                          "Сохранить"
                        }
                        submit={true}
                      />
                    )}
                </div>
              )}
              {type === "add_my_tasks_inc_security" && (
                <>
                  <div className={`w-full mb-5`}>
                    <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                      <span>Срок на закрытие инцидента</span>
                      <div className="flex flex-row justify-between">
                        <span className="text-[#BA0C2F]">*</span>
                      </div>
                    </label>
                    <div className="relative mt-2">
                      <div
                        className={`block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5  outline-none shadow-custom   cursor-not-allowed text-[#6B7280] bg-[#E5E7EB]`}
                      >
                        {moment(closedDateInc).format("DD.MM.YYYY")}
                      </div>
                      <svg
                        className="absolute right-[16px] top-[16px]"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="14"
                        viewBox="0 0 16 14"
                        fill="none"
                      >
                        <path
                          d="M12.3155 1.65039V1.98372H12.6488H13.9988C14.6717 1.98372 15.2405 2.54135 15.2405 3.20039V11.9004C15.2405 12.5879 14.6682 13.1421 13.9988 13.1421H1.99883C1.31135 13.1421 0.757161 12.5697 0.757161 11.9004V3.20039C0.757161 2.51291 1.32948 1.95872 1.99883 1.95872H3.32383H3.65716V1.62539V1.10039C3.65716 0.959485 3.75792 0.858724 3.89883 0.858724C4.03042 0.858724 4.14049 0.975035 4.14049 1.10039V1.62539V1.95872H4.47383H11.4988H11.8322V1.62539V1.10039C11.8322 0.959485 11.9329 0.858724 12.0738 0.858724C12.2054 0.858724 12.3155 0.975035 12.3155 1.10039V1.65039ZM3.68216 2.77539V2.44206H3.34883H1.99883C1.7935 2.44206 1.59685 2.51565 1.45212 2.66642C1.30819 2.81634 1.24049 3.01632 1.24049 3.22539V4.87539V5.20872H1.57383H14.4488H14.7822V4.87539V3.22539C14.7822 2.7913 14.4329 2.44206 13.9988 2.44206H12.7238H12.3905V2.77539V3.27539C12.3905 3.4163 12.2897 3.51706 12.1488 3.51706C12.0172 3.51706 11.9072 3.40075 11.9072 3.27539V2.77539V2.44206H11.5738H4.49883H4.16549V2.77539V3.27539C4.16549 3.4163 4.06473 3.51706 3.92383 3.51706C3.79223 3.51706 3.68216 3.40075 3.68216 3.27539V2.77539ZM1.54883 5.64206H1.21549V5.97539V11.8754C1.21549 12.3095 1.56473 12.6587 1.99883 12.6587H13.9988C14.393 12.6587 14.7943 12.3658 14.7572 11.8859V5.97539V5.64206H14.4238H1.54883Z"
                          fill="#9CA3AF"
                          stroke="#9CA3AF"
                          strokeWidth="0.666667"
                        />
                        <path
                          d="M7.19844 6.67578H6.64844C6.49844 6.67578 6.39844 6.77578 6.39844 6.92578V7.47578C6.39844 7.62578 6.49844 7.72578 6.64844 7.72578H7.19844C7.34844 7.72578 7.44844 7.62578 7.44844 7.47578V6.92578C7.44844 6.77578 7.32344 6.67578 7.19844 6.67578Z"
                          fill="#9CA3AF"
                        />
                        <path
                          d="M9.47383 6.67578H8.92383C8.77383 6.67578 8.67383 6.77578 8.67383 6.92578V7.47578C8.67383 7.62578 8.77383 7.72578 8.92383 7.72578H9.47383C9.62383 7.72578 9.72383 7.62578 9.72383 7.47578V6.92578C9.72383 6.77578 9.62383 6.67578 9.47383 6.67578Z"
                          fill="#9CA3AF"
                        />
                        <path
                          d="M11.7492 6.67578H11.1992C11.0492 6.67578 10.9492 6.77578 10.9492 6.92578V7.47578C10.9492 7.62578 11.0492 7.72578 11.1992 7.72578H11.7492C11.8992 7.72578 11.9992 7.62578 11.9992 7.47578V6.92578C11.9992 6.77578 11.8992 6.67578 11.7492 6.67578Z"
                          fill="#9CA3AF"
                        />
                        <path
                          d="M4.8 8.59961H4.25C4.1 8.59961 4 8.69961 4 8.84961V9.39961C4 9.54961 4.1 9.64961 4.25 9.64961H4.8C4.95 9.64961 5.05 9.54961 5.05 9.39961V8.84961C5.05 8.69961 4.925 8.59961 4.8 8.59961Z"
                          fill="#9CA3AF"
                        />
                        <path
                          d="M7.19844 8.59961H6.64844C6.49844 8.59961 6.39844 8.69961 6.39844 8.84961V9.39961C6.39844 9.54961 6.49844 9.64961 6.64844 9.64961H7.19844C7.34844 9.64961 7.44844 9.54961 7.44844 9.39961V8.84961C7.44844 8.69961 7.32344 8.59961 7.19844 8.59961Z"
                          fill="#9CA3AF"
                        />
                        <path
                          d="M9.47383 8.59961H8.92383C8.77383 8.59961 8.67383 8.69961 8.67383 8.84961V9.39961C8.67383 9.54961 8.77383 9.64961 8.92383 9.64961H9.47383C9.62383 9.64961 9.72383 9.54961 9.72383 9.39961V8.84961C9.72383 8.69961 9.62383 8.59961 9.47383 8.59961Z"
                          fill="#9CA3AF"
                        />
                        <path
                          d="M11.7492 8.59961H11.1992C11.0492 8.59961 10.9492 8.69961 10.9492 8.84961V9.39961C10.9492 9.54961 11.0492 9.64961 11.1992 9.64961H11.7492C11.8992 9.64961 11.9992 9.54961 11.9992 9.39961V8.84961C11.9992 8.69961 11.8992 8.59961 11.7492 8.59961Z"
                          fill="#9CA3AF"
                        />
                        <path
                          d="M4.8 10.5254H4.25C4.1 10.5254 4 10.6254 4 10.7754V11.3254C4 11.4754 4.1 11.5754 4.25 11.5754H4.8C4.95 11.5754 5.05 11.4754 5.05 11.3254V10.7754C5.05 10.6254 4.925 10.5254 4.8 10.5254Z"
                          fill="#9CA3AF"
                        />
                        <path
                          d="M7.19844 10.5254H6.64844C6.49844 10.5254 6.39844 10.6254 6.39844 10.7754V11.3254C6.39844 11.4754 6.49844 11.5754 6.64844 11.5754H7.19844C7.34844 11.5754 7.44844 11.4754 7.44844 11.3254V10.7754C7.44844 10.6254 7.32344 10.5254 7.19844 10.5254Z"
                          fill="#9CA3AF"
                        />
                        <path
                          d="M9.47383 10.5254H8.92383C8.77383 10.5254 8.67383 10.6254 8.67383 10.7754V11.3254C8.67383 11.4754 8.77383 11.5754 8.92383 11.5754H9.47383C9.62383 11.5754 9.72383 11.4754 9.72383 11.3254V10.7754C9.72383 10.6254 9.62383 10.5254 9.47383 10.5254Z"
                          fill="#9CA3AF"
                        />
                      </svg>
                    </div>
                  </div>
                  <FlexCol className="w-full mb-5 p-[16px] bg-[#FEEBEB] rounded-lg">
                    <AddActionInComponent
                      typeModule={defaultValues.TypeIncident}
                      idModule={0}
                      CustomStyles={"bg-white p-5"}
                    />
                    <div className="mb-[10px]"></div>
                  </FlexCol>
                  <TooltipItem
                    position="top"
                    tooltipsText={"Пожалуйста, сохраните инцидент"}
                  >
                    <FlexRow className="flex items-center justify-between w-full mb-5">
                      <h3 className="text-[#637381] flex items-center font-medium">
                        Комментарии и вложения · 0
                      </h3>
                    </FlexRow>
                  </TooltipItem>
                  <FlexRow className="justify-between w-full gap-5">
                    <Button
                      open={openCancelAddCard}
                      setOpen={setOpenCancelAddCard}
                      classBg="btn-white"
                      shadow={true}
                      text="Отмена"
                    />
                    {(Object.keys(errors).length > 0 && (
                      <TooltipItem
                        position="left"
                        tooltipsText={
                          "Пожалуйста, заполните все обязательные поля"
                        }
                      >
                        <Button
                          classBg="btn-dark"
                          text="Подтвердить и сохранить форму"
                          disabled={true}
                        />
                      </TooltipItem>
                    )) || (
                        <Button
                          classBg="btn-dark"
                          text="Подтвердить и сохранить форму"
                          submit={true}
                        />
                      )}
                  </FlexRow>
                </>
              )}
            </form>
            {type === "add_action_in_component" && (
              <div className={twMerge(
                "flex flex-col tablet:flex-row justify-between w-full gap-2 tablet:gap-5",
                isMobileModeAddInComponent && "flex-col gap-2"
              )}>
                <Button
                  open={openCancelAddCard}
                  setOpen={setOpenCancelAddCard}
                  classBg={twMerge(
                    "btn-white w-full justify-center flex items-center",
                  )}
                  shadow={true}
                  text={"Отмена"}
                />
                {(Object.keys(errors).length > 0 && (
                  <TooltipItem
                    wrapperClassName={"w-full"}
                    position={"top"}
                    tooltipsText={"Пожалуйста, заполните все обязательные поля"}
                  >
                    <Button
                      classBg={twMerge(
                        "btn-dark w-full justify-center flex items-center",
                      )}
                      text={textButtonSubmit || "Продолжить"}
                      disabled={true}
                    />
                  </TooltipItem>
                )) || (
                    <Button
                      classBg={twMerge(
                        "btn-dark w-full justify-center flex items-center",
                      )}
                      text={textButtonSubmit || "Продолжить"}
                      submit={true}
                      form={type}
                    />
                  )}
              </div>
            )}
            {type === "add_my_tasks_audit" && (
              <>
                <FlexCol className="w-full mb-5">
                  <h3 className="text-[#637381] font-medium mb-2.5">
                    Действия
                  </h3>
                  <AddActionInComponent
                    typeModule={"ПоведенческийАудит"}
                    idModule={auditID || 0}
                    CustomStyles={"bg-white p-5"}
                    mobileModalMode={isMobileModeAddInComponent}
                  />
                </FlexCol>
                <FlexRow className="justify-between w-full gap-5">
                  <Button
                    open={openCancelAddCard}
                    setOpen={setOpenCancelAddCard}
                    classBg="btn-white"
                    shadow={true}
                    text="Отмена"
                  />
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      position="left"
                      tooltipsText={
                        "Пожалуйста, заполните все обязательные поля"
                      }
                    >
                      <Button
                        classBg="btn-dark"
                        text="Подтвердить и сохранить форму"
                        disabled={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button
                        classBg="btn-dark"
                        text="Подтвердить и сохранить форму"
                        submit={true}
                        form={type}
                      />
                    )}
                </FlexRow>
              </>
            )}
            {type === "audit_card_my_tasks" && (
              <>
                <FlexCol className="w-full mb-5">
                  <h3 className="text-[#637381] font-medium mb-2.5">Действия</h3>
                  <AddActionInComponent
                    typeModule={"ПоведенческийАудит"}
                    idModule={auditID || 0}
                    CustomStyles={"bg-white p-0 tablet:p-5"}
                    mobileModalMode={isMobilePovAuditCard}
                  />
                </FlexCol>
                {(editDataForm && (
                  <FlexRow className="justify-between w-full gap-5">
                    <Button
                      classBg="btn-white"
                      shadow={true}
                      text="Отменить изменения"
                      customFunction={resetDefaultValuesHandle}
                      paramsCustomFunction={defaultValues.ID}
                    />
                    <FlexRow className="gap-5">
                      {(Object.keys(errors).length > 0 && (
                        <TooltipItem
                          position="top"
                          tooltipsText={
                            "Пожалуйста, заполните все обязательные поля"
                          }
                        >
                          <Button
                            classBg="btn-dark"
                            text="Сохранить изменения"
                            disabled={true}
                          />
                        </TooltipItem>
                      )) || (
                          <Button
                            classBg="btn-dark"
                            text="Сохранить изменения"
                            submit={true}
                            form={type}
                          />
                        )}
                    </FlexRow>
                  </FlexRow>
                )) || (
                    <FlexRow className="justify-end w-full gap-5">
                      <></>
                    </FlexRow>
                  )}
              </>
            )}
            {type === "add_my_tasks_5way" && (
              <>
                {canRender5WayLinkedBlocks && (
                  <>
                    {type5way !== FiveWhyType &&
                      <FlexCol className="w-full mb-5 p-5 bg-[#F3F4F6] gap-2">
                        <h3 className="text-[#637381] font-medium mb-2.5">Немедленные корректирующие действия и эффект от них</h3>
                        <AddActionInComponent
                          typeModule={
                            (ID5WayAdd && type5way === FiveWhyType && "5Почему") ||
                            (ID5WayAdd && "Отчет_об_отклонениях") ||
                            ""
                          }
                          idModule={(ID5WayAdd && `${ID5WayAdd}A`) || 0}
                          CustomStyles={"bg-white p-5"}
                          typeForm="add_my_tasks_5way"
                          mobileModalMode={isMobile5WayCard}
                          mobileModalZIndex={zIndex + 50}
                        />
                      </FlexCol>
                    }
                    {type5way === FiveWhyType &&
                      <>
                        <label className="block mb-2">
                          <div className="flex items-start gap-1">
                            <span className="text-sm font-medium text-[#111928]" dangerouslySetInnerHTML={{
                              __html: params.length > 0 && JSON.parse(params
                                .find((param: any) => param.Key === "FiveWhyFormStep3")
                              ["Comments"].trim())['title']
                            }} />
                          </div>
                          <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                            __html: params.length > 0 && JSON.parse(params
                              .find((param: any) => param.Key === "FiveWhyFormStep3")
                            ["Comments"].trim())['description']
                          }} />
                        </label>
                        {card5WayTree.some((treeItem: any) => treeItem.root || treeItem.system) &&
                          <FlexCol className="p-5 bg-[#F3F4F6] rounded-md mb-2">
                            <span className="text-[#111928] text-sm mb-2"><strong>Корневая причина: </strong></span>
                            <FlexRow className="justify-between">
                              {card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).map((treeItem: any, idx: number) => (
                                <>
                                  <span style={{ whiteSpace: "pre-wrap" }} className="text-sm">{treeItem.reason}</span>
                                  {treeItem.root && (
                                    <FlexRow
                                      title="Корневая причина"
                                      className="text-[#F2A900]"
                                    >
                                      <Medal />
                                    </FlexRow>
                                  )
                                  }
                                </>
                              ))}
                            </FlexRow>
                          </FlexCol>
                        }
                      </>
                      ||
                      <FlexCol className="mb-5 w-full gap-[10px]">
                        <h3 className="text-[#637381] font-medium">
                          Диаграмма Ишикавы
                        </h3>
                        {(card5WayTreeSafe && card5WayTreeSafe.some(
                          (treeItem: any) => treeItem.root || treeItem.system,
                        ) && (
                            <>
                              <FlexRow className="justify-center w-full rounded-md bg-[#DAF8E6] border border-[#22AD5C] p-2.5 mb-2.5">
                                Корневая причина найдена
                              </FlexRow>
                              {card5WayTreeSafe
                                .filter(
                                  (treeItem: any) => treeItem.root || treeItem.system,
                                )
                                .map((treeItem: any, idx: number) => (
                                  <FlexRow className="justify-center w-full gap-[10px] rounded-md bg-[#F3F4F6] p-5">
                                    <FlexRow className="w-fit">
                                      <strong>{idx + 1}.</strong>
                                    </FlexRow>
                                    <FlexCol className="w-full gap-[10px]">
                                      {treeItem.reason}
                                      <span className="text-[#8646F4]">
                                        Категория Ишикавы: {treeItem.category}
                                      </span>
                                    </FlexCol>
                                    {treeItem.root && (
                                      <FlexRow
                                        title="Техническая причина"
                                        className="text-[#F2A900]"
                                      >
                                        <Medal />
                                      </FlexRow>
                                    )}
                                    {treeItem.system && (
                                      <FlexRow
                                        title="Системная причина"
                                        className="text-[#E10E0E]"
                                      >
                                        <Medal />
                                      </FlexRow>
                                    )}
                                  </FlexRow>
                                ))}
                            </>
                          )) || (
                            <FlexRow className="justify-center w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5 mb-2.5">
                              Проанализируйте проблему и найдите хотя бы одну корневую
                              причину
                            </FlexRow>
                          )}
                      </FlexCol>
                    }
                    <Tree
                      open={openTree}
                      setOpen={setOpenTree}
                      zIndex={zIndex + 50}
                      setCard5WayTree={setCard5WayTree}
                      type5Way={type5way}
                      card5WayID={Number(ID5WayAdd)}
                      viewMode={false}
                      tree={card5WayTreeSafe}
                      detailProplem={watch("Details")}
                      setProblemInTree={setProblemInTree}
                      problemInTree={problemInTree}
                      isMobileView={isMobile5WayCard}
                    />

                    {type5way !== FiveWhyType &&
                      <SDCA
                      card5WayID={Number(ID5WayAdd)}
                      viewMode={false}
                      type5Way={type5way}
                      card5WayTree={card5WayTreeSafe}
                    />
                    }

                    {type5way === FiveWhyType &&
                      <>
                        <label className="block mb-2">
                          <div className="flex items-start gap-1">
                            <span className="text-sm font-medium text-[#111928]" dangerouslySetInnerHTML={{
                              __html: params.length > 0 && JSON.parse(params
                                .find((param: any) => param.Key === "FiveWhyFormStep4")
                              ["Comments"].trim())['title']
                            }} />
                          </div>
                          <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                            __html: params.length > 0 && JSON.parse(params
                              .find((param: any) => param.Key === "FiveWhyFormStep4")
                            ["Comments"].trim())['description']
                          }} />
                        </label>

                        <AddActionInComponent
                          typeModule="5Почему"
                          idModule={(ID5WayAdd && `${ID5WayAdd}`) || 0}
                          CustomStyles={"bg-white"}
                          typeForm="add_my_tasks_5way"
                        />

                        <label className="block mb-2">
                          <div className="flex items-start gap-1">
                            <span className="text-sm font-medium text-[#111928]" dangerouslySetInnerHTML={{
                              __html: params.length > 0 && JSON.parse(params
                                .find((param: any) => param.Key === "FiveWhyFormStep5")
                              ["Comments"].trim())['title']
                            }} />
                          </div>
                          <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                            __html: params.length > 0 && JSON.parse(params
                              .find((param: any) => param.Key === "FiveWhyFormStep5")
                            ["Comments"].trim())['description']
                          }} />
                        </label>
                        <Comments
                          history={false}
                          variant="inlineAdd"
                          zIndex={zIndex + 50}
                          IDCard={Number(ID5WayAdd)}
                          listComments={myTasks5WayCommentsListName}
                          listFilesComments={myTask5WayCommentsFilesListName}
                          strapiParams={MT5WhyCommentsFiles}
                          field="_x0035_Way"
                          customClass="mb-5 w-full"
                          label=""
                          isMobile5WayCard={isMobile5WayCard}
                        />
                      </> ||
                      <Comments
                        history={false}
                        zIndex={zIndex + 50}
                        IDCard={Number(ID5WayAdd)}
                        listComments={myTasks5WayCommentsListName}
                        listFilesComments={myTask5WayCommentsFilesListName}
                        strapiParams={MT5WhyCommentsFiles}
                        field="_x0035_Way"
                        customClass="mb-5 w-full"
                        isMobile5WayCard={isMobile5WayCard}
                      />
                    }

                    {/* <Comments
                      history={false}
                      zIndex={zIndex + 50}
                      IDCard={Number(ID5WayAdd)}
                      listComments={myTasks5WayCommentsListName}
                      listFilesComments={myTask5WayCommentsFilesListName}
                      strapiParams={MT5WhyCommentsFiles}
                      field="_x0035_Way"
                      customClass="mb-5 w-full"
                    /> */}
                  </>
                )}
                <FlexRow className="justify-between w-full gap-5">
                  <Button
                    classBg="btn-white"
                    shadow={true}
                    text="Отмена"
                    open={openCancelAddCard}
                    setOpen={setOpenCancelAddCard}
                  />
                  <FlexRow className="gap-5">
                    {(Object.keys(errors).length > 0 && (
                      <TooltipItem
                        position="left"
                        tooltipsText={
                          "Пожалуйста, заполните все обязательные поля"
                        }
                      >
                        <Button
                          classBg="btn-dark"
                          text="Сохранить"
                          disabled={true}
                        />
                      </TooltipItem>
                    )) || (
                        <Button
                          classBg="btn-dark"
                          text="Сохранить"
                          submit={true}
                          form={type}
                        />
                      )}
                  </FlexRow>
                </FlexRow>
              </>
            )}
            {type === "5way_card_my_tasks" && (
              <>
                {type5way !== FiveWhyType &&
                  <FlexCol className="w-full my-5 mb-5 p-5 bg-[#F3F4F6] gap-2">
                    <h3 className="text-[#637381] font-medium mb-2.5">Немедленные корректирующие действия и эффект от них</h3>
                    <AddActionInComponent
                      typeModule={
                        (ID5WayAdd && type5way === FiveWhyType && "5Почему") ||
                        (ID5WayAdd && "Отчет_об_отклонениях") ||
                        ""
                      }
                      idModule={(ID5WayAdd && `${ID5WayAdd}A`) || 0}
                      CustomStyles={"bg-white p-5"}
                      typeForm="5way_card_my_tasks"
                      mobileModalMode={isMobile5WayCard}
                      mobileModalZIndex={zIndex + 50}
                    />
                  </FlexCol>
                }

                {type5way === FiveWhyType &&
                  <>
                    <label className="block mb-2">
                      <div className="flex items-start gap-1">
                        <span className="text-sm font-medium text-[#111928]" dangerouslySetInnerHTML={{
                          __html: params.length > 0 && JSON.parse(params
                            .find((param: any) => param.Key === "FiveWhyFormStep3")
                          ["Comments"].trim())['title']
                        }} />
                      </div>
                      <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                        __html: params.length > 0 && JSON.parse(params
                          .find((param: any) => param.Key === "FiveWhyFormStep3")
                        ["Comments"].trim())['description']
                      }} />
                    </label>
                    {card5WayTree.some((treeItem: any) => treeItem.root || treeItem.system) &&
                      <FlexCol className="p-5 bg-[#F3F4F6] rounded-md mb-2">
                        <span className="text-[#111928] text-sm mb-2"><strong>Корневая причина: </strong></span>
                        <FlexRow className="justify-between">
                          {card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).map((treeItem: any, idx: number) => (
                            <>
                              <span style={{ whiteSpace: "pre-wrap" }} className="text-sm">{treeItem.reason}</span>
                              {treeItem.root && (
                                <FlexRow
                                  title="Корневая причина"
                                  className="text-[#F2A900]"
                                >
                                  <Medal />
                                </FlexRow>
                              )
                              }
                            </>
                          ))}
                        </FlexRow>
                      </FlexCol>
                    }
                  </>
                  ||
                  <FlexCol className="mb-5 w-full gap-[10px]">
                    <h3 className="text-[#637381] font-medium">
                      Диаграмма Ишикавы
                    </h3>
                    {(card5WayTreeSafe && card5WayTreeSafe.some(
                      (treeItem: any) => treeItem.root || treeItem.system,
                    ) && (
                        <>
                          <FlexRow className="justify-center w-full rounded-md bg-[#DAF8E6] border border-[#22AD5C] p-2.5 mb-2.5">
                            Корневая причина найдена
                          </FlexRow>
                          {card5WayTreeSafe
                            .filter(
                              (treeItem: any) => treeItem.root || treeItem.system,
                            )
                            .map((treeItem: any, idx: number) => (
                              <FlexRow className="justify-center w-full gap-[10px] rounded-md bg-[#F3F4F6] p-5">
                                <FlexRow className="w-fit">
                                  <strong>{idx + 1}.</strong>
                                </FlexRow>
                                <FlexCol className="w-full gap-[10px]">
                                  {treeItem.reason}
                                  <span className="text-[#8646F4]">
                                    Категория Ишикавы: {treeItem.category}
                                  </span>
                                </FlexCol>
                                {treeItem.root && (
                                  <FlexRow
                                    title="Техническая причина"
                                    className="text-[#F2A900]"
                                  >
                                    <Medal />
                                  </FlexRow>
                                )}
                                {treeItem.system && (
                                  <FlexRow
                                    title="Системная причина"
                                    className="text-[#E10E0E]"
                                  >
                                    <Medal />
                                  </FlexRow>
                                )}
                              </FlexRow>
                            ))}
                        </>
                      )) || (
                        <FlexRow className="justify-center w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5 mb-2.5">
                          Проанализируйте проблему и найдите хотя бы одну корневую
                          причину
                        </FlexRow>
                      )}
                  </FlexCol>
                }
                <Tree
                  open={openTree}
                  setOpen={setOpenTree}
                  zIndex={zIndex + 50}
                  setCard5WayTree={setCard5WayTree}
                  type5Way={type5way}
                  card5WayID={Number(ID5WayAdd)}
                  viewMode={false}
                  isMobileView={isMobile5WayCard}
                  tree={card5WayTreeSafe}
                  detailProplem={watch("Details")}
                  setProblemInTree={setProblemInTree}
                  problemInTree={problemInTree}
                />

                {type5way === FiveWhyType &&
                  <>
                    <label className="block mb-2">
                      <div className="flex items-start gap-1">
                        <span className="text-sm font-medium text-[#111928]" dangerouslySetInnerHTML={{
                          __html: params.length > 0 && JSON.parse(params
                            .find((param: any) => param.Key === "FiveWhyFormStep4")
                          ["Comments"].trim())['title']
                        }} />
                      </div>
                      <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                        __html: params.length > 0 && JSON.parse(params
                          .find((param: any) => param.Key === "FiveWhyFormStep4")
                        ["Comments"].trim())['description']
                      }} />
                    </label>
                    <FlexCol className="bg-[#F3F4F6] rounded-md p-5 mb-5">
                      <h3 className="text-lg text-[#637381] font-medium mb-2">Действия</h3>
                      <AddActionInComponent
                        typeModule="5Почему"
                        idModule={(ID5WayAdd && `${ID5WayAdd}`) || 0}
                        CustomStyles={"bg-white p-5"}
                        typeForm="5way_card_my_tasks"
                        mobileModalMode={isMobile5WayCard}
                      />
                    </FlexCol>
                    <label className="block mb-2">
                      <div className="flex items-start gap-1">
                        <span className="text-sm font-medium text-[#111928]" dangerouslySetInnerHTML={{
                          __html: params.length > 0 && JSON.parse(params
                            .find((param: any) => param.Key === "FiveWhyFormStep5")
                          ["Comments"].trim())['title']
                        }} />
                      </div>
                      <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                        __html: params.length > 0 && JSON.parse(params
                          .find((param: any) => param.Key === "FiveWhyFormStep5")
                        ["Comments"].trim())['description']
                      }} />
                    </label>
                    <Comments
                      history={false}
                      variant="inlineAdd"
                      zIndex={zIndex + 50}
                      IDCard={Number(ID5WayAdd)}
                      listComments={myTasks5WayCommentsListName}
                      listFilesComments={myTask5WayCommentsFilesListName}
                      strapiParams={MT5WhyCommentsFiles}
                      field="_x0035_Way"
                      customClass="mb-5 w-full"
                      label=""
                      isMobile5WayCard={isMobile5WayCard}
                    />
                  </> ||
                  <>
                    <SDCA
                      card5WayID={Number(ID5WayAdd)}
                      viewMode={false}
                      type5Way={type5way}
                      card5WayTree={card5WayTreeSafe}
                      isMobileView={isMobile5WayCard}
                      mobileModalZIndex={zIndex + 50}
                    />
                    <Comments
                      history={false}
                      zIndex={zIndex + 50}
                      IDCard={Number(ID5WayAdd)}
                      listComments={myTasks5WayCommentsListName}
                      listFilesComments={myTask5WayCommentsFilesListName}
                      strapiParams={MT5WhyCommentsFiles}
                      field="_x0035_Way"
                      customClass="mb-5 w-full"
                      isMobile5WayCard={isMobile5WayCard}
                    />
                  </>
                }

                <FlexRow className="justify-between w-full gap-5">
                  {/* {!editDataForm && (
                    <Button
                      classBg="btn-dark w-full justify-center"
                      shadow={true}
                      text="Выйти из режима редактирования"
                      customFunction={removeEditorHandle}
                      paramsCustomFunction={Number(ID5WayAdd)}
                    />
                  )} */}
                  <FlexRow className={`gap-5 justify-between ${editDataForm ? "w-full" : ""}`}>

                    {editDataForm && (
                      <>
                        <Button
                          classBg="btn-white"
                          shadow={true}
                          text="Отменить изменения"
                          customFunction={resetDefaultValuesHandle}
                          paramsCustomFunction={Number(ID5WayAdd)}
                        />
                        <FlexRow className="gap-5">
                          {/* {extraButtonText && extraButtonAction &&
                            <Button
                              classBg="btn-white"
                              shadow={true}
                              text={extraButtonText}
                              customFunction={extraButtonAction}
                            />
                          } */}
                          {(Object.keys(errors).length > 0 && (
                            <TooltipItem
                              position="left"
                              tooltipsText={
                                "Пожалуйста, заполните все обязательные поля"
                              }
                            >
                              <Button
                                classBg="btn-dark"
                                text="Сохранить"
                                disabled={true}
                              />
                            </TooltipItem>
                          )) || (
                              <Button
                                classBg="btn-dark"
                                text="Сохранить"
                                submit={true}
                                form={type}
                              />
                            )}
                        </FlexRow>
                      </>
                    )}
                    {/* {extraButtonText && extraButtonAction && !editDataForm &&
                      <Button
                        classBg="btn-white"
                        shadow={true}
                        text={extraButtonText}
                        customFunction={extraButtonAction}
                      />
                    } */}
                  </FlexRow>

                </FlexRow>
              </>
            )}
            {type === "add_my_tasks_inc" && (
              <>
                <Comments
                  history={false}
                  zIndex={zIndex + 50}
                  IDCard={Number(incidentID)}
                  listComments={myTaskIncCommentsListName}
                  listFilesComments={myTaskIncCommentsFilesListName}
                  strapiParams={MTIncCommentsFiles}
                  field="Incident"
                  customClass="mb-5 w-full"
                />
                {watch("IncidentOption") && (
                  <>
                    <h3 className="text-[#637381] font-medium mb-5 w-full">
                      {(watch("IncidentOption") === "Инцидент" &&
                        "Результаты анализа инцидента") ||
                        "Результаты анализа несоответствия"}
                    </h3>
                    <FlexCol className="w-full mb-5 p-[16px] bg-[#FEEBEB] rounded-lg">
                      {watch("IncidentOption") === "Несоответствие" && (
                        <>
                          <AddActionInComponent
                            typeModule={`${watch("IncidentOption")}_${watch(
                              "TypeIncident",
                            )}`.toLowerCase()}
                            idModule={Number(incidentID)}
                            CustomStyles={"bg-white p-5"}
                          />
                          <div className="mb-[10px]"></div>
                          <Button
                            icon={true}
                            submit={true}
                            typeIcon="add"
                            classBg="btn-white w-full justify-center"
                            shadow={true}
                            text="Создать 5Почему"
                            dataAttribute="addinc"
                            form={type}
                          />
                        </>
                      )}
                      {watch("IncidentOption") === "Инцидент" && (
                        <>
                          <p className="flex items-center justify-center mb-2">
                            Создайте отчет, найдите корневые причины, добавьте
                            действия, чтобы завершить расследование
                          </p>
                          <Button
                            icon={true}
                            submit={true}
                            typeIcon="add"
                            classBg="btn-white w-full justify-center"
                            shadow={true}
                            text="Создать отчет об отклонениях"
                            dataAttribute="addinc"
                            form={type}
                          />
                        </>
                      )}
                    </FlexCol>
                    <div className={`w-full mb-5`}>
                      <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                        {(watch("IncidentOption") === "Инцидент" && (
                          <span>Срок на закрытие инцидента</span>
                        )) || <span>Срок на закрытие несоответствия</span>}
                        <div className="flex flex-row justify-between">
                          <span className="text-[#BA0C2F]">*</span>
                        </div>
                      </label>
                      <div className="relative mt-2">
                        <div
                          className={`block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5  outline-none shadow-custom   cursor-not-allowed text-[#6B7280] bg-[#E5E7EB]`}
                        >
                          {moment(closedDateInc).format("DD.MM.YYYY")}
                        </div>
                        <svg
                          className="absolute right-[16px] top-[16px]"
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="14"
                          viewBox="0 0 16 14"
                          fill="none"
                        >
                          <path
                            d="M12.3155 1.65039V1.98372H12.6488H13.9988C14.6717 1.98372 15.2405 2.54135 15.2405 3.20039V11.9004C15.2405 12.5879 14.6682 13.1421 13.9988 13.1421H1.99883C1.31135 13.1421 0.757161 12.5697 0.757161 11.9004V3.20039C0.757161 2.51291 1.32948 1.95872 1.99883 1.95872H3.32383H3.65716V1.62539V1.10039C3.65716 0.959485 3.75792 0.858724 3.89883 0.858724C4.03042 0.858724 4.14049 0.975035 4.14049 1.10039V1.62539V1.95872H4.47383H11.4988H11.8322V1.62539V1.10039C11.8322 0.959485 11.9329 0.858724 12.0738 0.858724C12.2054 0.858724 12.3155 0.975035 12.3155 1.10039V1.65039ZM3.68216 2.77539V2.44206H3.34883H1.99883C1.7935 2.44206 1.59685 2.51565 1.45212 2.66642C1.30819 2.81634 1.24049 3.01632 1.24049 3.22539V4.87539V5.20872H1.57383H14.4488H14.7822V4.87539V3.22539C14.7822 2.7913 14.4329 2.44206 13.9988 2.44206H12.7238H12.3905V2.77539V3.27539C12.3905 3.4163 12.2897 3.51706 12.1488 3.51706C12.0172 3.51706 11.9072 3.40075 11.9072 3.27539V2.77539V2.44206H11.5738H4.49883H4.16549V2.77539V3.27539C4.16549 3.4163 4.06473 3.51706 3.92383 3.51706C3.79223 3.51706 3.68216 3.40075 3.68216 3.27539V2.77539ZM1.54883 5.64206H1.21549V5.97539V11.8754C1.21549 12.3095 1.56473 12.6587 1.99883 12.6587H13.9988C14.393 12.6587 14.7943 12.3658 14.7572 11.8859V5.97539V5.64206H14.4238H1.54883Z"
                            fill="#9CA3AF"
                            stroke="#9CA3AF"
                            strokeWidth="0.666667"
                          />
                          <path
                            d="M7.19844 6.67578H6.64844C6.49844 6.67578 6.39844 6.77578 6.39844 6.92578V7.47578C6.39844 7.62578 6.49844 7.72578 6.64844 7.72578H7.19844C7.34844 7.72578 7.44844 7.62578 7.44844 7.47578V6.92578C7.44844 6.77578 7.32344 6.67578 7.19844 6.67578Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M9.47383 6.67578H8.92383C8.77383 6.67578 8.67383 6.77578 8.67383 6.92578V7.47578C8.67383 7.62578 8.77383 7.72578 8.92383 7.72578H9.47383C9.62383 7.72578 9.72383 7.62578 9.72383 7.47578V6.92578C9.72383 6.77578 9.62383 6.67578 9.47383 6.67578Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M11.7492 6.67578H11.1992C11.0492 6.67578 10.9492 6.77578 10.9492 6.92578V7.47578C10.9492 7.62578 11.0492 7.72578 11.1992 7.72578H11.7492C11.8992 7.72578 11.9992 7.62578 11.9992 7.47578V6.92578C11.9992 6.77578 11.8992 6.67578 11.7492 6.67578Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M4.8 8.59961H4.25C4.1 8.59961 4 8.69961 4 8.84961V9.39961C4 9.54961 4.1 9.64961 4.25 9.64961H4.8C4.95 9.64961 5.05 9.54961 5.05 9.39961V8.84961C5.05 8.69961 4.925 8.59961 4.8 8.59961Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M7.19844 8.59961H6.64844C6.49844 8.59961 6.39844 8.69961 6.39844 8.84961V9.39961C6.39844 9.54961 6.49844 9.64961 6.64844 9.64961H7.19844C7.34844 9.64961 7.44844 9.54961 7.44844 9.39961V8.84961C7.44844 8.69961 7.32344 8.59961 7.19844 8.59961Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M9.47383 8.59961H8.92383C8.77383 8.59961 8.67383 8.69961 8.67383 8.84961V9.39961C8.67383 9.54961 8.77383 9.64961 8.92383 9.64961H9.47383C9.62383 9.64961 9.72383 9.54961 9.72383 9.39961V8.84961C9.72383 8.69961 9.62383 8.59961 9.47383 8.59961Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M11.7492 8.59961H11.1992C11.0492 8.59961 10.9492 8.69961 10.9492 8.84961V9.39961C10.9492 9.54961 11.0492 9.64961 11.1992 9.64961H11.7492C11.8992 9.64961 11.9992 9.54961 11.9992 9.39961V8.84961C11.9992 8.69961 11.8992 8.59961 11.7492 8.59961Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M4.8 10.5254H4.25C4.1 10.5254 4 10.6254 4 10.7754V11.3254C4 11.4754 4.1 11.5754 4.25 11.5754H4.8C4.95 11.5754 5.05 11.4754 5.05 11.3254V10.7754C5.05 10.6254 4.925 10.5254 4.8 10.5254Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M7.19844 10.5254H6.64844C6.49844 10.5254 6.39844 10.6254 6.39844 10.7754V11.3254C6.39844 11.4754 6.49844 11.5754 6.64844 11.5754H7.19844C7.34844 11.5754 7.44844 11.4754 7.44844 11.3254V10.7754C7.44844 10.6254 7.32344 10.5254 7.19844 10.5254Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M9.47383 10.5254H8.92383C8.77383 10.5254 8.67383 10.6254 8.67383 10.7754V11.3254C8.67383 11.4754 8.77383 11.5754 8.92383 11.5754H9.47383C9.62383 11.5754 9.72383 11.4754 9.72383 11.3254V10.7754C9.72383 10.6254 9.62383 10.5254 9.47383 10.5254Z"
                            fill="#9CA3AF"
                          />
                        </svg>
                      </div>
                    </div>
                  </>
                )}
                <FlexRow className="justify-between w-full gap-5">
                  <Button
                    open={openCancelAddCard}
                    setOpen={setOpenCancelAddCard}
                    classBg="btn-white"
                    shadow={true}
                    text="Отмена"
                  />
                  {(Object.keys(errors).length > 0 && (
                    <TooltipItem
                      position="left"
                      tooltipsText={
                        "Пожалуйста, заполните все обязательные поля"
                      }
                    >
                      <Button
                        classBg="btn-dark"
                        text="Подтвердить и сохранить форму"
                        disabled={true}
                      />
                    </TooltipItem>
                  )) || (
                      <Button
                        classBg="btn-dark"
                        text="Подтвердить и сохранить форму"
                        submit={true}
                        form={type}
                      />
                    )}
                </FlexRow>
              </>
            )}
            {type === "inc_card_my_tasks" && (
              <>
                <Comments
                  history={false}
                  zIndex={zIndex + 50}
                  IDCard={Number(incidentID)}
                  listComments={myTaskIncCommentsListName}
                  listFilesComments={myTaskIncCommentsFilesListName}
                  strapiParams={MTIncCommentsFiles}
                  field="Incident"
                  customClass="mb-5 w-full"
                  isMobileIncCard={isMobileIncCard}
                  variant={isMobileIncCard ? "inlineAdd" : "default"}
                />
                {watch("IncidentOption") && (
                  <>
                    <h3 className="text-[#637381] font-medium mb-5 w-full">
                      {(watch("IncidentOption") === "Инцидент" &&
                        "Результаты анализа инцидента") ||
                        "Результаты анализа несоответствия"}
                    </h3>
                    <FlexCol
                      style={{
                        backgroundColor:
                          (card5WayTreeSafe.some((treeItem: any) => treeItem.root) &&
                            "#DAF8E6") ||
                          "#FEEBEB",
                      }}
                      className="w-full mb-5 p-[16px] rounded-lg"
                    >
                      {watch("IncidentOption") === "Несоответствие" && (
                        <>
                          {!incLoading && (
                            <AddActionInComponent
                              typeModule={`${watch("IncidentOption")}_${watch(
                                "TypeIncident",
                              )}`.toLowerCase()}
                              idModule={Number(incidentID)}
                              CustomStyles={"bg-white p-5"}
                              mobileModalMode={isMobileIncCard}
                            />
                          )}
                          <div className="mb-[10px]"></div>
                          {(ID5WayAdd && (
                            <>
                              {console.log('card5WayTree: ', card5WayTree)}
                              {(card5WayTreeSafe.some((treeItem: any) => treeItem.root || treeItem.system)) &&
                                <FlexCol className="p-5 bg-[#F3F4F6] rounded-md mb-2">
                                  <span className="text-[#111928] text-sm mb-2"><strong>Корневая причина: </strong></span>
                                  <FlexRow className="justify-between">
                                    {card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).map((treeItem: any, idx: number) => (
                                      <>
                                        <span style={{ whiteSpace: "pre-wrap" }} className="text-sm">{treeItem.reason}</span>
                                        {treeItem.root && (
                                          <FlexRow
                                            title="Корневая причина"
                                            className="text-[#F2A900]"
                                          >
                                            <Medal />
                                          </FlexRow>
                                        )
                                        }
                                      </>
                                    ))}
                                  </FlexRow>
                                </FlexCol> ||
                                <FlexRow className="justify-center w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5 mb-2.5">
                                  Проанализируйте проблему и найдите хотя бы
                                  одну корневую причину
                                </FlexRow>
                              }
                              <a
                                className="btn-white w-full justify-center flex items-center py-3 px-6 rounded-md leading-[22px] disabled:bg-[#E5E7EB] disabled:text-[#374151] disabled:cursor-not-allowed shadow-custom mb-2"
                                href={`${siteUrl}/dashboard/3/5-whys?5WayCard=${ID5WayAdd}`}
                                target="_blanck"
                                onClick={(e) => {
                                  if (isMobileIncCard) {
                                    e.preventDefault();
                                    navigate(`/dashboard/3/5-whys?5WayCardMobile=${ID5WayAdd}`);
                                  }
                                }}
                              >
                                Открыть 5Почему
                              </a>
                              <FlexCol className="bg-[#F3F4F6] rounded-md p-5 mb-5">
                                <h3 className="text-lg text-[#637381] font-medium mb-2">Действия</h3>
                                <AddActionInComponent
                                  typeModule="5Почему"
                                  idModule={(ID5WayAdd && `${ID5WayAdd}`) || 0}
                                  CustomStyles={"bg-white p-5"}
                                  typeForm="5way_card_my_tasks"
                                  viewMode={true}
                                  mobileModalMode={isMobileIncCard}
                                />
                              </FlexCol>

                            </>
                          )) || (
                              <Button
                                icon={true}
                                submit={true}
                                typeIcon="add"
                                classBg="btn-white w-full justify-center"
                                shadow={true}
                                text="Создать 5Почему"
                                dataAttribute="addinc"
                                form={type}
                              />
                            )}
                        </>
                      )}
                      {watch("IncidentOption") === "Инцидент" && (
                        <>
                          {(ID5WayAdd && (
                            <>
                              <FlexCol className="mb-5 w-full gap-[10px]">
                                <h3 className="text-[#637381] font-medium">
                                  Диаграмма Ишикавы
                                </h3>
                                {(card5WayTreeSafe.some(
                                  (treeItem: any) => treeItem.root,
                                ) && (
                                    <>
                                      <FlexRow className="justify-center w-full rounded-md bg-[#DAF8E6] border border-[#22AD5C] p-2.5 mb-2.5">
                                        Корневая причина найдена
                                      </FlexRow>
                                      {card5WayTreeSafe
                                        .filter((treeItem: any) => treeItem.root)
                                        .map((treeItem: any, idx: number) => (
                                          <FlexRow className="justify-center w-full gap-[10px] rounded-md bg-[#F3F4F6] p-5">
                                            <FlexRow className="w-fit">
                                              <strong>{idx + 1}.</strong>
                                            </FlexRow>
                                            <FlexCol className="w-full gap-[10px]">
                                              {treeItem.reason}
                                              <span className="text-[#8646F4]">
                                                Категория Ишикавы:{" "}
                                                {treeItem.category}
                                              </span>
                                            </FlexCol>
                                            <FlexRow
                                              title={
                                                (treeItem.system &&
                                                  "Системная причина") ||
                                                "Техническая причина"
                                              }
                                              className="text-[#F2A900]"
                                            >
                                              <Medal />
                                            </FlexRow>
                                          </FlexRow>
                                        ))}
                                    </>
                                  )) || (
                                    <FlexRow className="justify-center w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5 mb-2.5">
                                      Проанализируйте проблему и найдите хотя бы
                                      одну корневую причину
                                    </FlexRow>
                                  )}
                              </FlexCol>
                              <div className="mb-[10px]"></div>
                              <a
                                className="btn-white w-full justify-center flex items-center py-3 px-6 rounded-md leading-[22px] disabled:bg-[#E5E7EB] disabled:text-[#374151] disabled:cursor-not-allowed shadow-custom"
                                href={`${siteUrl}/dashboard/3/deviation-reports?deviationCard=${ID5WayAdd}`}
                                target="_blanck"
                                onClick={(e) => {
                                  if (isMobileIncCard) {
                                    e.preventDefault();
                                    navigate(`/dashboard/3/deviation-reports?deviationCardMobile=${ID5WayAdd}`);
                                  }
                                }}
                              >
                                Открыть отчет об отклонении
                              </a>
                              <div className="mb-[10px]"></div>
                              <SDCA
                                card5WayID={ID5WayAdd}
                                viewMode={true}
                                type5Way={"DeviationReport"}
                                card5WayTree={card5WayTreeSafe}
                                isMobileView={isMobileIncCard}
                              />
                            </>
                          )) || (
                              <>
                                <p className="flex items-center justify-center mb-2">
                                  Создайте отчет, найдите корневые причины, добавьте
                                  действия, чтобы завершить расследование
                                </p>
                                <Button
                                  icon={true}
                                  submit={true}
                                  disabled={disabledDoubleSend}
                                  typeIcon="add"
                                  classBg="btn-white w-full justify-center"
                                  shadow={true}
                                  text="Создать отчет об отклонениях"
                                  dataAttribute="addinc"
                                  form={type}
                                />
                              </>
                            )}
                        </>
                      )}
                    </FlexCol>
                    <div className={`w-full mb-5`}>
                      <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                        {(watch("IncidentOption") === "Инцидент" && (
                          <span>Срок на закрытие инцидента</span>
                        )) || <span>Срок на закрытие несоответствия</span>}
                        <div className="flex flex-row justify-between">
                          <span className="text-[#BA0C2F]">*</span>
                        </div>
                      </label>
                      <div className="relative mt-2">
                        <div
                          className={`block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5  outline-none shadow-custom  cursor-not-allowed text-[#6B7280] bg-[#E5E7EB]`}
                        >
                          {moment(closedDateInc).format("DD.MM.YYYY")}
                        </div>
                        <svg
                          className="absolute right-[16px] top-[16px]"
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="14"
                          viewBox="0 0 16 14"
                          fill="none"
                        >
                          <path
                            d="M12.3155 1.65039V1.98372H12.6488H13.9988C14.6717 1.98372 15.2405 2.54135 15.2405 3.20039V11.9004C15.2405 12.5879 14.6682 13.1421 13.9988 13.1421H1.99883C1.31135 13.1421 0.757161 12.5697 0.757161 11.9004V3.20039C0.757161 2.51291 1.32948 1.95872 1.99883 1.95872H3.32383H3.65716V1.62539V1.10039C3.65716 0.959485 3.75792 0.858724 3.89883 0.858724C4.03042 0.858724 4.14049 0.975035 4.14049 1.10039V1.62539V1.95872H4.47383H11.4988H11.8322V1.62539V1.10039C11.8322 0.959485 11.9329 0.858724 12.0738 0.858724C12.2054 0.858724 12.3155 0.975035 12.3155 1.10039V1.65039ZM3.68216 2.77539V2.44206H3.34883H1.99883C1.7935 2.44206 1.59685 2.51565 1.45212 2.66642C1.30819 2.81634 1.24049 3.01632 1.24049 3.22539V4.87539V5.20872H1.57383H14.4488H14.7822V4.87539V3.22539C14.7822 2.7913 14.4329 2.44206 13.9988 2.44206H12.7238H12.3905V2.77539V3.27539C12.3905 3.4163 12.2897 3.51706 12.1488 3.51706C12.0172 3.51706 11.9072 3.40075 11.9072 3.27539V2.77539V2.44206H11.5738H4.49883H4.16549V2.77539V3.27539C4.16549 3.4163 4.06473 3.51706 3.92383 3.51706C3.79223 3.51706 3.68216 3.40075 3.68216 3.27539V2.77539ZM1.54883 5.64206H1.21549V5.97539V11.8754C1.21549 12.3095 1.56473 12.6587 1.99883 12.6587H13.9988C14.393 12.6587 14.7943 12.3658 14.7572 11.8859V5.97539V5.64206H14.4238H1.54883Z"
                            fill="#9CA3AF"
                            stroke="#9CA3AF"
                            strokeWidth="0.666667"
                          />
                          <path
                            d="M7.19844 6.67578H6.64844C6.49844 6.67578 6.39844 6.77578 6.39844 6.92578V7.47578C6.39844 7.62578 6.49844 7.72578 6.64844 7.72578H7.19844C7.34844 7.72578 7.44844 7.62578 7.44844 7.47578V6.92578C7.44844 6.77578 7.32344 6.67578 7.19844 6.67578Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M9.47383 6.67578H8.92383C8.77383 6.67578 8.67383 6.77578 8.67383 6.92578V7.47578C8.67383 7.62578 8.77383 7.72578 8.92383 7.72578H9.47383C9.62383 7.72578 9.72383 7.62578 9.72383 7.47578V6.92578C9.72383 6.77578 9.62383 6.67578 9.47383 6.67578Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M11.7492 6.67578H11.1992C11.0492 6.67578 10.9492 6.77578 10.9492 6.92578V7.47578C10.9492 7.62578 11.0492 7.72578 11.1992 7.72578H11.7492C11.8992 7.72578 11.9992 7.62578 11.9992 7.47578V6.92578C11.9992 6.77578 11.8992 6.67578 11.7492 6.67578Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M4.8 8.59961H4.25C4.1 8.59961 4 8.69961 4 8.84961V9.39961C4 9.54961 4.1 9.64961 4.25 9.64961H4.8C4.95 9.64961 5.05 9.54961 5.05 9.39961V8.84961C5.05 8.69961 4.925 8.59961 4.8 8.59961Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M7.19844 8.59961H6.64844C6.49844 8.59961 6.39844 8.69961 6.39844 8.84961V9.39961C6.39844 9.54961 6.49844 9.64961 6.64844 9.64961H7.19844C7.34844 9.64961 7.44844 9.54961 7.44844 9.39961V8.84961C7.44844 8.69961 7.32344 8.59961 7.19844 8.59961Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M9.47383 8.59961H8.92383C8.77383 8.59961 8.67383 8.69961 8.67383 8.84961V9.39961C8.67383 9.54961 8.77383 9.64961 8.92383 9.64961H9.47383C9.62383 9.64961 9.72383 9.54961 9.72383 9.39961V8.84961C9.72383 8.69961 9.62383 8.59961 9.47383 8.59961Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M11.7492 8.59961H11.1992C11.0492 8.59961 10.9492 8.69961 10.9492 8.84961V9.39961C10.9492 9.54961 11.0492 9.64961 11.1992 9.64961H11.7492C11.8992 9.64961 11.9992 9.54961 11.9992 9.39961V8.84961C11.9992 8.69961 11.8992 8.59961 11.7492 8.59961Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M4.8 10.5254H4.25C4.1 10.5254 4 10.6254 4 10.7754V11.3254C4 11.4754 4.1 11.5754 4.25 11.5754H4.8C4.95 11.5754 5.05 11.4754 5.05 11.3254V10.7754C5.05 10.6254 4.925 10.5254 4.8 10.5254Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M7.19844 10.5254H6.64844C6.49844 10.5254 6.39844 10.6254 6.39844 10.7754V11.3254C6.39844 11.4754 6.49844 11.5754 6.64844 11.5754H7.19844C7.34844 11.5754 7.44844 11.4754 7.44844 11.3254V10.7754C7.44844 10.6254 7.32344 10.5254 7.19844 10.5254Z"
                            fill="#9CA3AF"
                          />
                          <path
                            d="M9.47383 10.5254H8.92383C8.77383 10.5254 8.67383 10.6254 8.67383 10.7754V11.3254C8.67383 11.4754 8.77383 11.5754 8.92383 11.5754H9.47383C9.62383 11.5754 9.72383 11.4754 9.72383 11.3254V10.7754C9.72383 10.6254 9.62383 10.5254 9.47383 10.5254Z"
                            fill="#9CA3AF"
                          />
                        </svg>
                      </div>
                    </div>
                  </>
                )}
                {(editDataForm && (
                  <FlexRow className="justify-between w-full gap-5">
                    <Button
                      classBg="btn-white"
                      shadow={true}
                      text="Отменить изменения"
                      customFunction={resetDefaultValuesHandle}
                      paramsCustomFunction={defaultValues.ID}
                    />
                    <FlexRow className="gap-5">
                      {(watch("IncidentOption") === "Инцидент" &&
                        defaultValues.Status.id !== incStatus.finish &&
                        defaultValues.Status.id !== incStatus.cancel && (
                          <>
                            {(card5WayTreeSafe.some(
                              (treeItem: any) => treeItem.root,
                            ) && actionsEml?.length > 0 &&
                              (currentUser.isAdmin ||
                                (currentUser.isDirecor &&
                                  currentUser.isLocationEditorMyTasks &&
                                  currentUser.isLocationEditorMyTasks.length >
                                  0 &&
                                  currentUser.isLocationEditorMyTasks.find(
                                    (locationID: any) =>
                                      locationID === defaultValues.Location.id,
                                  )) ||
                                (currentUser.isDirecor &&
                                  currentUser.isLocationAdminMyTasks &&
                                  currentUser.isLocationAdminMyTasks.length > 0 &&
                                  currentUser.isLocationAdminMyTasks.find(
                                    (locationID: any) =>
                                      locationID === defaultValues.Location.id,
                                  ))) && (
                                <Button
                                  customFunction={setInvCompletedModal}
                                  paramsCustomFunction={true}
                                  classBg="btn-dark"
                                  text="Завершить расследование"
                                />
                              )) || (
                                <></>
                                // <Button
                                //   classBg="btn-dark"
                                //   text="Завершить расследование"
                                //   disabled={true}
                                // />
                              )}
                          </>
                        )) || <></>}
                      {(Object.keys(errors).length > 0 && (
                        <TooltipItem
                          position="top"
                          tooltipsText={
                            "Пожалуйста, заполните все обязательные поля"
                          }
                        >
                          <Button
                            classBg="btn-dark"
                            text="Сохранить изменения"
                            disabled={true}
                          />
                        </TooltipItem>
                      )) || (
                          <Button
                            classBg="btn-dark"
                            text="Сохранить изменения"
                            submit={true}
                            form={type}
                          />
                        )}
                    </FlexRow>
                  </FlexRow>
                )) || (
                    <FlexRow className="justify-end w-full gap-5">
                      {(watch("IncidentOption") === "Инцидент" &&
                        defaultValues.Status.id !== incStatus.finish &&
                        defaultValues.Status.id !== incStatus.cancel && (
                          <>
                            {(card5WayTreeSafe.some((treeItem: any) => treeItem.root) && actionsEml?.length > 0 &&
                              (currentUser.isAdmin ||
                                (currentUser.isDirecor &&
                                  currentUser.isLocationEditorMyTasks &&
                                  currentUser.isLocationEditorMyTasks.length > 0 &&
                                  currentUser.isLocationEditorMyTasks.find(
                                    (locationID: any) =>
                                      locationID === defaultValues.Location.id,
                                  )) ||
                                (currentUser.isDirecor &&
                                  currentUser.isLocationAdminMyTasks &&
                                  currentUser.isLocationAdminMyTasks.length > 0 &&
                                  currentUser.isLocationAdminMyTasks.find(
                                    (locationID: any) =>
                                      locationID === defaultValues.Location.id,
                                  ))) && (
                                <Button
                                  customFunction={setInvCompletedModal}
                                  paramsCustomFunction={true}
                                  classBg="btn-dark"
                                  text="Завершить расследование"
                                />
                              )) || (
                                <></>
                                // <Button
                                //   classBg="btn-dark"
                                //   text="Завершить расследование"
                                //   disabled={true}
                                // />
                              )}
                          </>
                        )) || <></>}
                    </FlexRow>
                  )}
              </>
            )}
            {type === "inc_security_card_my_tasks" && (
              <>
                <div className={`w-full mb-5`}>
                  <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                    <span>Срок на закрытие инцидента</span>
                    <div className="flex flex-row justify-between">
                      <span className="text-[#BA0C2F]">*</span>
                    </div>
                  </label>
                  <div className="relative mt-2">
                    <div
                      className={`block w-full text-base rounded-md border border-[#DFE4EA] py-3 px-5  outline-none shadow-custom   cursor-not-allowed text-[#6B7280] bg-[#E5E7EB]`}
                    >
                      {moment(closedDateInc).format("DD.MM.YYYY")}
                    </div>
                    <svg
                      className="absolute right-[16px] top-[16px]"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="14"
                      viewBox="0 0 16 14"
                      fill="none"
                    >
                      <path
                        d="M12.3155 1.65039V1.98372H12.6488H13.9988C14.6717 1.98372 15.2405 2.54135 15.2405 3.20039V11.9004C15.2405 12.5879 14.6682 13.1421 13.9988 13.1421H1.99883C1.31135 13.1421 0.757161 12.5697 0.757161 11.9004V3.20039C0.757161 2.51291 1.32948 1.95872 1.99883 1.95872H3.32383H3.65716V1.62539V1.10039C3.65716 0.959485 3.75792 0.858724 3.89883 0.858724C4.03042 0.858724 4.14049 0.975035 4.14049 1.10039V1.62539V1.95872H4.47383H11.4988H11.8322V1.62539V1.10039C11.8322 0.959485 11.9329 0.858724 12.0738 0.858724C12.2054 0.858724 12.3155 0.975035 12.3155 1.10039V1.65039ZM3.68216 2.77539V2.44206H3.34883H1.99883C1.7935 2.44206 1.59685 2.51565 1.45212 2.66642C1.30819 2.81634 1.24049 3.01632 1.24049 3.22539V4.87539V5.20872H1.57383H14.4488H14.7822V4.87539V3.22539C14.7822 2.7913 14.4329 2.44206 13.9988 2.44206H12.7238H12.3905V2.77539V3.27539C12.3905 3.4163 12.2897 3.51706 12.1488 3.51706C12.0172 3.51706 11.9072 3.40075 11.9072 3.27539V2.77539V2.44206H11.5738H4.49883H4.16549V2.77539V3.27539C4.16549 3.4163 4.06473 3.51706 3.92383 3.51706C3.79223 3.51706 3.68216 3.40075 3.68216 3.27539V2.77539ZM1.54883 5.64206H1.21549V5.97539V11.8754C1.21549 12.3095 1.56473 12.6587 1.99883 12.6587H13.9988C14.393 12.6587 14.7943 12.3658 14.7572 11.8859V5.97539V5.64206H14.4238H1.54883Z"
                        fill="#9CA3AF"
                        stroke="#9CA3AF"
                        strokeWidth="0.666667"
                      />
                      <path
                        d="M7.19844 6.67578H6.64844C6.49844 6.67578 6.39844 6.77578 6.39844 6.92578V7.47578C6.39844 7.62578 6.49844 7.72578 6.64844 7.72578H7.19844C7.34844 7.72578 7.44844 7.62578 7.44844 7.47578V6.92578C7.44844 6.77578 7.32344 6.67578 7.19844 6.67578Z"
                        fill="#9CA3AF"
                      />
                      <path
                        d="M9.47383 6.67578H8.92383C8.77383 6.67578 8.67383 6.77578 8.67383 6.92578V7.47578C8.67383 7.62578 8.77383 7.72578 8.92383 7.72578H9.47383C9.62383 7.72578 9.72383 7.62578 9.72383 7.47578V6.92578C9.72383 6.77578 9.62383 6.67578 9.47383 6.67578Z"
                        fill="#9CA3AF"
                      />
                      <path
                        d="M11.7492 6.67578H11.1992C11.0492 6.67578 10.9492 6.77578 10.9492 6.92578V7.47578C10.9492 7.62578 11.0492 7.72578 11.1992 7.72578H11.7492C11.8992 7.72578 11.9992 7.62578 11.9992 7.47578V6.92578C11.9992 6.77578 11.8992 6.67578 11.7492 6.67578Z"
                        fill="#9CA3AF"
                      />
                      <path
                        d="M4.8 8.59961H4.25C4.1 8.59961 4 8.69961 4 8.84961V9.39961C4 9.54961 4.1 9.64961 4.25 9.64961H4.8C4.95 9.64961 5.05 9.54961 5.05 9.39961V8.84961C5.05 8.69961 4.925 8.59961 4.8 8.59961Z"
                        fill="#9CA3AF"
                      />
                      <path
                        d="M7.19844 8.59961H6.64844C6.49844 8.59961 6.39844 8.69961 6.39844 8.84961V9.39961C6.39844 9.54961 6.49844 9.64961 6.64844 9.64961H7.19844C7.34844 9.64961 7.44844 9.54961 7.44844 9.39961V8.84961C7.44844 8.69961 7.32344 8.59961 7.19844 8.59961Z"
                        fill="#9CA3AF"
                      />
                      <path
                        d="M9.47383 8.59961H8.92383C8.77383 8.59961 8.67383 8.69961 8.67383 8.84961V9.39961C8.67383 9.54961 8.77383 9.64961 8.92383 9.64961H9.47383C9.62383 9.64961 9.72383 9.54961 9.72383 9.39961V8.84961C9.72383 8.69961 9.62383 8.59961 9.47383 8.59961Z"
                        fill="#9CA3AF"
                      />
                      <path
                        d="M11.7492 8.59961H11.1992C11.0492 8.59961 10.9492 8.69961 10.9492 8.84961V9.39961C10.9492 9.54961 11.0492 9.64961 11.1992 9.64961H11.7492C11.8992 9.64961 11.9992 9.54961 11.9992 9.39961V8.84961C11.9992 8.69961 11.8992 8.59961 11.7492 8.59961Z"
                        fill="#9CA3AF"
                      />
                      <path
                        d="M4.8 10.5254H4.25C4.1 10.5254 4 10.6254 4 10.7754V11.3254C4 11.4754 4.1 11.5754 4.25 11.5754H4.8C4.95 11.5754 5.05 11.4754 5.05 11.3254V10.7754C5.05 10.6254 4.925 10.5254 4.8 10.5254Z"
                        fill="#9CA3AF"
                      />
                      <path
                        d="M7.19844 10.5254H6.64844C6.49844 10.5254 6.39844 10.6254 6.39844 10.7754V11.3254C6.39844 11.4754 6.49844 11.5754 6.64844 11.5754H7.19844C7.34844 11.5754 7.44844 11.4754 7.44844 11.3254V10.7754C7.44844 10.6254 7.32344 10.5254 7.19844 10.5254Z"
                        fill="#9CA3AF"
                      />
                      <path
                        d="M9.47383 10.5254H8.92383C8.77383 10.5254 8.67383 10.6254 8.67383 10.7754V11.3254C8.67383 11.4754 8.77383 11.5754 8.92383 11.5754H9.47383C9.62383 11.5754 9.72383 11.4754 9.72383 11.3254V10.7754C9.72383 10.6254 9.62383 10.5254 9.47383 10.5254Z"
                        fill="#9CA3AF"
                      />
                    </svg>
                  </div>
                </div>
                <FlexCol className="w-full mb-5 p-[16px] bg-[#FEEBEB] rounded-lg">
                  <AddActionInComponent
                    typeModule={`инцидент_security`}
                    idModule={Number(incidentID)}
                    CustomStyles={"bg-white p-5"}
                  />
                </FlexCol>
                <Comments
                  history={false}
                  zIndex={zIndex + 50}
                  IDCard={Number(incidentID)}
                  listComments={myTaskIncCommentsListName}
                  listFilesComments={myTaskIncCommentsFilesListName}
                  strapiParams={MTIncCommentsFiles}
                  field="Incident"
                  customClass="mb-5 w-full"
                />
                {(editDataForm && (
                  <FlexRow className="justify-between w-full gap-5">
                    <Button
                      classBg="btn-white"
                      shadow={true}
                      text="Отменить изменения"
                      customFunction={resetDefaultValuesHandle}
                      paramsCustomFunction={defaultValues.ID}
                    />
                    <FlexRow className="gap-5">
                      {((currentUser.isAdmin || currentUser.isSecurityAdmin) &&
                        Object.keys(defaultValues).length > 0 &&
                        defaultValues.Status.id !== incStatus.finish &&
                        defaultValues.Status.id !== incStatus.cancel && (
                          <Button
                            customFunction={setInvCompletedModal}
                            paramsCustomFunction={true}
                            classBg="btn-dark"
                            text="Завершить расследование"
                          />
                        )) || <></>}
                      {(Object.keys(errors).length > 0 && (
                        <TooltipItem
                          position="top"
                          tooltipsText={
                            "Пожалуйста, заполните все обязательные поля"
                          }
                        >
                          <Button
                            classBg="btn-dark"
                            text="Сохранить изменения"
                            disabled={true}
                          />
                        </TooltipItem>
                      )) || (
                          <Button
                            classBg="btn-dark"
                            text="Сохранить изменения"
                            submit={true}
                            form={type}
                          />
                        )}
                    </FlexRow>
                  </FlexRow>
                )) || (
                    <FlexRow className="justify-end w-full gap-5">
                      {((currentUser.isAdmin || currentUser.isSecurityAdmin) &&
                        Object.keys(defaultValues).length > 0 &&
                        defaultValues.Status.id !== incStatus.finish &&
                        defaultValues.Status.id !== incStatus.cancel && (
                          <Button
                            customFunction={setInvCompletedModal}
                            paramsCustomFunction={true}
                            classBg="btn-dark"
                            text="Завершить расследование"
                          />
                        )) || <></>}
                    </FlexRow>
                  )}
              </>
            )}
          </>
        )}
    </>
  );
}

export default Form;
